/* eslint-disable @typescript-eslint/no-redeclare */
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: string; output: string; }
  DateTime: { input: any; output: any; }
  Int64: { input: any; output: any; }
  Map: { input: any; output: any; }
  Time: { input: string; output: string; }
  UUID: { input: any; output: any; }
};

export type __SHOULD_NOT_USE__ApiKey = {
  ageInDays: Scalars['Int']['output'];
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  generatedBy: Scalars['ID']['output'];
  generator: __SHOULD_NOT_USE__User;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maskedApiKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: __SHOULD_NOT_USE__Organization;
  ownerId: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__ApiKeyConnection = {
  edges: Array<__SHOULD_NOT_USE__ApiKeyEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__ApiKeyEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__ApiKey;
};

export const ApiKeyEnvironment = {
  Live: 'LIVE',
  Test: 'TEST'
} as const;

export type ApiKeyEnvironment = typeof ApiKeyEnvironment[keyof typeof ApiKeyEnvironment];
export type __SHOULD_NOT_USE__ApiKeyOrderByInput = {
  direction: SortOrder;
  field: ApiKeyOrderField;
};

export const ApiKeyOrderField = {
  CreatedAt: 'CREATED_AT',
  IsActive: 'IS_ACTIVE',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ApiKeyOrderField = typeof ApiKeyOrderField[keyof typeof ApiKeyOrderField];
/**
 * APIKeyWhereInput is used for filtering APIKey objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__ApiKeyWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__ApiKeyWhereInput>>;
  /** api_key field predicates */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKeyContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** generated_by_id field predicates */
  generatedByID?: InputMaybe<Scalars['ID']['input']>;
  generatedByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  generatedByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  generatedByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** api_logs edge predicates */
  hasAPILogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPILogsWith?: InputMaybe<Array<__SHOULD_NOT_USE__ApiLogWhereInput>>;
  /** generated_by edge predicates */
  hasGeneratedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeneratedByWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__ApiKeyWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__ApiKeyWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__ApiLog = {
  apiKey: Maybe<__SHOULD_NOT_USE__ApiKey>;
  apiKeyID: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  latencyMs: Scalars['Int64']['output'];
  method: Scalars['String']['output'];
  owner: __SHOULD_NOT_USE__Organization;
  ownerID: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  queryParams: Maybe<Scalars['String']['output']>;
  requestBody: Maybe<Scalars['String']['output']>;
  requestHeaders: Maybe<Scalars['Map']['output']>;
  requestID: Maybe<Scalars['String']['output']>;
  responseBody: Maybe<Scalars['String']['output']>;
  responseHeaders: Maybe<Scalars['Map']['output']>;
  statusCode: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  userAgent: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__ApiLogConnection = {
  edges: Array<__SHOULD_NOT_USE__ApiLogEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__ApiLogEdge = {
  cursor: Scalars['Cursor']['output'];
  node: __SHOULD_NOT_USE__ApiLog;
};

export type __SHOULD_NOT_USE__ApiLogOrderByInput = {
  direction: SortOrder;
  field: ApiLogOrderField;
};

export const ApiLogOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ApiLogOrderField = typeof ApiLogOrderField[keyof typeof ApiLogOrderField];
/**
 * APILogWhereInput is used for filtering APILog objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__ApiLogWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__ApiLogWhereInput>>;
  /** api_key_id field predicates */
  apiKeyID?: InputMaybe<Scalars['ID']['input']>;
  apiKeyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  apiKeyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  apiKeyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  apiKeyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** error_code field predicates */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorCodeContains?: InputMaybe<Scalars['String']['input']>;
  errorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorCodeGT?: InputMaybe<Scalars['String']['input']>;
  errorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  errorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorCodeLT?: InputMaybe<Scalars['String']['input']>;
  errorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  errorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  errorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** error_message field predicates */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessageContains?: InputMaybe<Scalars['String']['input']>;
  errorMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorMessageGT?: InputMaybe<Scalars['String']['input']>;
  errorMessageGTE?: InputMaybe<Scalars['String']['input']>;
  errorMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorMessageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessageLT?: InputMaybe<Scalars['String']['input']>;
  errorMessageLTE?: InputMaybe<Scalars['String']['input']>;
  errorMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  errorMessageNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key edge predicates */
  hasAPIKey?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIKeyWith?: InputMaybe<Array<__SHOULD_NOT_USE__ApiKeyWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ip_address field predicates */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressContains?: InputMaybe<Scalars['String']['input']>;
  ipAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressGT?: InputMaybe<Scalars['String']['input']>;
  ipAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ipAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddressLT?: InputMaybe<Scalars['String']['input']>;
  ipAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ipAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** latency_ms field predicates */
  latencyMs?: InputMaybe<Scalars['Int']['input']>;
  latencyMsGT?: InputMaybe<Scalars['Int']['input']>;
  latencyMsGTE?: InputMaybe<Scalars['Int']['input']>;
  latencyMsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  latencyMsLT?: InputMaybe<Scalars['Int']['input']>;
  latencyMsLTE?: InputMaybe<Scalars['Int']['input']>;
  latencyMsNEQ?: InputMaybe<Scalars['Int']['input']>;
  latencyMsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** method field predicates */
  method?: InputMaybe<Scalars['String']['input']>;
  methodContains?: InputMaybe<Scalars['String']['input']>;
  methodContainsFold?: InputMaybe<Scalars['String']['input']>;
  methodEqualFold?: InputMaybe<Scalars['String']['input']>;
  methodGT?: InputMaybe<Scalars['String']['input']>;
  methodGTE?: InputMaybe<Scalars['String']['input']>;
  methodHasPrefix?: InputMaybe<Scalars['String']['input']>;
  methodHasSuffix?: InputMaybe<Scalars['String']['input']>;
  methodIn?: InputMaybe<Array<Scalars['String']['input']>>;
  methodLT?: InputMaybe<Scalars['String']['input']>;
  methodLTE?: InputMaybe<Scalars['String']['input']>;
  methodNEQ?: InputMaybe<Scalars['String']['input']>;
  methodNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__ApiLogWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__ApiLogWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** path field predicates */
  path?: InputMaybe<Scalars['String']['input']>;
  pathContains?: InputMaybe<Scalars['String']['input']>;
  pathContainsFold?: InputMaybe<Scalars['String']['input']>;
  pathEqualFold?: InputMaybe<Scalars['String']['input']>;
  pathGT?: InputMaybe<Scalars['String']['input']>;
  pathGTE?: InputMaybe<Scalars['String']['input']>;
  pathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  pathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  pathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  pathLT?: InputMaybe<Scalars['String']['input']>;
  pathLTE?: InputMaybe<Scalars['String']['input']>;
  pathNEQ?: InputMaybe<Scalars['String']['input']>;
  pathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** query_params field predicates */
  queryParams?: InputMaybe<Scalars['String']['input']>;
  queryParamsContains?: InputMaybe<Scalars['String']['input']>;
  queryParamsContainsFold?: InputMaybe<Scalars['String']['input']>;
  queryParamsEqualFold?: InputMaybe<Scalars['String']['input']>;
  queryParamsGT?: InputMaybe<Scalars['String']['input']>;
  queryParamsGTE?: InputMaybe<Scalars['String']['input']>;
  queryParamsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  queryParamsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  queryParamsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  queryParamsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  queryParamsLT?: InputMaybe<Scalars['String']['input']>;
  queryParamsLTE?: InputMaybe<Scalars['String']['input']>;
  queryParamsNEQ?: InputMaybe<Scalars['String']['input']>;
  queryParamsNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  queryParamsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_body field predicates */
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestBodyContains?: InputMaybe<Scalars['String']['input']>;
  requestBodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestBodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestBodyGT?: InputMaybe<Scalars['String']['input']>;
  requestBodyGTE?: InputMaybe<Scalars['String']['input']>;
  requestBodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestBodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestBodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestBodyLT?: InputMaybe<Scalars['String']['input']>;
  requestBodyLTE?: InputMaybe<Scalars['String']['input']>;
  requestBodyNEQ?: InputMaybe<Scalars['String']['input']>;
  requestBodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_id field predicates */
  requestID?: InputMaybe<Scalars['String']['input']>;
  requestIDContains?: InputMaybe<Scalars['String']['input']>;
  requestIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestIDGT?: InputMaybe<Scalars['String']['input']>;
  requestIDGTE?: InputMaybe<Scalars['String']['input']>;
  requestIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestIDLT?: InputMaybe<Scalars['String']['input']>;
  requestIDLTE?: InputMaybe<Scalars['String']['input']>;
  requestIDNEQ?: InputMaybe<Scalars['String']['input']>;
  requestIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_body field predicates */
  responseBody?: InputMaybe<Scalars['String']['input']>;
  responseBodyContains?: InputMaybe<Scalars['String']['input']>;
  responseBodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseBodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseBodyGT?: InputMaybe<Scalars['String']['input']>;
  responseBodyGTE?: InputMaybe<Scalars['String']['input']>;
  responseBodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseBodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseBodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseBodyLT?: InputMaybe<Scalars['String']['input']>;
  responseBodyLTE?: InputMaybe<Scalars['String']['input']>;
  responseBodyNEQ?: InputMaybe<Scalars['String']['input']>;
  responseBodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status_code field predicates */
  statusCode?: InputMaybe<Scalars['Int']['input']>;
  statusCodeGT?: InputMaybe<Scalars['Int']['input']>;
  statusCodeGTE?: InputMaybe<Scalars['Int']['input']>;
  statusCodeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  statusCodeLT?: InputMaybe<Scalars['Int']['input']>;
  statusCodeLTE?: InputMaybe<Scalars['Int']['input']>;
  statusCodeNEQ?: InputMaybe<Scalars['Int']['input']>;
  statusCodeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgentContains?: InputMaybe<Scalars['String']['input']>;
  userAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  userAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  userAgentGT?: InputMaybe<Scalars['String']['input']>;
  userAgentGTE?: InputMaybe<Scalars['String']['input']>;
  userAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['String']['input']>;
  userAgentLTE?: InputMaybe<Scalars['String']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__ApiPayment = {
  accessKey: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  apiKey: Maybe<Scalars['String']['output']>;
  cancelUrl: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  fees: Maybe<__SHOULD_NOT_USE__Fees>;
  id: Scalars['ID']['output'];
  merchantProcessingFee: Scalars['Float']['output'];
  metadata: Scalars['Map']['output'];
  orderId: Scalars['String']['output'];
  owner: __SHOULD_NOT_USE__Organization;
  ownerId: Scalars['ID']['output'];
  paymentOptions: Array<PaymentType>;
  refundPolicyTerms: WebPaymentsRefundPolicyTerms;
  responseUrl: Scalars['String']['output'];
  status: ApiPaymentsStatus;
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__ApiPaymentConnection = {
  edges: Array<__SHOULD_NOT_USE__ApiPaymentEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__ApiPaymentEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__ApiPayment;
};

export type __SHOULD_NOT_USE__ApiPaymentOrderByInput = {
  direction: SortOrder;
  field: ApiPaymentOrderField;
};

export const ApiPaymentOrderField = {
  Amount: 'AMOUNT',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ApiPaymentOrderField = typeof ApiPaymentOrderField[keyof typeof ApiPaymentOrderField];
export type __SHOULD_NOT_USE__ApiPaymentStatistics = {
  averagePaymentAmount: Scalars['Float']['output'];
  cancelledPayments: Scalars['Int']['output'];
  failedPayments: Scalars['Int']['output'];
  pendingPayments: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
  successfulPayments: Scalars['Int']['output'];
  totalPayments: Scalars['Int']['output'];
  totalProcessingFees: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
};

/**
 * APIPaymentWhereInput is used for filtering APIPayment objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__ApiPaymentWhereInput = {
  /** access_key field predicates */
  accessKey?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  accessKeyLT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyLTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNEQ?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__ApiPaymentWhereInput>>;
  /** api_key field predicates */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKeyContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cancel_url field predicates */
  cancelURL?: InputMaybe<Scalars['String']['input']>;
  cancelURLContains?: InputMaybe<Scalars['String']['input']>;
  cancelURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  cancelURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  cancelURLGT?: InputMaybe<Scalars['String']['input']>;
  cancelURLGTE?: InputMaybe<Scalars['String']['input']>;
  cancelURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cancelURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cancelURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancelURLLT?: InputMaybe<Scalars['String']['input']>;
  cancelURLLTE?: InputMaybe<Scalars['String']['input']>;
  cancelURLNEQ?: InputMaybe<Scalars['String']['input']>;
  cancelURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyContains?: InputMaybe<Scalars['String']['input']>;
  currencyContainsFold?: InputMaybe<Scalars['String']['input']>;
  currencyEqualFold?: InputMaybe<Scalars['String']['input']>;
  currencyGT?: InputMaybe<Scalars['String']['input']>;
  currencyGTE?: InputMaybe<Scalars['String']['input']>;
  currencyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currencyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currencyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyLT?: InputMaybe<Scalars['String']['input']>;
  currencyLTE?: InputMaybe<Scalars['String']['input']>;
  currencyNEQ?: InputMaybe<Scalars['String']['input']>;
  currencyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__ApiPaymentWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__ApiPaymentWhereInput>>;
  /** order_id field predicates */
  orderID?: InputMaybe<Scalars['String']['input']>;
  orderIDContains?: InputMaybe<Scalars['String']['input']>;
  orderIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  orderIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  orderIDGT?: InputMaybe<Scalars['String']['input']>;
  orderIDGTE?: InputMaybe<Scalars['String']['input']>;
  orderIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  orderIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  orderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  orderIDLT?: InputMaybe<Scalars['String']['input']>;
  orderIDLTE?: InputMaybe<Scalars['String']['input']>;
  orderIDNEQ?: InputMaybe<Scalars['String']['input']>;
  orderIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** paid_at field predicates */
  paidAt?: InputMaybe<Scalars['Time']['input']>;
  paidAtGT?: InputMaybe<Scalars['Time']['input']>;
  paidAtGTE?: InputMaybe<Scalars['Time']['input']>;
  paidAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  paidAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paidAtLT?: InputMaybe<Scalars['Time']['input']>;
  paidAtLTE?: InputMaybe<Scalars['Time']['input']>;
  paidAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  paidAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  paidAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<WebPaymentsRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<WebPaymentsRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<WebPaymentsRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<WebPaymentsRefundPolicyTerms>>;
  /** response_url field predicates */
  responseURL?: InputMaybe<Scalars['String']['input']>;
  responseURLContains?: InputMaybe<Scalars['String']['input']>;
  responseURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseURLGT?: InputMaybe<Scalars['String']['input']>;
  responseURLGTE?: InputMaybe<Scalars['String']['input']>;
  responseURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseURLLT?: InputMaybe<Scalars['String']['input']>;
  responseURLLTE?: InputMaybe<Scalars['String']['input']>;
  responseURLNEQ?: InputMaybe<Scalars['String']['input']>;
  responseURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<ApiPaymentsStatus>;
  statusIn?: InputMaybe<Array<ApiPaymentsStatus>>;
  statusNEQ?: InputMaybe<ApiPaymentsStatus>;
  statusNotIn?: InputMaybe<Array<ApiPaymentsStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__AcceptAllRequiredUserPoliciesPayload = {
  acceptances: Maybe<Array<__SHOULD_NOT_USE__UserPolicyAcceptance>>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__AcceptDisputeInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__AcceptDisputePayload = {
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__AcceptInvitationInput = {
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__AcceptInvitationPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__AcceptPolicyInput = {
  acceptanceContext: AcceptanceContext;
  bankId?: InputMaybe<Scalars['ID']['input']>;
  policyId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__AcceptPolicyPayload = {
  acceptance: Maybe<__SHOULD_NOT_USE__MerchantPolicyAcceptance>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__AcceptUserPolicyInput = {
  policyId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__AcceptUserPolicyPayload = {
  acceptance: Maybe<__SHOULD_NOT_USE__UserPolicyAcceptance>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export const AcceptanceContext = {
  BankAccountAdded: 'BANK_ACCOUNT_ADDED',
  Onboarding: 'ONBOARDING',
  PolicyUpdate: 'POLICY_UPDATE'
} as const;

export type AcceptanceContext = typeof AcceptanceContext[keyof typeof AcceptanceContext];
export type __SHOULD_NOT_USE__ActivateApiKeyPayload = {
  apiKey: Maybe<__SHOULD_NOT_USE__ApiKey>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__ActivateQuickPayPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  quickPay: Maybe<__SHOULD_NOT_USE__QuickPay>;
};

export type __SHOULD_NOT_USE__AddCardTypeInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  paymentProviderId: Scalars['ID']['input'];
  priority: Scalars['Int']['input'];
  type: CardType;
};

export type __SHOULD_NOT_USE__AddCardTypeToProviderPayload = {
  cardType: __SHOULD_NOT_USE__PaymentProviderCardType;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__AddLineItemInput = {
  description: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
};

export type __SHOULD_NOT_USE__AddLineItemPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  lineItem: Maybe<__SHOULD_NOT_USE__InvoiceLineItem>;
};

export type __SHOULD_NOT_USE__AddMerchantBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bankId: Scalars['ID']['input'];
  setAsPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  type: BankAccountType;
};

export type __SHOULD_NOT_USE__AddMerchantBankAccountPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  notificationSent: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__AddPaymentTypeInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  enabled: Scalars['Boolean']['input'];
  gatewayFeeType: FeeType;
  gatewayFees: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  paymentProviderId: Scalars['ID']['input'];
  platformFeeType: FeeType;
  platformFees: Scalars['Float']['input'];
  supportedCurrencies: Array<Scalars['String']['input']>;
  type: PaymentType;
};

export type __SHOULD_NOT_USE__AddPaymentTypeToProviderPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  paymentType: __SHOULD_NOT_USE__PaymentProviderPaymentType;
};

export type __SHOULD_NOT_USE__AddPayoutsToTransferInput = {
  payoutIds: Array<Scalars['ID']['input']>;
  transferId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__AddPayoutsToTransferPayload = {
  addedPayouts: Maybe<Array<__SHOULD_NOT_USE__Payout>>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  failedPayouts: Maybe<Array<__SHOULD_NOT_USE__PayoutOperationError>>;
  transfer: Maybe<__SHOULD_NOT_USE__Transfer>;
};

export type __SHOULD_NOT_USE__AddServiceAccountWebhookSubscriptionsInput = {
  eventTypeIds: Array<Scalars['ID']['input']>;
  webhookId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__AddServiceAccountWebhookSubscriptionsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  subscriptions: Maybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookSubscription>>;
};

export type __SHOULD_NOT_USE__AddWebhookSubscriptionsInput = {
  eventTypeIds: Array<Scalars['ID']['input']>;
  webhookId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__AddWebhookSubscriptionsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  subscriptions: Maybe<Array<__SHOULD_NOT_USE__MerchantWebhookSubscription>>;
};

export const AnalyticsPeriod = {
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  Quarterly: 'QUARTERLY',
  Weekly: 'WEEKLY',
  Yearly: 'YEARLY'
} as const;

export type AnalyticsPeriod = typeof AnalyticsPeriod[keyof typeof AnalyticsPeriod];
export type __SHOULD_NOT_USE__ApiPaymentSuccessResponseUrlPayload = {
  successResponseUrl: Scalars['String']['output'];
};

export const ApiPaymentsStatus = {
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  Paid: 'PAID',
  PendingAction: 'PENDING_ACTION',
  Processing: 'PROCESSING',
  Unpaid: 'UNPAID'
} as const;

export type ApiPaymentsStatus = typeof ApiPaymentsStatus[keyof typeof ApiPaymentsStatus];
export type __SHOULD_NOT_USE__ApproveBankAccountPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  statusChange: Maybe<__SHOULD_NOT_USE__BankAccountStatusChangeRecord>;
  verificationInitiated: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__ApproveRefundInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
  overrideCancellationPolicy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__ApproveRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export type __SHOULD_NOT_USE__ArchiveQuickPayPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  quickPay: Maybe<__SHOULD_NOT_USE__QuickPay>;
};

export type __SHOULD_NOT_USE__AssignRoleInput = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__AssignRolePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  userRole: Maybe<__SHOULD_NOT_USE__UserRole>;
};

export type __SHOULD_NOT_USE__AuthContext = {
  serviceAccount: Maybe<__SHOULD_NOT_USE__ServiceAccount>;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__AuthPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__AuthenticationError>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__AuthenticationError = {
  code: ErrorCode;
  field: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export const BankAccountStatus = {
  Approved: 'APPROVED',
  Closed: 'CLOSED',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Suspended: 'SUSPENDED'
} as const;

export type BankAccountStatus = typeof BankAccountStatus[keyof typeof BankAccountStatus];
export type __SHOULD_NOT_USE__BankAccountStatusChangeRecord = {
  changedAt: Scalars['Time']['output'];
  changedBy: __SHOULD_NOT_USE__User;
  fromStatus: BankAccountStatus;
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
  toStatus: BankAccountStatus;
};

export const BankAccountType = {
  Btn: 'BTN',
  Fc: 'FC'
} as const;

export type BankAccountType = typeof BankAccountType[keyof typeof BankAccountType];
export type __SHOULD_NOT_USE__BankApproveRefundInput = {
  id: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__BankApproveRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export type __SHOULD_NOT_USE__BankDenyRefundInput = {
  bankDeclineReason: Scalars['Map']['input'];
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type __SHOULD_NOT_USE__BankDenyRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__BatchProcessPayoutsInput = {
  batchNotes?: InputMaybe<Scalars['String']['input']>;
  payoutIds: Array<Scalars['ID']['input']>;
};

export type __SHOULD_NOT_USE__BatchProcessPayoutsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  failedPayouts: Maybe<Array<__SHOULD_NOT_USE__PayoutBatchError>>;
  failureCount: Maybe<Scalars['Int']['output']>;
  successCount: Maybe<Scalars['Int']['output']>;
  successfulPayouts: Maybe<Array<__SHOULD_NOT_USE__Payout>>;
};

export type __SHOULD_NOT_USE__BillingAddress = {
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  customer: __SHOULD_NOT_USE__Customer;
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  invoiceId: Maybe<Scalars['ID']['output']>;
  isDefault: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__BillingAddressConnection = {
  edges: Array<__SHOULD_NOT_USE__BillingAddressEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__BillingAddressEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__BillingAddress;
};

export type __SHOULD_NOT_USE__BillingAddressOrderByInput = {
  direction: SortOrder;
  field: BillingAddressOrderField;
};

export const BillingAddressOrderField = {
  City: 'CITY',
  Country: 'COUNTRY',
  CreatedAt: 'CREATED_AT',
  IsDefault: 'IS_DEFAULT',
  Label: 'LABEL',
  PostalCode: 'POSTAL_CODE',
  State: 'STATE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type BillingAddressOrderField = typeof BillingAddressOrderField[keyof typeof BillingAddressOrderField];
/**
 * BillingAddressWhereInput is used for filtering BillingAddress objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__BillingAddressWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__BillingAddressWhereInput>>;
  /** city field predicates */
  city?: InputMaybe<Scalars['String']['input']>;
  cityContains?: InputMaybe<Scalars['String']['input']>;
  cityContainsFold?: InputMaybe<Scalars['String']['input']>;
  cityEqualFold?: InputMaybe<Scalars['String']['input']>;
  cityGT?: InputMaybe<Scalars['String']['input']>;
  cityGTE?: InputMaybe<Scalars['String']['input']>;
  cityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityLT?: InputMaybe<Scalars['String']['input']>;
  cityLTE?: InputMaybe<Scalars['String']['input']>;
  cityNEQ?: InputMaybe<Scalars['String']['input']>;
  cityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** country field predicates */
  country?: InputMaybe<Scalars['String']['input']>;
  countryContains?: InputMaybe<Scalars['String']['input']>;
  countryContainsFold?: InputMaybe<Scalars['String']['input']>;
  countryEqualFold?: InputMaybe<Scalars['String']['input']>;
  countryGT?: InputMaybe<Scalars['String']['input']>;
  countryGTE?: InputMaybe<Scalars['String']['input']>;
  countryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  countryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryLT?: InputMaybe<Scalars['String']['input']>;
  countryLTE?: InputMaybe<Scalars['String']['input']>;
  countryNEQ?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** customer_id field predicates */
  customerID?: InputMaybe<Scalars['ID']['input']>;
  customerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  customerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** customer edge predicates */
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomerWith?: InputMaybe<Array<__SHOULD_NOT_USE__CustomerWhereInput>>;
  /** invoice edge predicates */
  hasInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoiceWith?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** invoice_id field predicates */
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** line1 field predicates */
  line1?: InputMaybe<Scalars['String']['input']>;
  line1Contains?: InputMaybe<Scalars['String']['input']>;
  line1ContainsFold?: InputMaybe<Scalars['String']['input']>;
  line1EqualFold?: InputMaybe<Scalars['String']['input']>;
  line1GT?: InputMaybe<Scalars['String']['input']>;
  line1GTE?: InputMaybe<Scalars['String']['input']>;
  line1HasPrefix?: InputMaybe<Scalars['String']['input']>;
  line1HasSuffix?: InputMaybe<Scalars['String']['input']>;
  line1In?: InputMaybe<Array<Scalars['String']['input']>>;
  line1LT?: InputMaybe<Scalars['String']['input']>;
  line1LTE?: InputMaybe<Scalars['String']['input']>;
  line1NEQ?: InputMaybe<Scalars['String']['input']>;
  line1NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** line2 field predicates */
  line2?: InputMaybe<Scalars['String']['input']>;
  line2Contains?: InputMaybe<Scalars['String']['input']>;
  line2ContainsFold?: InputMaybe<Scalars['String']['input']>;
  line2EqualFold?: InputMaybe<Scalars['String']['input']>;
  line2GT?: InputMaybe<Scalars['String']['input']>;
  line2GTE?: InputMaybe<Scalars['String']['input']>;
  line2HasPrefix?: InputMaybe<Scalars['String']['input']>;
  line2HasSuffix?: InputMaybe<Scalars['String']['input']>;
  line2In?: InputMaybe<Array<Scalars['String']['input']>>;
  line2IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  line2LT?: InputMaybe<Scalars['String']['input']>;
  line2LTE?: InputMaybe<Scalars['String']['input']>;
  line2NEQ?: InputMaybe<Scalars['String']['input']>;
  line2NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  line2NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__BillingAddressWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__BillingAddressWhereInput>>;
  /** postal_code field predicates */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeContains?: InputMaybe<Scalars['String']['input']>;
  postalCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  postalCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  postalCodeGT?: InputMaybe<Scalars['String']['input']>;
  postalCodeGTE?: InputMaybe<Scalars['String']['input']>;
  postalCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  postalCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  postalCodeLT?: InputMaybe<Scalars['String']['input']>;
  postalCodeLTE?: InputMaybe<Scalars['String']['input']>;
  postalCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  postalCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state field predicates */
  state?: InputMaybe<Scalars['String']['input']>;
  stateContains?: InputMaybe<Scalars['String']['input']>;
  stateContainsFold?: InputMaybe<Scalars['String']['input']>;
  stateEqualFold?: InputMaybe<Scalars['String']['input']>;
  stateGT?: InputMaybe<Scalars['String']['input']>;
  stateGTE?: InputMaybe<Scalars['String']['input']>;
  stateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  stateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateLT?: InputMaybe<Scalars['String']['input']>;
  stateLTE?: InputMaybe<Scalars['String']['input']>;
  stateNEQ?: InputMaybe<Scalars['String']['input']>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__CancelApiPaymentPayload = {
  cancelResponseUrl: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__CancelPayoutInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__CancelPayoutPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  payout: Maybe<__SHOULD_NOT_USE__Payout>;
};

export type __SHOULD_NOT_USE__CancelRecurringPaymentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  recurringPayment: Maybe<__SHOULD_NOT_USE__RecurringPayment>;
};

export type __SHOULD_NOT_USE__CancelRecurringPaymentSetupInput = {
  checkoutSessionID: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__CancelRecurringPaymentSetupPayload = {
  cancelResponseUrl: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__CancelRefundInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
  reason: Scalars['Map']['input'];
};

export type __SHOULD_NOT_USE__CancelRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export const CardType = {
  Amex: 'AMEX',
  DinersClub: 'DINERS_CLUB',
  Discover: 'DISCOVER',
  Jcb: 'JCB',
  Maestro: 'MAESTRO',
  Mastercard: 'MASTERCARD',
  Other: 'OTHER',
  UnionPay: 'UNION_PAY',
  Visa: 'VISA'
} as const;

export type CardType = typeof CardType[keyof typeof CardType];
export type __SHOULD_NOT_USE__CardTypeFilter = {
  type?: InputMaybe<CardType>;
};

export type __SHOULD_NOT_USE__ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__ChangePasswordPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__CloseBankAccountPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  newPrimaryAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  statusChange: Maybe<__SHOULD_NOT_USE__BankAccountStatusChangeRecord>;
};

export type __SHOULD_NOT_USE__CompletePayoutInput = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type __SHOULD_NOT_USE__CompletePayoutPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  payouts: Maybe<Array<Maybe<__SHOULD_NOT_USE__Payout>>>;
};

export type __SHOULD_NOT_USE__CompleteTransferInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type __SHOULD_NOT_USE__CompleteTransferPayload = {
  completedPayouts: Maybe<Array<__SHOULD_NOT_USE__Payout>>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  transfer: Maybe<__SHOULD_NOT_USE__Transfer>;
};

export type __SHOULD_NOT_USE__ComplianceStatus = {
  acceptedPolicies: Array<__SHOULD_NOT_USE__MerchantPolicyAcceptance>;
  gracePeriodEnd: Maybe<Scalars['Time']['output']>;
  isCompliant: Scalars['Boolean']['output'];
  pendingPolicies: Array<__SHOULD_NOT_USE__PolicyDocument>;
};

export type __SHOULD_NOT_USE__CreateApiPaymentIntentInput = {
  apiPaymentAccessKey: Scalars['String']['input'];
  cardType?: InputMaybe<CardType>;
  /** Client channel originating the payment (defaults to WEB) */
  channel?: InputMaybe<PaymentChannel>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile user ref for saved-card checkout (service-account callers only) */
  customerRef?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey: Scalars['String']['input'];
  paymentType: PaymentType;
  /** Vault the collected card for reuse (service-account callers only) */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__CreateBillingAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__CreateBillingAddressPayload = {
  billingAddress: Maybe<__SHOULD_NOT_USE__BillingAddress>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__CreateDisputeInput = {
  disputeAmount: Scalars['Float']['input'];
  disputedAt: Scalars['Time']['input'];
  gatewayDisputeId?: InputMaybe<Scalars['String']['input']>;
  gatewayName?: InputMaybe<Scalars['String']['input']>;
  merchantResponseDueDate: Scalars['Time']['input'];
  paymentId: Scalars['ID']['input'];
  reason: DisputeReason;
};

export type __SHOULD_NOT_USE__CreateDisputePayload = {
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__CreateInvoiceInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createBillingAddressInput?: InputMaybe<__SHOULD_NOT_USE__CreateBillingAddressInput>;
  customFields?: InputMaybe<Scalars['Map']['input']>;
  dueDate?: InputMaybe<Scalars['Time']['input']>;
  lineItems: Array<__SHOULD_NOT_USE__InvoiceLineItemInput>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  paymentOptions: Array<PaymentType>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  refundPolicyTerms: InvoiceRefundPolicyTerms;
};

export type __SHOULD_NOT_USE__CreateInvoicePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  invoice: Maybe<__SHOULD_NOT_USE__Invoice>;
};

export type __SHOULD_NOT_USE__CreateMediaInput = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<MediaEntityType>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__CreateMerchantWebhookInput = {
  Name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__CreateMerchantWebhookPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantWebhook: Maybe<__SHOULD_NOT_USE__MerchantWebhook>;
};

export type __SHOULD_NOT_USE__CreateMobileCardSetupIntentInput = {
  customerEmail: Scalars['String']['input'];
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile backend's user UUID — asserted by the service caller */
  customerRef: Scalars['ID']['input'];
  /** Redirect landing for the SDK; defaults to the platform return page */
  returnURL?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__CreateMobileCardSetupIntentPayload = {
  clientSecret: Scalars['String']['output'];
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  providerCustomerId: Scalars['String']['output'];
  providerSlug: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__CreateOrganizationInput = {
  address: Scalars['Map']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  email: Scalars['String']['input'];
  industry?: InputMaybe<OrganizationIndustry>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  mccCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  otherIndustry?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  type: OrganizationType;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__CreateOrganizationPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
};

export type __SHOULD_NOT_USE__CreateOrganizationPaymentTypeInput = {
  enabled: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  paymentContext: OrganizationPaymentTypeContext;
  paymentProviderPaymentTypeId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__CreateOrganizationPaymentTypePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organizationPaymentType: Maybe<__SHOULD_NOT_USE__OrganizationPaymentType>;
};

export type __SHOULD_NOT_USE__CreatePaymentIntentInput = {
  cardType?: InputMaybe<CardType>;
  /** Client channel originating the payment (defaults to WEB) */
  channel?: InputMaybe<PaymentChannel>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile user ref for saved-card checkout (service-account callers only) */
  customerRef?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey: Scalars['String']['input'];
  invoiceAccessKey: Scalars['String']['input'];
  paymentType: PaymentType;
  /** Vault the collected card for reuse (service-account callers only) */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__CreatePaymentIntentPayload = {
  amount: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Currency;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  feeBreakdown: Maybe<__SHOULD_NOT_USE__PaymentFeeBreakdown>;
  /** The merchant organization receiving this payment (set for QuickPay intents) */
  merchantId: Maybe<Scalars['ID']['output']>;
  /** The pre-created payment record's ID (set for QuickPay intents) — callers use it to link their own records */
  paymentId: Maybe<Scalars['ID']['output']>;
  paymentIntentId: Scalars['String']['output'];
  /** Slug of the provider that will process the payment (e.g. stripe, hyperswitch) - tells the client which SDK to load */
  providerSlug: Maybe<Scalars['String']['output']>;
  publishableKey: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__CreatePaymentMethodUpdateSessionInput = {
  /** Recurring payment ID */
  recurringPaymentId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__CreatePaymentMethodUpdateSessionPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  /** When the session expires */
  expiresAt: Scalars['Time']['output'];
  /** URL the customer should visit to update their payment method */
  updateURL: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__CreatePaymentProviderInput = {
  configProfile: Scalars['String']['input'];
  description?: InputMaybe<Scalars['Map']['input']>;
  environment: PaymentEnvironment;
  logoMediaId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  status: ProviderStatus;
  /** Defaults to [WEB] when omitted */
  supportedChannels?: InputMaybe<Array<PaymentChannel>>;
  supportedCurrencies: Array<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__CreatePaymentProviderPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  paymentProvider: __SHOULD_NOT_USE__PaymentProvider;
};

export type __SHOULD_NOT_USE__CreatePolicyDocumentInput = {
  content: Scalars['Map']['input'];
  effectiveDate: Scalars['Time']['input'];
  policyType: PolicyType;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__CreatePolicyDocumentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  policy: Maybe<__SHOULD_NOT_USE__PolicyDocument>;
};

export type __SHOULD_NOT_USE__CreatePolicyDocumentVersionInput = {
  content: Scalars['Map']['input'];
  effectiveDate: Scalars['Time']['input'];
  policyId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__CreatePolicyDocumentVersionPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  oldPolicy: Maybe<__SHOULD_NOT_USE__PolicyDocument>;
  policy: Maybe<__SHOULD_NOT_USE__PolicyDocument>;
};

export type __SHOULD_NOT_USE__CreatePolicyTemplateInput = {
  content: Scalars['Map']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  policyType: PolicyType;
};

export type __SHOULD_NOT_USE__CreatePolicyTemplatePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  template: Maybe<__SHOULD_NOT_USE__PolicyTemplate>;
};

export type __SHOULD_NOT_USE__CreateQuickPayInput = {
  amountType: QuickPayAmountType;
  currency: Currency;
  customFields?: InputMaybe<Scalars['Map']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Optional sale basket for dynamic QRs, stored verbatim ([{description, unitPrice, quantity}]); client validates */
  lineItems?: InputMaybe<Array<Scalars['Map']['input']>>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentOptions?: InputMaybe<Array<PaymentType>>;
  presetAmounts?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundPolicyTerms?: InputMaybe<QuickPayRefundPolicyTerms>;
  title: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__CreateQuickPayPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  quickPay: Maybe<__SHOULD_NOT_USE__QuickPay>;
};

export type __SHOULD_NOT_USE__CreateQuickPayPaymentIntentInput = {
  amount: Scalars['Float']['input'];
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<CardType>;
  /** Client channel originating the payment (defaults to WEB) */
  channel?: InputMaybe<PaymentChannel>;
  customerEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Mobile user ref for saved-card checkout (service-account callers only) */
  customerRef?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey: Scalars['String']['input'];
  /** Optional sale basket, stored verbatim (convention: [{description, unitPrice, quantity}]); client validates */
  lineItems?: InputMaybe<Array<Scalars['Map']['input']>>;
  paymentType: PaymentType;
  quickPayAccessKey: Scalars['String']['input'];
  /** Vault the collected card for reuse (service-account callers only) */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__CreateRecurringPaymentInput = {
  amount: Scalars['Int64']['input'];
  chargeImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  currency: Currency;
  customerEmail: Scalars['String']['input'];
  customerExternalID?: InputMaybe<Scalars['String']['input']>;
  customerMetadata?: InputMaybe<Scalars['Map']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['Time']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  interval: RecurringInterval;
  intervalCount: Scalars['Int']['input'];
  maxCharges?: InputMaybe<Scalars['Int']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  merchantProcessingFee: Scalars['Float']['input'];
  metadata?: InputMaybe<Scalars['Map']['input']>;
  paymentOptions?: InputMaybe<Array<PaymentType>>;
  refundPolicyTerms?: InputMaybe<RecurringPaymentRefundPolicyTerms>;
  startsAt?: InputMaybe<Scalars['Time']['input']>;
};

export type __SHOULD_NOT_USE__CreateRecurringPaymentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  recurringPayment: Maybe<__SHOULD_NOT_USE__RecurringPayment>;
};

export type __SHOULD_NOT_USE__CreateRefundInput = {
  amount: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
  paymentId: Scalars['ID']['input'];
  pointOfContact?: InputMaybe<RefundPointOfContact>;
  reason: Scalars['Map']['input'];
  subReason?: InputMaybe<Scalars['Map']['input']>;
};

export type __SHOULD_NOT_USE__CreateRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export type __SHOULD_NOT_USE__CreateRoleInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  permissionIds: Array<Scalars['ID']['input']>;
};

export type __SHOULD_NOT_USE__CreateRolePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  role: Maybe<__SHOULD_NOT_USE__Role>;
};

export type __SHOULD_NOT_USE__CreateServiceAccountWebhookInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceAccountId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__CreateServiceAccountWebhookPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  /** The signing secret. Returned only here — store it now, it cannot be read again. */
  secret: Maybe<Scalars['String']['output']>;
  serviceAccountWebhook: Maybe<__SHOULD_NOT_USE__ServiceAccountWebhook>;
};

export type __SHOULD_NOT_USE__CreateSetupIntentInput = {
  checkoutSessionID: Scalars['String']['input'];
  paymentProviderId: Scalars['ID']['input'];
  paymentType: PaymentType;
  returnURL?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__CreateSetupIntentPayload = {
  clientSecret: Scalars['String']['output'];
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  publishableKey: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__CreateTransferInput = {
  currency: Currency;
  notes?: InputMaybe<Scalars['Map']['input']>;
  payoutIds: Array<Scalars['ID']['input']>;
  transferredToBankId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__CreateTransferPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  transfer: Maybe<__SHOULD_NOT_USE__Transfer>;
};

export type __SHOULD_NOT_USE__CreateUpdateSetupIntentInput = {
  paymentProviderId: Scalars['ID']['input'];
  paymentType: PaymentType;
  /** The update session ID (from the URL) */
  updateSessionID: Scalars['String']['input'];
};

export const Currency = {
  Aud: 'AUD',
  Btn: 'BTN',
  Cad: 'CAD',
  Eur: 'EUR',
  Gbp: 'GBP',
  Inr: 'INR',
  Jpy: 'JPY',
  Sgd: 'SGD',
  Usd: 'USD'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];
export type __SHOULD_NOT_USE__Customer = {
  createdAt: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  externalID: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Scalars['Map']['output'];
  name: Maybe<Scalars['String']['output']>;
  owner: __SHOULD_NOT_USE__Organization;
  paymentMethods: Array<__SHOULD_NOT_USE__PaymentMethod>;
  payments: Array<__SHOULD_NOT_USE__Payment>;
  phone: Maybe<Scalars['String']['output']>;
  recurringPayments: Array<__SHOULD_NOT_USE__RecurringPayment>;
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__CustomerConnection = {
  edges: Array<__SHOULD_NOT_USE__CustomerEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__CustomerEdge = {
  cursor: Scalars['Cursor']['output'];
  node: __SHOULD_NOT_USE__Customer;
};

export type __SHOULD_NOT_USE__CustomerOrderBy = {
  direction: SortOrder;
  field: CustomerOrderField;
};

export const CustomerOrderField = {
  CreatedAt: 'CREATED_AT',
  Email: 'EMAIL',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomerOrderField = typeof CustomerOrderField[keyof typeof CustomerOrderField];
export type __SHOULD_NOT_USE__CustomerPaymentHistory = {
  averagePayment: Scalars['Float']['output'];
  customerEmail: Scalars['String']['output'];
  customerName: Maybe<Scalars['String']['output']>;
  failedPayments: Scalars['Int']['output'];
  firstPaymentDate: Maybe<Scalars['Time']['output']>;
  lastPaymentDate: Maybe<Scalars['Time']['output']>;
  payments: Maybe<__SHOULD_NOT_USE__PaymentConnection>;
  successfulPayments: Scalars['Int']['output'];
  totalPayments: Scalars['Int']['output'];
  totalSpent: Scalars['Float']['output'];
};

/**
 * CustomerWhereInput is used for filtering Customer objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__CustomerWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__CustomerWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_addresses edge predicates */
  hasBillingAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  hasBillingAddressesWith?: InputMaybe<Array<__SHOULD_NOT_USE__BillingAddressWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payment_methods edge predicates */
  hasPaymentMethods?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentMethodsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentMethodWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** recurring_payments edge predicates */
  hasRecurringPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecurringPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__RecurringPaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__CustomerWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__CustomerWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** phone field predicates */
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneContains?: InputMaybe<Scalars['String']['input']>;
  phoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneGT?: InputMaybe<Scalars['String']['input']>;
  phoneGTE?: InputMaybe<Scalars['String']['input']>;
  phoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  phoneLT?: InputMaybe<Scalars['String']['input']>;
  phoneLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__DateRange = {
  endDate: Maybe<Scalars['Time']['output']>;
  startDate: Maybe<Scalars['Time']['output']>;
};

export type __SHOULD_NOT_USE__DateRangeInput = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};

export type __SHOULD_NOT_USE__DeactivateApiKeyPayload = {
  apiKey: Maybe<__SHOULD_NOT_USE__ApiKey>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DefaultQuickPayPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  quickPay: Maybe<__SHOULD_NOT_USE__QuickPay>;
};

export type __SHOULD_NOT_USE__DeleteApiKeyPayload = {
  deletedKeyId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type __SHOULD_NOT_USE__DeleteBankAccountPayload = {
  deletedAccountId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  newPrimaryAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeleteCardTypePayload = {
  deletedCardTypeId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeleteInvoicePayload = {
  deletedInvoiceId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type __SHOULD_NOT_USE__DeleteLineItemPayload = {
  deletedLineItemId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type __SHOULD_NOT_USE__DeleteOrganizationPayload = {
  deletedOrganizationId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeleteOrganizationPaymentTypePayload = {
  deletedOrganizationPaymentTypeId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeletePaymentProviderPayload = {
  deletedPaymentProviderId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeletePaymentTypePayload = {
  deletedPaymentTypeId: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeletePayoutPayload = {
  deletedPayoutId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeletePolicyDocumentPayload = {
  deletedPolicyId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type __SHOULD_NOT_USE__DeletePolicyTemplatePayload = {
  deletedTemplateId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type __SHOULD_NOT_USE__DeleteRolePayload = {
  deletedRoleId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeleteTransferPayload = {
  deletedTransferId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DeleteUserPayload = {
  deletedUserId: Maybe<Scalars['ID']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__DenyRefundInput = {
  id: Scalars['ID']['input'];
  merchantDeclineReason: Scalars['Map']['input'];
};

export type __SHOULD_NOT_USE__DenyRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export type __SHOULD_NOT_USE__DeprecatePolicyDocumentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  policy: Maybe<__SHOULD_NOT_USE__PolicyDocument>;
};

export type __SHOULD_NOT_USE__Dispute = {
  additionalInformation: Maybe<Scalars['String']['output']>;
  cancellationDelayDate: Maybe<Scalars['Time']['output']>;
  cancellationDelayDescription: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  creditVoucherAmount: Maybe<Scalars['Float']['output']>;
  creditVoucherDescription: Maybe<Scalars['String']['output']>;
  creditVoucherGivenDate: Maybe<Scalars['Time']['output']>;
  currency: Scalars['String']['output'];
  customerAlreadyRefunded: Scalars['Boolean']['output'];
  disputeAmount: Scalars['Float']['output'];
  disputedAt: Scalars['Time']['output'];
  environment: PaymentEnvironment;
  evidenceDocumentUrl: Maybe<Array<__SHOULD_NOT_USE__DownloadUrl>>;
  evidenceReason: Maybe<DisputeEvidenceReason>;
  gatewayDisputeId: Maybe<Scalars['String']['output']>;
  gatewayName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchant: __SHOULD_NOT_USE__Organization;
  merchantResponseDueDate: Scalars['Time']['output'];
  otherReasonDescription: Maybe<Scalars['String']['output']>;
  payment: __SHOULD_NOT_USE__Payment;
  productOrServiceDetails: Maybe<Scalars['String']['output']>;
  productServiceType: Maybe<ProductServiceType>;
  progressStatus: DisputeProgressStatus;
  providerDocs: Maybe<Array<__SHOULD_NOT_USE__ProviderDoc>>;
  reason: DisputeReason;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
  refundAmount: Maybe<Scalars['Float']['output']>;
  refundDate: Maybe<Scalars['Time']['output']>;
  refundDescription: Maybe<Scalars['String']['output']>;
  resolutionDate: Maybe<Scalars['Time']['output']>;
  status: DisputeStatus;
  statusUpdatedAt: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  withdrawalDateByCustomer: Maybe<Scalars['Time']['output']>;
};

export type __SHOULD_NOT_USE__DisputeConnection = {
  edges: Array<__SHOULD_NOT_USE__DisputeEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__DisputeEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Dispute;
};

export const DisputeEvidenceReason = {
  BookingCancelledDelayedDueToGovtOrder: 'BOOKING_CANCELLED_DELAYED_DUE_TO_GOVT_ORDER',
  CancellationDelayed: 'CANCELLATION_DELAYED',
  CreditVoucherProvided: 'CREDIT_VOUCHER_PROVIDED',
  CustomerAlreadyRefunded: 'CUSTOMER_ALREADY_REFUNDED',
  CustomerReceivedCreditVoucherOutsidePg: 'CUSTOMER_RECEIVED_CREDIT_VOUCHER_OUTSIDE_PG',
  CustomerWithdrew: 'CUSTOMER_WITHDREW',
  Other: 'OTHER',
  ProductServiceDelivered: 'PRODUCT_SERVICE_DELIVERED',
  RequestMadeAfterDateOfTerms: 'REQUEST_MADE_AFTER_DATE_OF_TERMS',
  TransactionNonRefundable: 'TRANSACTION_NON_REFUNDABLE'
} as const;

export type DisputeEvidenceReason = typeof DisputeEvidenceReason[keyof typeof DisputeEvidenceReason];
export type __SHOULD_NOT_USE__DisputeOrderByInput = {
  direction: SortOrder;
  field: DisputeSortField;
};

export const DisputeProgressStatus = {
  AwaitingFinalDecision: 'AWAITING_FINAL_DECISION',
  EvidenceRequested: 'EVIDENCE_REQUESTED',
  EvidenceSubmitted: 'EVIDENCE_SUBMITTED',
  MerchantNotified: 'MERCHANT_NOTIFIED',
  Received: 'RECEIVED',
  Resolved: 'RESOLVED',
  UnderGatewayReview: 'UNDER_GATEWAY_REVIEW'
} as const;

export type DisputeProgressStatus = typeof DisputeProgressStatus[keyof typeof DisputeProgressStatus];
export const DisputeReason = {
  CreditNotProcessed: 'CREDIT_NOT_PROCESSED',
  Duplicate: 'DUPLICATE',
  Fraudulent: 'FRAUDULENT',
  General: 'GENERAL',
  IncorrectAmount: 'INCORRECT_AMOUNT',
  ProductNotReceived: 'PRODUCT_NOT_RECEIVED',
  ProductUnacceptable: 'PRODUCT_UNACCEPTABLE',
  SubscriptionCanceled: 'SUBSCRIPTION_CANCELED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type DisputeReason = typeof DisputeReason[keyof typeof DisputeReason];
export const DisputeReportField = {
  AdditionalInformation: 'ADDITIONAL_INFORMATION',
  CancellationDelayDate: 'CANCELLATION_DELAY_DATE',
  CancellationDelayDescription: 'CANCELLATION_DELAY_DESCRIPTION',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  CreditVoucherAmount: 'CREDIT_VOUCHER_AMOUNT',
  CreditVoucherDescription: 'CREDIT_VOUCHER_DESCRIPTION',
  CreditVoucherGivenDate: 'CREDIT_VOUCHER_GIVEN_DATE',
  Currency: 'CURRENCY',
  CustomerAlreadyRefunded: 'CUSTOMER_ALREADY_REFUNDED',
  DisputedAt: 'DISPUTED_AT',
  DisputeAmount: 'DISPUTE_AMOUNT',
  Environment: 'ENVIRONMENT',
  EvidenceReason: 'EVIDENCE_REASON',
  GatewayDisputeId: 'GATEWAY_DISPUTE_ID',
  GatewayName: 'GATEWAY_NAME',
  MerchantId: 'MERCHANT_ID',
  MerchantResponseDueDate: 'MERCHANT_RESPONSE_DUE_DATE',
  OtherReasonDescription: 'OTHER_REASON_DESCRIPTION',
  PaymentId: 'PAYMENT_ID',
  ProductOrServiceDetails: 'PRODUCT_OR_SERVICE_DETAILS',
  ProductServiceType: 'PRODUCT_SERVICE_TYPE',
  ProgressStatus: 'PROGRESS_STATUS',
  Reason: 'REASON',
  RefundAmount: 'REFUND_AMOUNT',
  RefundDate: 'REFUND_DATE',
  RefundDescription: 'REFUND_DESCRIPTION',
  RefundId: 'REFUND_ID',
  ResolutionDate: 'RESOLUTION_DATE',
  Status: 'STATUS',
  StatusUpdatedAt: 'STATUS_UPDATED_AT',
  WithdrawalDateByCustomer: 'WITHDRAWAL_DATE_BY_CUSTOMER'
} as const;

export type DisputeReportField = typeof DisputeReportField[keyof typeof DisputeReportField];
export const DisputeSortField = {
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  DisputedAt: 'DISPUTED_AT',
  DisputeAmount: 'DISPUTE_AMOUNT',
  MerchantResponseDueDate: 'MERCHANT_RESPONSE_DUE_DATE',
  ProgressStatus: 'PROGRESS_STATUS',
  ResolutionDate: 'RESOLUTION_DATE',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type DisputeSortField = typeof DisputeSortField[keyof typeof DisputeSortField];
export const DisputeStatus = {
  Accepted: 'ACCEPTED',
  Expired: 'EXPIRED',
  Lost: 'LOST',
  Open: 'OPEN',
  UnderReview: 'UNDER_REVIEW',
  Withdrawn: 'WITHDRAWN',
  Won: 'WON'
} as const;

export type DisputeStatus = typeof DisputeStatus[keyof typeof DisputeStatus];
/**
 * DisputeWhereInput is used for filtering Dispute objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__DisputeWhereInput = {
  /** additional_information field predicates */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  additionalInformationContains?: InputMaybe<Scalars['String']['input']>;
  additionalInformationContainsFold?: InputMaybe<Scalars['String']['input']>;
  additionalInformationEqualFold?: InputMaybe<Scalars['String']['input']>;
  additionalInformationGT?: InputMaybe<Scalars['String']['input']>;
  additionalInformationGTE?: InputMaybe<Scalars['String']['input']>;
  additionalInformationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  additionalInformationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  additionalInformationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalInformationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  additionalInformationLT?: InputMaybe<Scalars['String']['input']>;
  additionalInformationLTE?: InputMaybe<Scalars['String']['input']>;
  additionalInformationNEQ?: InputMaybe<Scalars['String']['input']>;
  additionalInformationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalInformationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__DisputeWhereInput>>;
  /** cancellation_delay_date field predicates */
  cancellationDelayDate?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateGT?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateGTE?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  cancellationDelayDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationDelayDateLT?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateLTE?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  cancellationDelayDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cancellation_delay_description field predicates */
  cancellationDelayDescription?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancellationDelayDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationDelayDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancellationDelayDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** credit_voucher_amount field predicates */
  creditVoucherAmount?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountGT?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  creditVoucherAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  creditVoucherAmountLT?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  creditVoucherAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** credit_voucher_description field predicates */
  creditVoucherDescription?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  creditVoucherDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  creditVoucherDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  creditVoucherDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  creditVoucherDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** credit_voucher_given_date field predicates */
  creditVoucherGivenDate?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateGT?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateGTE?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  creditVoucherGivenDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  creditVoucherGivenDateLT?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateLTE?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  creditVoucherGivenDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  creditVoucherGivenDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyContains?: InputMaybe<Scalars['String']['input']>;
  currencyContainsFold?: InputMaybe<Scalars['String']['input']>;
  currencyEqualFold?: InputMaybe<Scalars['String']['input']>;
  currencyGT?: InputMaybe<Scalars['String']['input']>;
  currencyGTE?: InputMaybe<Scalars['String']['input']>;
  currencyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currencyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currencyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyLT?: InputMaybe<Scalars['String']['input']>;
  currencyLTE?: InputMaybe<Scalars['String']['input']>;
  currencyNEQ?: InputMaybe<Scalars['String']['input']>;
  currencyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** customer_already_refunded field predicates */
  customerAlreadyRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  customerAlreadyRefundedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** dispute_amount field predicates */
  disputeAmount?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountGT?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  disputeAmountLT?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  disputeAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** disputed_at field predicates */
  disputedAt?: InputMaybe<Scalars['Time']['input']>;
  disputedAtGT?: InputMaybe<Scalars['Time']['input']>;
  disputedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  disputedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disputedAtLT?: InputMaybe<Scalars['Time']['input']>;
  disputedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  disputedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  disputedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** environment field predicates */
  environment?: InputMaybe<EnvironmentType>;
  environmentIn?: InputMaybe<Array<EnvironmentType>>;
  environmentNEQ?: InputMaybe<EnvironmentType>;
  environmentNotIn?: InputMaybe<Array<EnvironmentType>>;
  /** evidence_reason field predicates */
  evidenceReason?: InputMaybe<DisputeEvidenceReason>;
  evidenceReasonIn?: InputMaybe<Array<DisputeEvidenceReason>>;
  evidenceReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  evidenceReasonNEQ?: InputMaybe<DisputeEvidenceReason>;
  evidenceReasonNotIn?: InputMaybe<Array<DisputeEvidenceReason>>;
  evidenceReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gateway_dispute_id field predicates */
  gatewayDisputeID?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDContains?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDGT?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDGTE?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayDisputeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayDisputeIDLT?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDLTE?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDNEQ?: InputMaybe<Scalars['String']['input']>;
  gatewayDisputeIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayDisputeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gateway_name field predicates */
  gatewayName?: InputMaybe<Scalars['String']['input']>;
  gatewayNameContains?: InputMaybe<Scalars['String']['input']>;
  gatewayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  gatewayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  gatewayNameGT?: InputMaybe<Scalars['String']['input']>;
  gatewayNameGTE?: InputMaybe<Scalars['String']['input']>;
  gatewayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  gatewayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  gatewayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayNameLT?: InputMaybe<Scalars['String']['input']>;
  gatewayNameLTE?: InputMaybe<Scalars['String']['input']>;
  gatewayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  gatewayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant edge predicates */
  hasMerchant?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payment edge predicates */
  hasPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** refund edge predicates */
  hasRefund?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefundWith?: InputMaybe<Array<__SHOULD_NOT_USE__RefundWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** merchant_id field predicates */
  merchantID?: InputMaybe<Scalars['ID']['input']>;
  merchantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  merchantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** merchant_response_due_date field predicates */
  merchantResponseDueDate?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateGT?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateGTE?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  merchantResponseDueDateLT?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateLTE?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  merchantResponseDueDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__DisputeWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__DisputeWhereInput>>;
  /** other_reason_description field predicates */
  otherReasonDescription?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherReasonDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  otherReasonDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  otherReasonDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherReasonDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_id field predicates */
  paymentID?: InputMaybe<Scalars['ID']['input']>;
  paymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** product_or_service_details field predicates */
  productOrServiceDetails?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsContains?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsContainsFold?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsEqualFold?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsGT?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsGTE?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  productOrServiceDetailsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productOrServiceDetailsLT?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsLTE?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsNEQ?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetailsNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  productOrServiceDetailsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** product_service_type field predicates */
  productServiceType?: InputMaybe<ProductServiceType>;
  productServiceTypeIn?: InputMaybe<Array<ProductServiceType>>;
  productServiceTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  productServiceTypeNEQ?: InputMaybe<ProductServiceType>;
  productServiceTypeNotIn?: InputMaybe<Array<ProductServiceType>>;
  productServiceTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** progress_status field predicates */
  progressStatus?: InputMaybe<DisputeProgressStatus>;
  progressStatusIn?: InputMaybe<Array<DisputeProgressStatus>>;
  progressStatusNEQ?: InputMaybe<DisputeProgressStatus>;
  progressStatusNotIn?: InputMaybe<Array<DisputeProgressStatus>>;
  /** reason field predicates */
  reason?: InputMaybe<DisputeReason>;
  reasonIn?: InputMaybe<Array<DisputeReason>>;
  reasonNEQ?: InputMaybe<DisputeReason>;
  reasonNotIn?: InputMaybe<Array<DisputeReason>>;
  /** refund_amount field predicates */
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
  refundAmountGT?: InputMaybe<Scalars['Float']['input']>;
  refundAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  refundAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundAmountLT?: InputMaybe<Scalars['Float']['input']>;
  refundAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  refundAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  refundAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_date field predicates */
  refundDate?: InputMaybe<Scalars['Time']['input']>;
  refundDateGT?: InputMaybe<Scalars['Time']['input']>;
  refundDateGTE?: InputMaybe<Scalars['Time']['input']>;
  refundDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  refundDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundDateLT?: InputMaybe<Scalars['Time']['input']>;
  refundDateLTE?: InputMaybe<Scalars['Time']['input']>;
  refundDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  refundDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  refundDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_description field predicates */
  refundDescription?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  refundDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  refundDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  refundDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_id field predicates */
  refundID?: InputMaybe<Scalars['ID']['input']>;
  refundIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  refundIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** resolution_date field predicates */
  resolutionDate?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateGT?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateGTE?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  resolutionDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  resolutionDateLT?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateLTE?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  resolutionDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  resolutionDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<DisputeStatus>;
  statusIn?: InputMaybe<Array<DisputeStatus>>;
  statusNEQ?: InputMaybe<DisputeStatus>;
  statusNotIn?: InputMaybe<Array<DisputeStatus>>;
  /** status_updated_at field predicates */
  statusUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** withdrawal_date_by_customer field predicates */
  withdrawalDateByCustomer?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerGT?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerGTE?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  withdrawalDateByCustomerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  withdrawalDateByCustomerLT?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerLTE?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerNEQ?: InputMaybe<Scalars['Time']['input']>;
  withdrawalDateByCustomerNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  withdrawalDateByCustomerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__DownloadDailyReportPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  failureBase64: Maybe<Scalars['String']['output']>;
  failureFileName: Maybe<Scalars['String']['output']>;
  successBase64: Maybe<Scalars['String']['output']>;
  successFileName: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__DownloadDisputeReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadMerchantReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Maybe<__SHOULD_NOT_USE__Error>>>;
};

export type __SHOULD_NOT_USE__DownloadPaidApiPaymentReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadPaidInvoiceReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadPaymentReceiptPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadPaymentReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadPayoutReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadRefundReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadTransferReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadTransferReportPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadUnpaidApiPaymentReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadUnpaidInvoiceReceipt = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__DownloadUrl = {
  expiresIn: Scalars['Int64']['output'];
  url: Scalars['String']['output'];
};

export const EnvironmentType = {
  Live: 'LIVE',
  Test: 'TEST'
} as const;

export type EnvironmentType = typeof EnvironmentType[keyof typeof EnvironmentType];
export type __SHOULD_NOT_USE__Error = {
  code: ErrorCode;
  field: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export const ErrorCode = {
  AlreadyExists: 'ALREADY_EXISTS',
  InternalServerError: 'INTERNAL_SERVER_ERROR',
  InvalidCredentials: 'INVALID_CREDENTIALS',
  InvalidInput: 'INVALID_INPUT',
  JwtTokenExpired: 'JWT_TOKEN_EXPIRED',
  NotFound: 'NOT_FOUND',
  PermissionDenied: 'PERMISSION_DENIED',
  Unauthorized: 'UNAUTHORIZED'
} as const;

export type ErrorCode = typeof ErrorCode[keyof typeof ErrorCode];
export type __SHOULD_NOT_USE__Event = {
  createdAt: Scalars['Time']['output'];
  entityId: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  eventAction: EventAction;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['Map']['output']>;
  organization: __SHOULD_NOT_USE__Organization;
  organizationId: Scalars['ID']['output'];
  user: Maybe<__SHOULD_NOT_USE__User>;
  userAgent: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['ID']['output']>;
};

export const EventAction = {
  Created: 'CREATED',
  Deleted: 'DELETED',
  StatusChanged: 'STATUS_CHANGED',
  Updated: 'UPDATED'
} as const;

export type EventAction = typeof EventAction[keyof typeof EventAction];
export type __SHOULD_NOT_USE__EventConnection = {
  edges: Array<__SHOULD_NOT_USE__EventEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__EventEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Event;
};

export type __SHOULD_NOT_USE__EventOrderByInput = {
  direction: SortOrder;
  field: EventOrderField;
};

export const EventOrderField = {
  CreatedAt: 'CREATED_AT',
  EntityType: 'ENTITY_TYPE',
  EventAction: 'EVENT_ACTION',
  EventType: 'EVENT_TYPE'
} as const;

export type EventOrderField = typeof EventOrderField[keyof typeof EventOrderField];
/**
 * EventWhereInput is used for filtering Event objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__EventWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__EventWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['UUID']['input']>;
  entityIDGT?: InputMaybe<Scalars['UUID']['input']>;
  entityIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  entityIDLT?: InputMaybe<Scalars['UUID']['input']>;
  entityIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  entityIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** entity_type field predicates */
  entityType?: InputMaybe<Scalars['String']['input']>;
  entityTypeContains?: InputMaybe<Scalars['String']['input']>;
  entityTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  entityTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  entityTypeGT?: InputMaybe<Scalars['String']['input']>;
  entityTypeGTE?: InputMaybe<Scalars['String']['input']>;
  entityTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  entityTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  entityTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  entityTypeLT?: InputMaybe<Scalars['String']['input']>;
  entityTypeLTE?: InputMaybe<Scalars['String']['input']>;
  entityTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  entityTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** event_action field predicates */
  eventAction?: InputMaybe<EventAction>;
  eventActionIn?: InputMaybe<Array<EventAction>>;
  eventActionNEQ?: InputMaybe<EventAction>;
  eventActionNotIn?: InputMaybe<Array<EventAction>>;
  /** event_type field predicates */
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventTypeContains?: InputMaybe<Scalars['String']['input']>;
  eventTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeGT?: InputMaybe<Scalars['String']['input']>;
  eventTypeGTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventTypeLT?: InputMaybe<Scalars['String']['input']>;
  eventTypeLTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  eventTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ip_address field predicates */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressContains?: InputMaybe<Scalars['String']['input']>;
  ipAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressGT?: InputMaybe<Scalars['String']['input']>;
  ipAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ipAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddressLT?: InputMaybe<Scalars['String']['input']>;
  ipAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ipAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__EventWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__EventWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgentContains?: InputMaybe<Scalars['String']['input']>;
  userAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  userAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  userAgentGT?: InputMaybe<Scalars['String']['input']>;
  userAgentGTE?: InputMaybe<Scalars['String']['input']>;
  userAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['String']['input']>;
  userAgentLTE?: InputMaybe<Scalars['String']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__ExpireDisputeInput = {
  id: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__ExpireDisputePayload = {
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export const FeeType = {
  Flat: 'FLAT',
  Percentage: 'PERCENTAGE'
} as const;

export type FeeType = typeof FeeType[keyof typeof FeeType];
export type __SHOULD_NOT_USE__Fees = {
  customerProcessingFee: Maybe<Scalars['Float']['output']>;
  merchantProcessingFee: Maybe<Scalars['Float']['output']>;
  paymentType: Maybe<PaymentType>;
  processingFees: Maybe<Scalars['Float']['output']>;
};

export type __SHOULD_NOT_USE__FlagPaymentInput = {
  flagReason: Scalars['Map']['input'];
  paymentId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__FlagPaymentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  payment: Maybe<__SHOULD_NOT_USE__Payment>;
};

export type __SHOULD_NOT_USE__GenerateApiKeyInput = {
  name: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__GenerateApiKeyPayload = {
  apiKey: Maybe<__SHOULD_NOT_USE__ApiKey>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  secretKey: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__GenerateInvoicePdfPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  media: Maybe<__SHOULD_NOT_USE__Media>;
};

export type __SHOULD_NOT_USE__GenerateTransferPdfPayload = {
  base64: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__GenerateUploadUrlInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int64']['input'];
};

export type __SHOULD_NOT_USE__GrantPermissionInput = {
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__GrantPermissionPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  permissionRole: Maybe<__SHOULD_NOT_USE__PermissionRole>;
};

export type __SHOULD_NOT_USE__GrantPermissionsInput = {
  permissionIds: Array<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__GrantPermissionsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  permissionRoles: Maybe<Array<__SHOULD_NOT_USE__PermissionRole>>;
};

export type __SHOULD_NOT_USE__ImgixOptions = {
  auto?: InputMaybe<Scalars['String']['input']>;
  fit?: InputMaybe<Scalars['String']['input']>;
  h?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['Int']['input']>;
  w?: InputMaybe<Scalars['Int']['input']>;
};

export type __SHOULD_NOT_USE__InitQuickPaymentInput = {
  accessKey: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<CardType>;
  customerEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  paymentType: PaymentType;
};

export type __SHOULD_NOT_USE__InitQuickPaymentPayload = {
  amount: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Currency;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  feeBreakdown: Maybe<__SHOULD_NOT_USE__PaymentFeeBreakdown>;
  paymentIntentId: Scalars['String']['output'];
  publishableKey: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__IntrospectTokenInput = {
  token: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__IntrospectTokenPayload = {
  active: Scalars['Boolean']['output'];
  expiresAt: Maybe<Scalars['Time']['output']>;
  orgId: Maybe<Scalars['ID']['output']>;
  orgType: Maybe<OrganizationType>;
  userId: Maybe<Scalars['ID']['output']>;
};

export type __SHOULD_NOT_USE__InviteBankUserInput = {
  bankId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Roles must belong to the target bank organization */
  roleIds: Array<Scalars['ID']['input']>;
};

export type __SHOULD_NOT_USE__InviteUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  roledIds: Array<Scalars['ID']['input']>;
};

export type __SHOULD_NOT_USE__InviteUserPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  invitationSent: Scalars['Boolean']['output'];
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__Invoice = {
  accessKey: Scalars['String']['output'];
  billingAddresses: Maybe<Array<Maybe<__SHOULD_NOT_USE__BillingAddress>>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Maybe<__SHOULD_NOT_USE__User>;
  createdById: Scalars['ID']['output'];
  customFields: Scalars['Map']['output'];
  dueDate: Maybe<Scalars['Time']['output']>;
  fees: Maybe<__SHOULD_NOT_USE__Fees>;
  guestAccessUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<__SHOULD_NOT_USE__InvoiceLineItem>;
  merchantProcessingFee: Scalars['Float']['output'];
  owner: __SHOULD_NOT_USE__Organization;
  ownerId: Scalars['ID']['output'];
  paymentOptions: Array<PaymentType>;
  payoutAmount: Scalars['Float']['output'];
  previousStatus: InvoiceStatus;
  receipt: Maybe<__SHOULD_NOT_USE__DownloadUrl>;
  recipientEmail: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  refundPolicyTerms: InvoiceRefundPolicyTerms;
  status: InvoiceStatus;
  subtotal: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__InvoiceConnection = {
  edges: Array<__SHOULD_NOT_USE__InvoiceEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__InvoiceEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Invoice;
};

export type __SHOULD_NOT_USE__InvoiceLineItem = {
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  subtotal: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__InvoiceLineItemInput = {
  description: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * InvoiceLineItemWhereInput is used for filtering InvoiceLineItem objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__InvoiceLineItemWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceLineItemWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** invoice edge predicates */
  hasInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoiceWith?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** invoice_id field predicates */
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__InvoiceLineItemWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceLineItemWhereInput>>;
  /** price field predicates */
  price?: InputMaybe<Scalars['Float']['input']>;
  priceGT?: InputMaybe<Scalars['Float']['input']>;
  priceGTE?: InputMaybe<Scalars['Float']['input']>;
  priceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  priceLT?: InputMaybe<Scalars['Float']['input']>;
  priceLTE?: InputMaybe<Scalars['Float']['input']>;
  priceNEQ?: InputMaybe<Scalars['Float']['input']>;
  priceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** quantity field predicates */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityGT?: InputMaybe<Scalars['Int']['input']>;
  quantityGTE?: InputMaybe<Scalars['Int']['input']>;
  quantityIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  quantityLT?: InputMaybe<Scalars['Int']['input']>;
  quantityLTE?: InputMaybe<Scalars['Int']['input']>;
  quantityNEQ?: InputMaybe<Scalars['Int']['input']>;
  quantityNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** sort field predicates */
  sort?: InputMaybe<Scalars['Int']['input']>;
  sortGT?: InputMaybe<Scalars['Int']['input']>;
  sortGTE?: InputMaybe<Scalars['Int']['input']>;
  sortIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortLT?: InputMaybe<Scalars['Int']['input']>;
  sortLTE?: InputMaybe<Scalars['Int']['input']>;
  sortNEQ?: InputMaybe<Scalars['Int']['input']>;
  sortNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__InvoiceOrderByField = {
  direction: SortOrder;
  field: InvoiceOrderField;
};

export type __SHOULD_NOT_USE__InvoiceOrderByInput = {
  orderBy: Array<__SHOULD_NOT_USE__InvoiceOrderByField>;
};

export const InvoiceOrderField = {
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  DueDate: 'DUE_DATE',
  Status: 'STATUS',
  TotalAmount: 'TOTAL_AMOUNT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type InvoiceOrderField = typeof InvoiceOrderField[keyof typeof InvoiceOrderField];
export const InvoiceRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type InvoiceRefundPolicyTerms = typeof InvoiceRefundPolicyTerms[keyof typeof InvoiceRefundPolicyTerms];
export const InvoiceStatus = {
  Paid: 'PAID',
  PendingAction: 'PENDING_ACTION',
  Processing: 'PROCESSING',
  Unpaid: 'UNPAID',
  Void: 'VOID'
} as const;

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];
export type __SHOULD_NOT_USE__InvoiceSummary = {
  overdueCount: Scalars['Int']['output'];
  paidCount: Scalars['Int']['output'];
  totalInvoices: Scalars['Int']['output'];
  totalPaidAmount: Scalars['Float']['output'];
  totalUnpaidAmount: Scalars['Float']['output'];
  unpaidCount: Scalars['Int']['output'];
  voidCount: Scalars['Int']['output'];
};

/**
 * InvoiceWhereInput is used for filtering Invoice objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__InvoiceWhereInput = {
  /** access_key field predicates */
  accessKey?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  accessKeyLT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyLTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNEQ?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** due_date field predicates */
  dueDate?: InputMaybe<Scalars['Time']['input']>;
  dueDateGT?: InputMaybe<Scalars['Time']['input']>;
  dueDateGTE?: InputMaybe<Scalars['Time']['input']>;
  dueDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dueDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dueDateLT?: InputMaybe<Scalars['Time']['input']>;
  dueDateLTE?: InputMaybe<Scalars['Time']['input']>;
  dueDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  dueDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dueDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** billing_addresses edge predicates */
  hasBillingAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  hasBillingAddressesWith?: InputMaybe<Array<__SHOULD_NOT_USE__BillingAddressWhereInput>>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** items edge predicates */
  hasItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasItemsWith?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceLineItemWhereInput>>;
  /** manually_approved_by edge predicates */
  hasManuallyApprovedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasManuallyApprovedByWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_manually_paid field predicates */
  isManuallyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isManuallyPaidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** manually_approved_at field predicates */
  manuallyApprovedAt?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtGT?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  manuallyApprovedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  manuallyApprovedAtLT?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  manuallyApprovedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  manuallyApprovedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** manually_approved_by_id field predicates */
  manuallyApprovedByID?: InputMaybe<Scalars['ID']['input']>;
  manuallyApprovedByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  manuallyApprovedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  manuallyApprovedByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  manuallyApprovedByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  manuallyApprovedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__InvoiceWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** paid_at field predicates */
  paidAt?: InputMaybe<Scalars['Time']['input']>;
  paidAtGT?: InputMaybe<Scalars['Time']['input']>;
  paidAtGTE?: InputMaybe<Scalars['Time']['input']>;
  paidAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  paidAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paidAtLT?: InputMaybe<Scalars['Time']['input']>;
  paidAtLTE?: InputMaybe<Scalars['Time']['input']>;
  paidAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  paidAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  paidAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter invoices that contain this specific payment option */
  paymentOptionsContains?: InputMaybe<PaymentType>;
  /** Filter invoices that contain ALL of the specified payment options */
  paymentOptionsHasAll?: InputMaybe<Array<PaymentType>>;
  /** Filter invoices that contain ANY of the specified payment options */
  paymentOptionsHasAny?: InputMaybe<Array<PaymentType>>;
  /** Filter invoices that do NOT contain this specific payment option */
  paymentOptionsNotContains?: InputMaybe<PaymentType>;
  /** previous_status field predicates */
  previousStatus?: InputMaybe<InvoiceStatus>;
  previousStatusIn?: InputMaybe<Array<InvoiceStatus>>;
  previousStatusNEQ?: InputMaybe<InvoiceStatus>;
  previousStatusNotIn?: InputMaybe<Array<InvoiceStatus>>;
  /** recipient_email field predicates */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientEmailContains?: InputMaybe<Scalars['String']['input']>;
  recipientEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  recipientEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  recipientEmailGT?: InputMaybe<Scalars['String']['input']>;
  recipientEmailGTE?: InputMaybe<Scalars['String']['input']>;
  recipientEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  recipientEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  recipientEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recipientEmailLT?: InputMaybe<Scalars['String']['input']>;
  recipientEmailLTE?: InputMaybe<Scalars['String']['input']>;
  recipientEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  recipientEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** recipient_name field predicates */
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientNameContains?: InputMaybe<Scalars['String']['input']>;
  recipientNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  recipientNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  recipientNameGT?: InputMaybe<Scalars['String']['input']>;
  recipientNameGTE?: InputMaybe<Scalars['String']['input']>;
  recipientNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  recipientNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  recipientNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recipientNameLT?: InputMaybe<Scalars['String']['input']>;
  recipientNameLTE?: InputMaybe<Scalars['String']['input']>;
  recipientNameNEQ?: InputMaybe<Scalars['String']['input']>;
  recipientNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<InvoiceRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<InvoiceRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<InvoiceRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<InvoiceRefundPolicyTerms>>;
  /** status field predicates */
  status?: InputMaybe<InvoiceStatus>;
  statusIn?: InputMaybe<Array<InvoiceStatus>>;
  statusNEQ?: InputMaybe<InvoiceStatus>;
  statusNotIn?: InputMaybe<Array<InvoiceStatus>>;
  /** transfer_id field predicates */
  transferID?: InputMaybe<Scalars['UUID']['input']>;
  transferIDGT?: InputMaybe<Scalars['UUID']['input']>;
  transferIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  transferIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  transferIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  transferIDLT?: InputMaybe<Scalars['UUID']['input']>;
  transferIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  transferIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  transferIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  transferIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__LoginPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__AuthenticationError>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__ManualProcessRefundInput = {
  id: Scalars['ID']['input'];
  providerRefundID: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__ManualProcessRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export type __SHOULD_NOT_USE__ManuallyApproveInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paidAmount: Scalars['Float']['input'];
  paymentMethod: PaymentType;
  transactionReference?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__ManuallyApproveInvoicePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  invoice: Maybe<__SHOULD_NOT_USE__Invoice>;
  payment: Maybe<__SHOULD_NOT_USE__Payment>;
  payout: Maybe<__SHOULD_NOT_USE__Payout>;
};

export type __SHOULD_NOT_USE__Media = {
  cloudFrontUrl: __SHOULD_NOT_USE__DownloadUrl;
  createdAt: Scalars['Time']['output'];
  createdBy: Maybe<__SHOULD_NOT_USE__User>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<MediaEntityType>;
  id: Scalars['ID']['output'];
  imgixUrl: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  url: __SHOULD_NOT_USE__DownloadUrl;
};


export type __SHOULD_NOT_USE__MediaImgixUrlArgs = {
  options?: InputMaybe<__SHOULD_NOT_USE__ImgixOptions>;
};

export const MediaEntityType = {
  Dispute: 'DISPUTE',
  Invoice: 'INVOICE',
  Organization: 'ORGANIZATION',
  Payment: 'PAYMENT',
  Payout: 'PAYOUT',
  Refund: 'REFUND',
  User: 'USER'
} as const;

export type MediaEntityType = typeof MediaEntityType[keyof typeof MediaEntityType];
export const MediaType = {
  Avatar: 'AVATAR',
  CreditAdvice: 'CREDIT_ADVICE',
  DisputeCreditVoucherProof: 'DISPUTE_CREDIT_VOUCHER_PROOF',
  DisputeProviderDocument: 'DISPUTE_PROVIDER_DOCUMENT',
  DisputeRefundProof: 'DISPUTE_REFUND_PROOF',
  DisputeSupportingDocument: 'DISPUTE_SUPPORTING_DOCUMENT',
  DoiDocument: 'DOI_DOCUMENT',
  HotelInvoice: 'HOTEL_INVOICE',
  InvoicePdf: 'INVOICE_PDF',
  Logo: 'LOGO',
  QrCode: 'QR_CODE',
  RefundProof: 'REFUND_PROOF',
  RefundSupportingDocument: 'REFUND_SUPPORTING_DOCUMENT'
} as const;

export type MediaType = typeof MediaType[keyof typeof MediaType];
/**
 * MediaWhereInput is used for filtering Media objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__MediaWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__MediaWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['UUID']['input']>;
  entityIDGT?: InputMaybe<Scalars['UUID']['input']>;
  entityIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  entityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityIDLT?: InputMaybe<Scalars['UUID']['input']>;
  entityIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  entityIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  entityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_type field predicates */
  entityType?: InputMaybe<MediaEntityType>;
  entityTypeIn?: InputMaybe<Array<MediaEntityType>>;
  entityTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityTypeNEQ?: InputMaybe<MediaEntityType>;
  entityTypeNotIn?: InputMaybe<Array<MediaEntityType>>;
  entityTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** mime_type field predicates */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  mimeTypeContains?: InputMaybe<Scalars['String']['input']>;
  mimeTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  mimeTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  mimeTypeGT?: InputMaybe<Scalars['String']['input']>;
  mimeTypeGTE?: InputMaybe<Scalars['String']['input']>;
  mimeTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mimeTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mimeTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mimeTypeLT?: InputMaybe<Scalars['String']['input']>;
  mimeTypeLTE?: InputMaybe<Scalars['String']['input']>;
  mimeTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  mimeTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__MediaWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__MediaWhereInput>>;
  /** path field predicates */
  path?: InputMaybe<Scalars['String']['input']>;
  pathContains?: InputMaybe<Scalars['String']['input']>;
  pathContainsFold?: InputMaybe<Scalars['String']['input']>;
  pathEqualFold?: InputMaybe<Scalars['String']['input']>;
  pathGT?: InputMaybe<Scalars['String']['input']>;
  pathGTE?: InputMaybe<Scalars['String']['input']>;
  pathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  pathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  pathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  pathLT?: InputMaybe<Scalars['String']['input']>;
  pathLTE?: InputMaybe<Scalars['String']['input']>;
  pathNEQ?: InputMaybe<Scalars['String']['input']>;
  pathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** type field predicates */
  type?: InputMaybe<Scalars['String']['input']>;
  typeContains?: InputMaybe<Scalars['String']['input']>;
  typeContainsFold?: InputMaybe<Scalars['String']['input']>;
  typeEqualFold?: InputMaybe<Scalars['String']['input']>;
  typeGT?: InputMaybe<Scalars['String']['input']>;
  typeGTE?: InputMaybe<Scalars['String']['input']>;
  typeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  typeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  typeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  typeLT?: InputMaybe<Scalars['String']['input']>;
  typeLTE?: InputMaybe<Scalars['String']['input']>;
  typeNEQ?: InputMaybe<Scalars['String']['input']>;
  typeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__MerchantBankAccount = {
  accountHolderName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountNumberMasked: Scalars['String']['output'];
  bank: __SHOULD_NOT_USE__Organization;
  bankId: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  organization: __SHOULD_NOT_USE__Organization;
  organizationId: Scalars['ID']['output'];
  rejectReason: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  type: BankAccountType;
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__MerchantBankAccountConnection = {
  edges: Array<__SHOULD_NOT_USE__MerchantBankAccountEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__MerchantBankAccountEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__MerchantBankAccount;
};

export type __SHOULD_NOT_USE__MerchantBankAccountOrderByInput = {
  direction: SortOrder;
  field: MerchantBankAccountOrderField;
};

export const MerchantBankAccountOrderField = {
  AccountHolderName: 'ACCOUNT_HOLDER_NAME',
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  Type: 'TYPE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type MerchantBankAccountOrderField = typeof MerchantBankAccountOrderField[keyof typeof MerchantBankAccountOrderField];
/**
 * MerchantBankAccountWhereInput is used for filtering MerchantBankAccount objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__MerchantBankAccountWhereInput = {
  /** account_holder_name field predicates */
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameContains?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameGT?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameGTE?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  accountHolderNameLT?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameLTE?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameNEQ?: InputMaybe<Scalars['String']['input']>;
  accountHolderNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** account_number field predicates */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountNumberContains?: InputMaybe<Scalars['String']['input']>;
  accountNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  accountNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  accountNumberGT?: InputMaybe<Scalars['String']['input']>;
  accountNumberGTE?: InputMaybe<Scalars['String']['input']>;
  accountNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  accountNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  accountNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  accountNumberLT?: InputMaybe<Scalars['String']['input']>;
  accountNumberLTE?: InputMaybe<Scalars['String']['input']>;
  accountNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  accountNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantBankAccountWhereInput>>;
  /** bank_id field predicates */
  bankID?: InputMaybe<Scalars['ID']['input']>;
  bankIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  bankIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** bank edge predicates */
  hasBank?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_primary field predicates */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_verified field predicates */
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isVerifiedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__MerchantBankAccountWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantBankAccountWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** reject_reason field predicates */
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  rejectReasonContains?: InputMaybe<Scalars['String']['input']>;
  rejectReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  rejectReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  rejectReasonGT?: InputMaybe<Scalars['String']['input']>;
  rejectReasonGTE?: InputMaybe<Scalars['String']['input']>;
  rejectReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  rejectReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  rejectReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rejectReasonLT?: InputMaybe<Scalars['String']['input']>;
  rejectReasonLTE?: InputMaybe<Scalars['String']['input']>;
  rejectReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  rejectReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<BankAccountStatus>;
  statusIn?: InputMaybe<Array<BankAccountStatus>>;
  statusNEQ?: InputMaybe<BankAccountStatus>;
  statusNotIn?: InputMaybe<Array<BankAccountStatus>>;
  /** type field predicates */
  type?: InputMaybe<BankAccountType>;
  typeIn?: InputMaybe<Array<BankAccountType>>;
  typeNEQ?: InputMaybe<BankAccountType>;
  typeNotIn?: InputMaybe<Array<BankAccountType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__MerchantDefaultPolicy = {
  organization: __SHOULD_NOT_USE__Organization;
  policy: __SHOULD_NOT_USE__PolicyDocument;
  policyType: PolicyType;
  setAt: Scalars['Time']['output'];
};

/**
 * MerchantDefaultPolicyWhereInput is used for filtering MerchantDefaultPolicy objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__MerchantDefaultPolicyWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantDefaultPolicyWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** policy edge predicates */
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyWith?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__MerchantDefaultPolicyWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantDefaultPolicyWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** policy_id field predicates */
  policyID?: InputMaybe<Scalars['ID']['input']>;
  policyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  policyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** policy_type field predicates */
  policyType?: InputMaybe<PolicyType>;
  policyTypeIn?: InputMaybe<Array<PolicyType>>;
  policyTypeNEQ?: InputMaybe<PolicyType>;
  policyTypeNotIn?: InputMaybe<Array<PolicyType>>;
  /** set_at field predicates */
  setAt?: InputMaybe<Scalars['Time']['input']>;
  setAtGT?: InputMaybe<Scalars['Time']['input']>;
  setAtGTE?: InputMaybe<Scalars['Time']['input']>;
  setAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  setAtLT?: InputMaybe<Scalars['Time']['input']>;
  setAtLTE?: InputMaybe<Scalars['Time']['input']>;
  setAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  setAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__MerchantPayoutDashboard = {
  /** One entry per currency the merchant has payouts in */
  items: Array<__SHOULD_NOT_USE__MerchantPayoutDashboardItem>;
};

export type __SHOULD_NOT_USE__MerchantPayoutDashboardItem = {
  /** Sum of all PENDING payout amounts (awaiting transfer) */
  availablePayouts: Scalars['Float']['output'];
  /** Count of pending/available payouts */
  availablePayoutsCount: Scalars['Int']['output'];
  /** Currency for this item's amounts */
  currency: Currency;
  /** Sum of all COMPLETED payout amounts (money already transferred to bank) */
  totalPaidOut: Scalars['Float']['output'];
  /** Count of completed payouts */
  totalPaidOutCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__MerchantPolicyAcceptance = {
  acceptanceContext: AcceptanceContext;
  acceptedAt: Scalars['Time']['output'];
  acceptedByUser: __SHOULD_NOT_USE__User;
  bank: Maybe<__SHOULD_NOT_USE__Organization>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  organization: __SHOULD_NOT_USE__Organization;
  policy: __SHOULD_NOT_USE__PolicyDocument;
  supersededBy: Maybe<__SHOULD_NOT_USE__MerchantPolicyAcceptance>;
  userAgent: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__MerchantPolicyAcceptanceConnection = {
  edges: Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__MerchantPolicyAcceptanceEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__MerchantPolicyAcceptance;
};

/**
 * MerchantPolicyAcceptanceWhereInput is used for filtering MerchantPolicyAcceptance objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput = {
  /** acceptance_context field predicates */
  acceptanceContext?: InputMaybe<AcceptanceContext>;
  acceptanceContextIn?: InputMaybe<Array<AcceptanceContext>>;
  acceptanceContextNEQ?: InputMaybe<AcceptanceContext>;
  acceptanceContextNotIn?: InputMaybe<Array<AcceptanceContext>>;
  /** accepted_at field predicates */
  acceptedAt?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  acceptedAtLT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** accepted_by_user_id field predicates */
  acceptedByUserID?: InputMaybe<Scalars['ID']['input']>;
  acceptedByUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  acceptedByUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  acceptedByUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>>;
  /** bank_id field predicates */
  bankID?: InputMaybe<Scalars['ID']['input']>;
  bankIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bankIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  bankIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** accepted_by_user edge predicates */
  hasAcceptedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasAcceptedByUserWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** bank edge predicates */
  hasBank?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** policy edge predicates */
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyWith?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** superseded_acceptances edge predicates */
  hasSupersededAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededAcceptancesWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>>;
  /** superseded_by edge predicates */
  hasSupersededBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededByWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ip_address field predicates */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressContains?: InputMaybe<Scalars['String']['input']>;
  ipAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressGT?: InputMaybe<Scalars['String']['input']>;
  ipAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ipAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddressLT?: InputMaybe<Scalars['String']['input']>;
  ipAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ipAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_current field predicates */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** policy_id field predicates */
  policyID?: InputMaybe<Scalars['ID']['input']>;
  policyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  policyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** superseded_by_id field predicates */
  supersededByID?: InputMaybe<Scalars['ID']['input']>;
  supersededByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supersededByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supersededByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  supersededByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supersededByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgentContains?: InputMaybe<Scalars['String']['input']>;
  userAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  userAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  userAgentGT?: InputMaybe<Scalars['String']['input']>;
  userAgentGTE?: InputMaybe<Scalars['String']['input']>;
  userAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['String']['input']>;
  userAgentLTE?: InputMaybe<Scalars['String']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const MerchantReportField = {
  Address: 'ADDRESS',
  Code: 'CODE',
  Country: 'COUNTRY',
  CreatedAt: 'CREATED_AT',
  Description: 'DESCRIPTION',
  Email: 'EMAIL',
  Industry: 'INDUSTRY',
  LicenseNumber: 'LICENSE_NUMBER',
  MccCode: 'MCC_CODE',
  MerchantProcessingFee: 'MERCHANT_PROCESSING_FEE',
  Name: 'NAME',
  OtherIndustry: 'OTHER_INDUSTRY',
  PhoneNumber: 'PHONE_NUMBER',
  RefundPolicyTerms: 'REFUND_POLICY_TERMS',
  Status: 'STATUS',
  Type: 'TYPE',
  Website: 'WEBSITE'
} as const;

export type MerchantReportField = typeof MerchantReportField[keyof typeof MerchantReportField];
export type __SHOULD_NOT_USE__MerchantWebhook = {
  createdAt: Scalars['Time']['output'];
  deliveries: Maybe<Array<__SHOULD_NOT_USE__WebhookDelivery>>;
  description: Maybe<Scalars['String']['output']>;
  disabledAt: Maybe<Scalars['Time']['output']>;
  failureCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastTriggeredAt: Maybe<Scalars['Time']['output']>;
  metadata: Maybe<Scalars['Map']['output']>;
  name: Scalars['String']['output'];
  organization: __SHOULD_NOT_USE__Organization;
  organizationID: Scalars['ID']['output'];
  secret: Scalars['String']['output'];
  status: WebhookStatus;
  subscriptions: Maybe<Array<__SHOULD_NOT_USE__MerchantWebhookSubscription>>;
  updatedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__MerchantWebhookConnection = {
  edges: Array<__SHOULD_NOT_USE__MerchantWebhookEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__MerchantWebhookEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__MerchantWebhook;
};

export type __SHOULD_NOT_USE__MerchantWebhookOrderByInput = {
  direction: SortOrder;
  field: MerchantWebhookOrderField;
};

export const MerchantWebhookOrderField = {
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type MerchantWebhookOrderField = typeof MerchantWebhookOrderField[keyof typeof MerchantWebhookOrderField];
export type __SHOULD_NOT_USE__MerchantWebhookSubscription = {
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  merchantWebhook: __SHOULD_NOT_USE__MerchantWebhook;
  merchantWebhookID: Scalars['ID']['output'];
  metadata: Maybe<Scalars['Map']['output']>;
  updatedAt: Scalars['Time']['output'];
  webhookEventType: __SHOULD_NOT_USE__WebhookEventType;
  webhookEventTypeID: Scalars['ID']['output'];
};

/**
 * MerchantWebhookSubscriptionWhereInput is used for filtering MerchantWebhookSubscription objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__MerchantWebhookSubscriptionWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookSubscriptionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** merchant_webhook edge predicates */
  hasMerchantWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantWebhookWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookWhereInput>>;
  /** webhook_event_type edge predicates */
  hasWebhookEventType?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhookEventTypeWith?: InputMaybe<Array<__SHOULD_NOT_USE__WebhookEventTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_enabled field predicates */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_webhook_id field predicates */
  merchantWebhookID?: InputMaybe<Scalars['ID']['input']>;
  merchantWebhookIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantWebhookIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  merchantWebhookIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__MerchantWebhookSubscriptionWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookSubscriptionWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** webhook_event_type_id field predicates */
  webhookEventTypeID?: InputMaybe<Scalars['ID']['input']>;
  webhookEventTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookEventTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  webhookEventTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * MerchantWebhookWhereInput is used for filtering MerchantWebhook objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__MerchantWebhookWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled_at field predicates */
  disabledAt?: InputMaybe<Scalars['Time']['input']>;
  disabledAtGT?: InputMaybe<Scalars['Time']['input']>;
  disabledAtGTE?: InputMaybe<Scalars['Time']['input']>;
  disabledAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disabledAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  disabledAtLT?: InputMaybe<Scalars['Time']['input']>;
  disabledAtLTE?: InputMaybe<Scalars['Time']['input']>;
  disabledAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  disabledAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disabledAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** failure_count field predicates */
  failureCount?: InputMaybe<Scalars['Int']['input']>;
  failureCountGT?: InputMaybe<Scalars['Int']['input']>;
  failureCountGTE?: InputMaybe<Scalars['Int']['input']>;
  failureCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  failureCountLT?: InputMaybe<Scalars['Int']['input']>;
  failureCountLTE?: InputMaybe<Scalars['Int']['input']>;
  failureCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  failureCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** deliveries edge predicates */
  hasDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeliveriesWith?: InputMaybe<Array<__SHOULD_NOT_USE__WebhookDeliveryWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** subscriptions edge predicates */
  hasSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubscriptionsWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookSubscriptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_triggered_at field predicates */
  lastTriggeredAt?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastTriggeredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastTriggeredAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastTriggeredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__MerchantWebhookWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<WebhookStatus>;
  statusIn?: InputMaybe<Array<WebhookStatus>>;
  statusNEQ?: InputMaybe<WebhookStatus>;
  statusNotIn?: InputMaybe<Array<WebhookStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __SHOULD_NOT_USE__MobileCurrencyRangeInput = {
  currency: Currency;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * One currency's header stats. Which money field these aggregate follows the
 * query they came from, so the header always adds up to the rows beneath it:
 * the payer summary uses `amount` (what the payer was charged), the merchant
 * summary uses `netAmount` (what settles to the merchant).
 */
export type __SHOULD_NOT_USE__MobileCurrencyTotal = {
  currency: Currency;
  /** Largest payment amount in this currency (filter-slider upper bound) */
  max: Scalars['Float']['output'];
  /** Smallest payment amount in this currency (filter-slider lower bound) */
  min: Scalars['Float']['output'];
  /** Sum of SUCCEEDED payments in this currency */
  total: Scalars['Float']['output'];
};

export type __SHOULD_NOT_USE__MobileCustomerTxnSummary = {
  refundCount: Scalars['Int']['output'];
  totalsByCurrency: Array<__SHOULD_NOT_USE__MobileCurrencyTotal>;
  transactionCount: Scalars['Int']['output'];
};

/**
 * Flat payload (not the Dispute type): M2M callers carry no org context, so the
 * org-scoped Dispute privacy rules would deny field resolution. Merchant-internal
 * fields (gateway references, evidence, response deadlines) are deliberately
 * excluded from the payer surface.
 */
export type __SHOULD_NOT_USE__MobileDispute = {
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  disputeAmount: Scalars['Float']['output'];
  disputedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** Merchant the disputed payment was made to */
  merchantName: Scalars['String']['output'];
  paymentId: Scalars['ID']['output'];
  progressStatus: DisputeProgressStatus;
  reason: DisputeReason;
  refundId: Maybe<Scalars['ID']['output']>;
  resolutionDate: Maybe<Scalars['Time']['output']>;
  status: DisputeStatus;
  statusUpdatedAt: Maybe<Scalars['Time']['output']>;
};

export type __SHOULD_NOT_USE__MobileDonationOrganization = {
  description: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  industry: Maybe<OrganizationIndustry>;
  name: Scalars['String']['output'];
  quickPayAccessKey: Scalars['String']['output'];
  quickPayCode: Scalars['String']['output'];
};

/** Bucket width for mobileMerchantRevenueSeries. */
export const MobileInsightsBucket = {
  Day: 'DAY',
  Hour: 'HOUR',
  Month: 'MONTH',
  Year: 'YEAR'
} as const;

export type MobileInsightsBucket = typeof MobileInsightsBucket[keyof typeof MobileInsightsBucket];
/** One currency's money total. No FX rates exist in this system, so totals are never converted or summed across currencies. */
export type __SHOULD_NOT_USE__MobileInsightsCurrencyTotal = {
  currency: Currency;
  total: Scalars['Float']['output'];
};

/** One hour of the day-of-week-agnostic activity profile. */
export type __SHOULD_NOT_USE__MobileMerchantActivityHour = {
  /** SUCCEEDED payments that fell in this hour, across every day in the window. */
  count: Scalars['Int']['output'];
  /** Hour of day, 0–23, Asia/Thimphu. */
  hour: Scalars['Int']['output'];
};

/**
 * The window and tag scope shared by every insights query.
 *
 * The mobile backend owns the merchant's spot and category tags — they live in
 * its own database and are invisible here — so it resolves them locally to a
 * set of payment IDs and passes them as paymentIds.
 */
export type __SHOULD_NOT_USE__MobileMerchantInsightsScopeInput = {
  environment?: InputMaybe<PaymentEnvironment>;
  /** Window start, inclusive. Null means unbounded — the org's whole history. */
  from?: InputMaybe<Scalars['Time']['input']>;
  /** The merchant organization. Asserted by the trusted mobile backend from its own validated merchant session. */
  merchantOrgId: Scalars['ID']['input'];
  /**
   * Restrict to these payments. Null or absent means no constraint; an
   * explicitly empty list matches nothing, so a tag filter that resolved to
   * zero payments reports zeros rather than the unfiltered total.
   */
  paymentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Window end, exclusive. Null means unbounded. */
  to?: InputMaybe<Scalars['Time']['input']>;
};

/** Header stats for the merchant Insights screen. */
export type __SHOULD_NOT_USE__MobileMerchantInsightsSummary = {
  /**
   * Distinct non-null customer_id among those payments. Guest and web payments
   * carry no customer row and are not counted at all, so this is a count of
   * known customer records, not of people.
   */
  customerCount: Scalars['Int']['output'];
  /** REFUNDED refunds settled in the window, in their parent payment's currency. Dated by status_updated_at, falling back to created_at — the same instant the feed shows as a refund entry's occurredAt. */
  refundTotalsByCurrency: Array<__SHOULD_NOT_USE__MobileInsightsCurrencyTotal>;
  /** Count of SUCCEEDED payments in the window. */
  salesCount: Scalars['Int']['output'];
  /** SUCCEEDED payments in the window, per currency. Gross — refunds are reported separately and never subtracted. */
  totalsByCurrency: Array<__SHOULD_NOT_USE__MobileInsightsCurrencyTotal>;
};

/** One bucket of the revenue series. */
export type __SHOULD_NOT_USE__MobileMerchantRevenueBucket = {
  /** Bucket start as an absolute instant. The truncation was performed in Asia/Thimphu, so this lands on a Bhutan-local hour/day/month/year boundary. */
  bucketStart: Scalars['Time']['output'];
  /** SUCCEEDED payments in this bucket. */
  salesCount: Scalars['Int']['output'];
  totalsByCurrency: Array<__SHOULD_NOT_USE__MobileInsightsCurrencyTotal>;
};

/**
 * Revenue over time. Only buckets holding at least one payment are returned,
 * ascending by bucketStart — gap-filling belongs to the caller, which is the
 * only side that knows whether an empty bucket should be rendered as a zero
 * (a quiet Tuesday) or omitted (a year before the org existed).
 */
export type __SHOULD_NOT_USE__MobileMerchantRevenueSeries = {
  buckets: Array<__SHOULD_NOT_USE__MobileMerchantRevenueBucket>;
  /** Grand totals for the window. Equals summing the buckets. */
  totalsByCurrency: Array<__SHOULD_NOT_USE__MobileInsightsCurrencyTotal>;
};

export type __SHOULD_NOT_USE__MobileRequestRefundInput = {
  /** Omit for a full refund of the remaining refundable amount */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Mobile backend user UUID — matched against the payment customer's external_id */
  externalId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
  /** Why the payer wants the refund — TipTap doc, rendered in the merchant console */
  reason: Scalars['Map']['input'];
};

/**
 * Flat payload (not the Refund type): M2M callers carry no org context, so the
 * org-scoped Refund privacy rules would deny field resolution.
 */
export type __SHOULD_NOT_USE__MobileRequestRefundPayload = {
  amount: Maybe<Scalars['Float']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  progressStatus: Maybe<RefundProgressStatus>;
  refundCode: Maybe<Scalars['String']['output']>;
  refundId: Maybe<Scalars['ID']['output']>;
  status: Maybe<RefundStatus>;
};

/** A provider-vaulted payment method of a mobile end-user */
export type __SHOULD_NOT_USE__MobileSavedCard = {
  cardBrand: Maybe<Scalars['String']['output']>;
  cardExpMonth: Maybe<Scalars['Int']['output']>;
  cardExpYear: Maybe<Scalars['Int']['output']>;
  cardLast4: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Time']['output']>;
  isDefault: Scalars['Boolean']['output'];
  /** Provider payment method id (e.g. Hyperswitch pm_...) */
  paymentMethodId: Scalars['String']['output'];
  paymentType: PaymentType;
  /** Wallet subtype when paymentType is WALLET: apple_pay | google_pay */
  walletType: Maybe<Scalars['String']['output']>;
};

/**
 * One row of the feed — a payment or a refund, normalized.
 *
 * Three money fields, because the payer and the merchant are owed different
 * numbers for the same payment. `amount` is what the payer was charged
 * (sale + the fee share they bore); `saleAmount` is what the merchant priced
 * the sale at; `netAmount` is what settles to the merchant once the fee share
 * *they* absorbed is taken off. Payer surfaces render `amount`; merchant
 * surfaces render `netAmount` and explain it with `saleAmount` and
 * `merchantProcessingFee`. They coincide whenever the merchant absorbs
 * nothing (merchantProcessingFee = 0), which is the default.
 */
export type __SHOULD_NOT_USE__MobileTxnEntry = {
  /** Charged to the payer: saleAmount plus the processing fee share the payer bore */
  amount: Scalars['Float']['output'];
  currency: Currency;
  /** Raw customer display name (merchant feed callers mask it before display) */
  customerName: Maybe<Scalars['String']['output']>;
  entryType: MobileTxnEntryType;
  id: Scalars['ID']['output'];
  merchantId: Scalars['ID']['output'];
  /** The processing fee share the merchant absorbed; deducted from what settles to them */
  merchantProcessingFee: Scalars['Float']['output'];
  /** Settles to the merchant: saleAmount minus merchantProcessingFee */
  netAmount: Scalars['Float']['output'];
  notes: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['Time']['output'];
  /** The payment's code for PAYMENT entries; the refund's code (fallback: payment code) for REFUND entries */
  paymentCode: Scalars['String']['output'];
  paymentMethodLabel: Maybe<Scalars['String']['output']>;
  relatedPaymentCode: Maybe<Scalars['String']['output']>;
  relatedPaymentId: Maybe<Scalars['ID']['output']>;
  /** The merchant's own price for the sale, before any processing fee moved either way */
  saleAmount: Scalars['Float']['output'];
  /** Verbatim sale basket JSON ([{description, unitPrice, quantity}]) from the payment or its invoice items */
  saleItems: Maybe<Array<Scalars['Map']['output']>>;
  status: MobileTxnStatus;
};

export const MobileTxnEntryType = {
  Payment: 'PAYMENT',
  Refund: 'REFUND'
} as const;

export type MobileTxnEntryType = typeof MobileTxnEntryType[keyof typeof MobileTxnEntryType];
export type __SHOULD_NOT_USE__MobileTxnFilterInput = {
  currencyRanges?: InputMaybe<Array<__SHOULD_NOT_USE__MobileCurrencyRangeInput>>;
  /** Fetch specific entries by their own IDs (payment or refund IDs) — detail lookups */
  entryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entryTypes?: InputMaybe<Array<MobileTxnEntryType>>;
  environment?: InputMaybe<PaymentEnvironment>;
  /** Drop these payment IDs (mobile's hidden rows); refund entries follow their parent payment */
  excludePaymentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to these payment IDs (mobile's onlyShared filter) */
  includePaymentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Narrow to specific merchant organizations (mobile resolves category/search chips to these) */
  merchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free text — matched against payment code and exact amount */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Merchant organizations whose display name matched the search on the mobile
   * side; entries of these merchants match the search too (OR with code/amount).
   * Ignored when search is empty.
   */
  searchMerchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<MobileTxnStatus>>;
};

/** Offset-paginated page. Offset pagination is deliberate: the feed interleaves two tables. */
export type __SHOULD_NOT_USE__MobileTxnList = {
  entries: Array<__SHOULD_NOT_USE__MobileTxnEntry>;
  totalCount: Scalars['Int']['output'];
};

export const MobileTxnOrder = {
  AmountAsc: 'AMOUNT_ASC',
  AmountDesc: 'AMOUNT_DESC',
  MostRecent: 'MOST_RECENT'
} as const;

export type MobileTxnOrder = typeof MobileTxnOrder[keyof typeof MobileTxnOrder];
export const MobileTxnStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Pending: 'PENDING',
  Refunded: 'REFUNDED'
} as const;

export type MobileTxnStatus = typeof MobileTxnStatus[keyof typeof MobileTxnStatus];
export type __SHOULD_NOT_USE__Mutation = {
  CancelApiPayment: Maybe<__SHOULD_NOT_USE__CancelApiPaymentPayload>;
  acceptAllRequiredUserPolicies: Maybe<__SHOULD_NOT_USE__AcceptAllRequiredUserPoliciesPayload>;
  acceptDispute: Maybe<__SHOULD_NOT_USE__AcceptDisputePayload>;
  acceptInvitation: __SHOULD_NOT_USE__AcceptInvitationPayload;
  acceptPolicy: Maybe<__SHOULD_NOT_USE__AcceptPolicyPayload>;
  acceptUserPolicy: Maybe<__SHOULD_NOT_USE__AcceptUserPolicyPayload>;
  activateAPIKey: Maybe<__SHOULD_NOT_USE__ActivateApiKeyPayload>;
  activateQuickPay: __SHOULD_NOT_USE__ActivateQuickPayPayload;
  addCardTypeToProvider: __SHOULD_NOT_USE__AddCardTypeToProviderPayload;
  addLineItem: __SHOULD_NOT_USE__AddLineItemPayload;
  addMerchantBankAccount: Maybe<__SHOULD_NOT_USE__AddMerchantBankAccountPayload>;
  addPaymentTypeToProvider: __SHOULD_NOT_USE__AddPaymentTypeToProviderPayload;
  addPayoutsToTransfer: Maybe<__SHOULD_NOT_USE__AddPayoutsToTransferPayload>;
  addServiceAccountWebhookSubscriptions: __SHOULD_NOT_USE__AddServiceAccountWebhookSubscriptionsPayload;
  addWebhookSubscriptions: __SHOULD_NOT_USE__AddWebhookSubscriptionsPayload;
  approveBankAccount: Maybe<__SHOULD_NOT_USE__ApproveBankAccountPayload>;
  approveRefund: Maybe<__SHOULD_NOT_USE__ApproveRefundPayload>;
  archiveQuickPay: __SHOULD_NOT_USE__ArchiveQuickPayPayload;
  assignRoleToUser: Maybe<__SHOULD_NOT_USE__AssignRolePayload>;
  bankApproveRefund: Maybe<__SHOULD_NOT_USE__BankApproveRefundPayload>;
  bankDenyRefund: Maybe<__SHOULD_NOT_USE__BankDenyRefundPayload>;
  batchProcessPayouts: Maybe<__SHOULD_NOT_USE__BatchProcessPayoutsPayload>;
  cancelPayout: Maybe<__SHOULD_NOT_USE__CancelPayoutPayload>;
  cancelRecurringPayment: Maybe<__SHOULD_NOT_USE__CancelRecurringPaymentPayload>;
  cancelRecurringPaymentSetup: __SHOULD_NOT_USE__CancelRecurringPaymentSetupPayload;
  cancelRefund: Maybe<__SHOULD_NOT_USE__CancelRefundPayload>;
  changePassword: __SHOULD_NOT_USE__ChangePasswordPayload;
  closeBankAccount: Maybe<__SHOULD_NOT_USE__CloseBankAccountPayload>;
  completePayouts: Maybe<__SHOULD_NOT_USE__CompletePayoutPayload>;
  completeTransfer: Maybe<__SHOULD_NOT_USE__CompleteTransferPayload>;
  createApiPaymentIntent: __SHOULD_NOT_USE__CreatePaymentIntentPayload;
  createBillingAddress: __SHOULD_NOT_USE__CreateBillingAddressPayload;
  createDispute: Maybe<__SHOULD_NOT_USE__CreateDisputePayload>;
  createInvoice: Maybe<__SHOULD_NOT_USE__CreateInvoicePayload>;
  createMedia: __SHOULD_NOT_USE__Media;
  createMediaBulk: Array<__SHOULD_NOT_USE__Media>;
  createMerchantWebhook: __SHOULD_NOT_USE__CreateMerchantWebhookPayload;
  /** Create a zero-amount setup intent to add a card from the mobile wallet (service-account only) */
  createMobileCardSetupIntent: __SHOULD_NOT_USE__CreateMobileCardSetupIntentPayload;
  createOrganization: __SHOULD_NOT_USE__CreateOrganizationPayload;
  createOrganizationPaymentType: __SHOULD_NOT_USE__CreateOrganizationPaymentTypePayload;
  createPaymentIntent: __SHOULD_NOT_USE__CreatePaymentIntentPayload;
  /**
   * Generate a secure update session for a recurring payment.
   * Called by merchant dashboard or triggered automatically on payment failure.
   * Requires auth + recurringpayment.manage permission.
   */
  createPaymentMethodUpdateSession: __SHOULD_NOT_USE__CreatePaymentMethodUpdateSessionPayload;
  createPaymentProvider: __SHOULD_NOT_USE__CreatePaymentProviderPayload;
  createPolicyDocument: Maybe<__SHOULD_NOT_USE__CreatePolicyDocumentPayload>;
  createPolicyDocumentVersion: Maybe<__SHOULD_NOT_USE__CreatePolicyDocumentVersionPayload>;
  createPolicyTemplate: Maybe<__SHOULD_NOT_USE__CreatePolicyTemplatePayload>;
  createQuickPay: __SHOULD_NOT_USE__CreateQuickPayPayload;
  createQuickPayPaymentIntent: __SHOULD_NOT_USE__CreatePaymentIntentPayload;
  createRecurringPayment: __SHOULD_NOT_USE__CreateRecurringPaymentPayload;
  createRefund: Maybe<__SHOULD_NOT_USE__CreateRefundPayload>;
  createRole: Maybe<__SHOULD_NOT_USE__CreateRolePayload>;
  createServiceAccountWebhook: __SHOULD_NOT_USE__CreateServiceAccountWebhookPayload;
  createSetupIntent: __SHOULD_NOT_USE__CreateSetupIntentPayload;
  createTransfer: Maybe<__SHOULD_NOT_USE__CreateTransferPayload>;
  /**
   * Create a setup intent for the update payment method page.
   * No auth required — validated via update_session_id.
   */
  createUpdateSetupIntent: __SHOULD_NOT_USE__CreateSetupIntentPayload;
  deactivateAPIKey: Maybe<__SHOULD_NOT_USE__DeactivateApiKeyPayload>;
  /**
   * Returns the organization's default quickpay (backs the merchant's static QR),
   * creating it on first call. Idempotent.
   */
  defaultQuickPay: __SHOULD_NOT_USE__DefaultQuickPayPayload;
  deleteAPIKey: Maybe<__SHOULD_NOT_USE__DeleteApiKeyPayload>;
  deleteBankAccount: Maybe<__SHOULD_NOT_USE__DeleteBankAccountPayload>;
  deleteCardType: __SHOULD_NOT_USE__DeleteCardTypePayload;
  deleteLineItem: __SHOULD_NOT_USE__DeleteLineItemPayload;
  deleteMedia: Scalars['Boolean']['output'];
  /** Delete one of a mobile user's saved cards (service-account only) */
  deleteMobileSavedCard: Scalars['Boolean']['output'];
  deleteOrganization: __SHOULD_NOT_USE__DeleteOrganizationPayload;
  deleteOrganizationPaymentType: __SHOULD_NOT_USE__DeleteOrganizationPaymentTypePayload;
  deletePaymentProvider: __SHOULD_NOT_USE__DeletePaymentProviderPayload;
  deletePaymentType: __SHOULD_NOT_USE__DeletePaymentTypePayload;
  deletePayout: Maybe<__SHOULD_NOT_USE__DeletePayoutPayload>;
  deletePolicyDocument: __SHOULD_NOT_USE__DeletePolicyDocumentPayload;
  deletePolicyTemplate: Maybe<__SHOULD_NOT_USE__DeletePolicyTemplatePayload>;
  deleteRole: Maybe<__SHOULD_NOT_USE__DeleteRolePayload>;
  deleteTransfer: Maybe<__SHOULD_NOT_USE__DeleteTransferPayload>;
  deleteUser: __SHOULD_NOT_USE__DeleteUserPayload;
  denyRefund: Maybe<__SHOULD_NOT_USE__DenyRefundPayload>;
  deprecatePolicyDocument: __SHOULD_NOT_USE__DeprecatePolicyDocumentPayload;
  detachPaymentMethod: Scalars['Boolean']['output'];
  downloadPaidApiPaymentReceipt: __SHOULD_NOT_USE__DownloadPaidApiPaymentReceipt;
  downloadPaidInvoiceReceipt: __SHOULD_NOT_USE__DownloadPaidInvoiceReceipt;
  downloadTransferReceipt: __SHOULD_NOT_USE__DownloadTransferReceipt;
  downloadUnpaidApiPaymentReceipt: __SHOULD_NOT_USE__DownloadUnpaidApiPaymentReceipt;
  downloadUnpaidInvoiceReceipt: __SHOULD_NOT_USE__DownloadUnpaidInvoiceReceipt;
  expireDispute: Maybe<__SHOULD_NOT_USE__ExpireDisputePayload>;
  flagPayment: __SHOULD_NOT_USE__FlagPaymentPayload;
  generateAPIKey: Maybe<__SHOULD_NOT_USE__GenerateApiKeyPayload>;
  generateInvoicePdf: __SHOULD_NOT_USE__GenerateInvoicePdfPayload;
  generateTransferPdf: __SHOULD_NOT_USE__GenerateTransferPdfPayload;
  grantPermissionToRole: Maybe<__SHOULD_NOT_USE__GrantPermissionPayload>;
  grantPermissionsToRole: Maybe<__SHOULD_NOT_USE__GrantPermissionsPayload>;
  initQuickPayment: __SHOULD_NOT_USE__InitQuickPaymentPayload;
  /** Invite a user into a bank organization (platform admin only) */
  inviteBankUser: __SHOULD_NOT_USE__InviteUserPayload;
  inviteUser: __SHOULD_NOT_USE__InviteUserPayload;
  login: Maybe<__SHOULD_NOT_USE__LoginPayload>;
  manualProcessRefund: Maybe<__SHOULD_NOT_USE__ManualProcessRefundPayload>;
  manuallyApproveInvoice: __SHOULD_NOT_USE__ManuallyApproveInvoicePayload;
  /** Payer-initiated refund request from the mobile app. Service-account only. */
  mobileRequestRefund: __SHOULD_NOT_USE__MobileRequestRefundPayload;
  /** Onboard a BANK organization with its owner user (platform admin only) */
  onboardBank: __SHOULD_NOT_USE__OnboardBankPayload;
  onboardOrganization: __SHOULD_NOT_USE__CreateOrganizationPayload;
  pauseQuickPay: __SHOULD_NOT_USE__PauseQuickPayPayload;
  pauseRecurringPayment: Maybe<__SHOULD_NOT_USE__PauseRecurringPaymentPayload>;
  platformAdminSignIn: Maybe<__SHOULD_NOT_USE__LoginPayload>;
  processApiPayment: __SHOULD_NOT_USE__ProcessApiPaymentPayload;
  processInvoicePayment: __SHOULD_NOT_USE__ProcessInvoicePaymentPayload;
  processQuickPayPayment: __SHOULD_NOT_USE__ProcessQuickPayPaymentPayload;
  processRefund: Maybe<__SHOULD_NOT_USE__ProcessRefundPayload>;
  recordDisputeWithdrawal: Maybe<__SHOULD_NOT_USE__RecordDisputeWithdrawalPayload>;
  refreshToken: Maybe<__SHOULD_NOT_USE__RefreshTokenPayload>;
  reinstateBankAccount: Maybe<__SHOULD_NOT_USE__ReinstateBankAccountPayload>;
  rejectBankAccount: Maybe<__SHOULD_NOT_USE__RejectBankAccountPayload>;
  rejectRefund: Maybe<__SHOULD_NOT_USE__RejectRefundPayload>;
  removeDefaultPolicy: Maybe<__SHOULD_NOT_USE__RemoveDefaultPolicyPayload>;
  removePayoutsFromTransfer: Maybe<__SHOULD_NOT_USE__RemovePayoutsFromTransferPayload>;
  removeServiceAccountWebhookSubscriptions: __SHOULD_NOT_USE__RemoveServiceAccountWebhookSubscriptionsPayload;
  removeWebhookSubscriptions: __SHOULD_NOT_USE__RemoveWebhookSubscriptionsPayload;
  reorderLineItems: __SHOULD_NOT_USE__ReorderLineItemsPayload;
  requestEmailVerificationOTP: __SHOULD_NOT_USE__RequestOtpPayload;
  requestLoginOTP: __SHOULD_NOT_USE__RequestOtpPayload;
  requestMagicLink: __SHOULD_NOT_USE__RequestMagicLinkPayload;
  requestPasswordReset: __SHOULD_NOT_USE__RequestPasswordResetPayload;
  requestPasswordResetOTP: __SHOULD_NOT_USE__RequestOtpPayload;
  resendEmailVerification: Maybe<__SHOULD_NOT_USE__ResendEmailVerificationPayload>;
  resendInvitation: __SHOULD_NOT_USE__ResendInvitationPayload;
  resetPassword: __SHOULD_NOT_USE__ResetPasswordPayload;
  resetPasswordWithOTP: __SHOULD_NOT_USE__AuthPayload;
  resolveDispute: Maybe<__SHOULD_NOT_USE__ResolveDisputePayload>;
  restoreOrganization: __SHOULD_NOT_USE__RestoreOrganizationPayload;
  restorePermissionToRole: Maybe<__SHOULD_NOT_USE__RestorePermissionPayload>;
  resumeRecurringPayment: Maybe<__SHOULD_NOT_USE__ResumeRecurringPaymentPayload>;
  retryWebhookDelivery: __SHOULD_NOT_USE__RetryWebhookDeliveryPayload;
  revokePermissionFromRole: Maybe<__SHOULD_NOT_USE__RevokePermissionPayload>;
  rotateServiceAccountWebhookSecret: __SHOULD_NOT_USE__RotateServiceAccountWebhookSecretPayload;
  savePaymentMethod: __SHOULD_NOT_USE__SavePaymentMethodPayload;
  sendDisputeReceivedMerchantNotification: Scalars['Boolean']['output'];
  sendInvoiceEmail: __SHOULD_NOT_USE__SendInvoiceEmailPayload;
  /**
   * Replaces the payment channels a BANK organization settles. Admin-only;
   * a merchant must never be able to grant its banks new channels.
   */
  setBankSupportedChannels: __SHOULD_NOT_USE__SetBankSupportedChannelsPayload;
  setDefaultPaymentMethod: __SHOULD_NOT_USE__PaymentMethod;
  setDefaultPolicy: Maybe<__SHOULD_NOT_USE__SetDefaultPolicyPayload>;
  /**
   * Toggles whether a MERCHANT organization may be listed as a donation
   * recipient in the payer app. Platform/bank-admin only; a merchant must
   * never be able to grant itself donation eligibility.
   *
   * Enabling guarantees the merchant is payable: their default QuickPay
   * (static QR) is created when missing, gated on an ACTIVE org and an
   * APPROVED bank account — the toggle fails with
   * MERCHANT_BANK_ACCOUNT_NOT_CONFIGURED / FORBIDDEN instead of listing an
   * unpayable merchant.
   */
  setOrganizationDonationEligibility: __SHOULD_NOT_USE__SetOrganizationDonationEligibilityPayload;
  setPrimaryBankAccount: Maybe<__SHOULD_NOT_USE__SetPrimaryBankAccountPayload>;
  signUpUser: __SHOULD_NOT_USE__SignUpUserPayload;
  splitPayout: Maybe<__SHOULD_NOT_USE__SplitPayoutPayload>;
  submitDisputeEvidence: Maybe<__SHOULD_NOT_USE__SubmitDisputeEvidencePayload>;
  submitTransfer: Maybe<__SHOULD_NOT_USE__SubmitTransferPayload>;
  suspendBankAccount: Maybe<__SHOULD_NOT_USE__SuspendBankAccountPayload>;
  syncRolePermissions: Maybe<__SHOULD_NOT_USE__SyncRolePermissionsPayload>;
  unassignRoleFromUser: Maybe<__SHOULD_NOT_USE__UnassignRolePayload>;
  unflagPayment: __SHOULD_NOT_USE__UnflagPaymentPayload;
  updateAPIKey: Maybe<__SHOULD_NOT_USE__UpdateApiKeyPayload>;
  updateBankAccountDetails: Maybe<__SHOULD_NOT_USE__UpdateBankAccountDetailsPayload>;
  updateBillingAddress: __SHOULD_NOT_USE__UpdateBillingAddressPayload;
  updateBusiness: __SHOULD_NOT_USE__UpdateOrganizationPayload;
  updateCardType: __SHOULD_NOT_USE__UpdateCardTypePayload;
  updateDisputeProgress: Maybe<__SHOULD_NOT_USE__UpdateDisputeProgressPayload>;
  updateInvoice: __SHOULD_NOT_USE__UpdateInvoicePayload;
  updateLineItem: __SHOULD_NOT_USE__UpdateLineItemPayload;
  updateMedia: __SHOULD_NOT_USE__Media;
  updateMerchantWebhook: __SHOULD_NOT_USE__UpdateMerchantWebhookPayload;
  updateOrganization: __SHOULD_NOT_USE__UpdateOrganizationPayload;
  updateOrganizationPaymentType: __SHOULD_NOT_USE__UpdateOrganizationPaymentTypePayload;
  updateOrganizationStatus: __SHOULD_NOT_USE__UpdateOrganizationStatusPayload;
  updatePaymentProvider: __SHOULD_NOT_USE__UpdatePaymentProviderPayload;
  updatePaymentType: __SHOULD_NOT_USE__UpdatePaymentTypePayload;
  updatePermissionGroup: __SHOULD_NOT_USE__UpdatePermissionGroupPayload;
  updatePolicyDocument: Maybe<__SHOULD_NOT_USE__UpdatePolicyDocumentPayload>;
  updatePolicyTemplate: Maybe<__SHOULD_NOT_USE__UpdatePolicyTemplatePayload>;
  updateQuickPay: __SHOULD_NOT_USE__UpdateQuickPayPayload;
  updateRecurringPayment: __SHOULD_NOT_USE__UpdateRecurringPaymentPayload;
  /**
   * Save the new payment method and swap it on the recurring payment.
   * No auth required — validated via update_session_id.
   */
  updateRecurringPaymentMethod: __SHOULD_NOT_USE__UpdateRecurringPaymentMethodPayload;
  updateRefund: Maybe<__SHOULD_NOT_USE__UpdateRefundPayload>;
  updateRole: Maybe<__SHOULD_NOT_USE__UpdateRolePayload>;
  updateServiceAccountWebhook: __SHOULD_NOT_USE__UpdateServiceAccountWebhookPayload;
  updateServiceAccountWebhookSubscription: __SHOULD_NOT_USE__UpdateServiceAccountWebhookSubscriptionPayload;
  updateTransferNotes: Maybe<__SHOULD_NOT_USE__UpdateTransferNotesPayload>;
  updateUserProfile: __SHOULD_NOT_USE__UpdateUserProfilePayload;
  updateUserStatus: __SHOULD_NOT_USE__UpdateUserStatusPayload;
  updateWebhookSubscription: __SHOULD_NOT_USE__UpdateWebhookSubscriptionPayload;
  verifyBankAccount: Maybe<__SHOULD_NOT_USE__VerifyBankAccountPayload>;
  verifyEmail: __SHOULD_NOT_USE__VerifyEmailPayload;
  verifyEmailWithOTP: __SHOULD_NOT_USE__AuthPayload;
  verifyLoginOTP: __SHOULD_NOT_USE__AuthPayload;
  verifyMagicLink: __SHOULD_NOT_USE__VerifyMagicLinkPayload;
  verifyOTP: __SHOULD_NOT_USE__VerifyOtpPayload;
  voidInvoice: __SHOULD_NOT_USE__VoidInvoicePayload;
};


export type __SHOULD_NOT_USE__MutationCancelApiPaymentArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationAcceptDisputeArgs = {
  input: __SHOULD_NOT_USE__AcceptDisputeInput;
};


export type __SHOULD_NOT_USE__MutationAcceptInvitationArgs = {
  input: __SHOULD_NOT_USE__AcceptInvitationInput;
};


export type __SHOULD_NOT_USE__MutationAcceptPolicyArgs = {
  input: __SHOULD_NOT_USE__AcceptPolicyInput;
};


export type __SHOULD_NOT_USE__MutationAcceptUserPolicyArgs = {
  input: __SHOULD_NOT_USE__AcceptUserPolicyInput;
};


export type __SHOULD_NOT_USE__MutationActivateApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationActivateQuickPayArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationAddCardTypeToProviderArgs = {
  input: __SHOULD_NOT_USE__AddCardTypeInput;
};


export type __SHOULD_NOT_USE__MutationAddLineItemArgs = {
  input: __SHOULD_NOT_USE__AddLineItemInput;
  invoiceId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationAddMerchantBankAccountArgs = {
  input: __SHOULD_NOT_USE__AddMerchantBankAccountInput;
};


export type __SHOULD_NOT_USE__MutationAddPaymentTypeToProviderArgs = {
  input: __SHOULD_NOT_USE__AddPaymentTypeInput;
};


export type __SHOULD_NOT_USE__MutationAddPayoutsToTransferArgs = {
  input: __SHOULD_NOT_USE__AddPayoutsToTransferInput;
};


export type __SHOULD_NOT_USE__MutationAddServiceAccountWebhookSubscriptionsArgs = {
  input: __SHOULD_NOT_USE__AddServiceAccountWebhookSubscriptionsInput;
};


export type __SHOULD_NOT_USE__MutationAddWebhookSubscriptionsArgs = {
  input: __SHOULD_NOT_USE__AddWebhookSubscriptionsInput;
};


export type __SHOULD_NOT_USE__MutationApproveBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type __SHOULD_NOT_USE__MutationApproveRefundArgs = {
  input: __SHOULD_NOT_USE__ApproveRefundInput;
};


export type __SHOULD_NOT_USE__MutationArchiveQuickPayArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationAssignRoleToUserArgs = {
  input: __SHOULD_NOT_USE__AssignRoleInput;
};


export type __SHOULD_NOT_USE__MutationBankApproveRefundArgs = {
  input: __SHOULD_NOT_USE__BankApproveRefundInput;
};


export type __SHOULD_NOT_USE__MutationBankDenyRefundArgs = {
  input: __SHOULD_NOT_USE__BankDenyRefundInput;
};


export type __SHOULD_NOT_USE__MutationBatchProcessPayoutsArgs = {
  input: __SHOULD_NOT_USE__BatchProcessPayoutsInput;
};


export type __SHOULD_NOT_USE__MutationCancelPayoutArgs = {
  input: __SHOULD_NOT_USE__CancelPayoutInput;
};


export type __SHOULD_NOT_USE__MutationCancelRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationCancelRecurringPaymentSetupArgs = {
  input: __SHOULD_NOT_USE__CancelRecurringPaymentSetupInput;
};


export type __SHOULD_NOT_USE__MutationCancelRefundArgs = {
  input: __SHOULD_NOT_USE__CancelRefundInput;
};


export type __SHOULD_NOT_USE__MutationChangePasswordArgs = {
  input: __SHOULD_NOT_USE__ChangePasswordInput;
};


export type __SHOULD_NOT_USE__MutationCloseBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type __SHOULD_NOT_USE__MutationCompletePayoutsArgs = {
  input: __SHOULD_NOT_USE__CompletePayoutInput;
};


export type __SHOULD_NOT_USE__MutationCompleteTransferArgs = {
  input: __SHOULD_NOT_USE__CompleteTransferInput;
};


export type __SHOULD_NOT_USE__MutationCreateApiPaymentIntentArgs = {
  input: __SHOULD_NOT_USE__CreateApiPaymentIntentInput;
};


export type __SHOULD_NOT_USE__MutationCreateBillingAddressArgs = {
  input: __SHOULD_NOT_USE__CreateBillingAddressInput;
};


export type __SHOULD_NOT_USE__MutationCreateDisputeArgs = {
  input: __SHOULD_NOT_USE__CreateDisputeInput;
};


export type __SHOULD_NOT_USE__MutationCreateInvoiceArgs = {
  input: __SHOULD_NOT_USE__CreateInvoiceInput;
};


export type __SHOULD_NOT_USE__MutationCreateMediaArgs = {
  input: __SHOULD_NOT_USE__CreateMediaInput;
};


export type __SHOULD_NOT_USE__MutationCreateMediaBulkArgs = {
  input: Array<__SHOULD_NOT_USE__CreateMediaInput>;
};


export type __SHOULD_NOT_USE__MutationCreateMerchantWebhookArgs = {
  input: __SHOULD_NOT_USE__CreateMerchantWebhookInput;
};


export type __SHOULD_NOT_USE__MutationCreateMobileCardSetupIntentArgs = {
  input: __SHOULD_NOT_USE__CreateMobileCardSetupIntentInput;
};


export type __SHOULD_NOT_USE__MutationCreateOrganizationArgs = {
  input: __SHOULD_NOT_USE__CreateOrganizationInput;
};


export type __SHOULD_NOT_USE__MutationCreateOrganizationPaymentTypeArgs = {
  input: __SHOULD_NOT_USE__CreateOrganizationPaymentTypeInput;
};


export type __SHOULD_NOT_USE__MutationCreatePaymentIntentArgs = {
  input: __SHOULD_NOT_USE__CreatePaymentIntentInput;
};


export type __SHOULD_NOT_USE__MutationCreatePaymentMethodUpdateSessionArgs = {
  input: __SHOULD_NOT_USE__CreatePaymentMethodUpdateSessionInput;
};


export type __SHOULD_NOT_USE__MutationCreatePaymentProviderArgs = {
  input: __SHOULD_NOT_USE__CreatePaymentProviderInput;
};


export type __SHOULD_NOT_USE__MutationCreatePolicyDocumentArgs = {
  input: __SHOULD_NOT_USE__CreatePolicyDocumentInput;
};


export type __SHOULD_NOT_USE__MutationCreatePolicyDocumentVersionArgs = {
  input: __SHOULD_NOT_USE__CreatePolicyDocumentVersionInput;
};


export type __SHOULD_NOT_USE__MutationCreatePolicyTemplateArgs = {
  input: __SHOULD_NOT_USE__CreatePolicyTemplateInput;
};


export type __SHOULD_NOT_USE__MutationCreateQuickPayArgs = {
  input: __SHOULD_NOT_USE__CreateQuickPayInput;
};


export type __SHOULD_NOT_USE__MutationCreateQuickPayPaymentIntentArgs = {
  input: __SHOULD_NOT_USE__CreateQuickPayPaymentIntentInput;
};


export type __SHOULD_NOT_USE__MutationCreateRecurringPaymentArgs = {
  input: __SHOULD_NOT_USE__CreateRecurringPaymentInput;
};


export type __SHOULD_NOT_USE__MutationCreateRefundArgs = {
  input: __SHOULD_NOT_USE__CreateRefundInput;
};


export type __SHOULD_NOT_USE__MutationCreateRoleArgs = {
  input: __SHOULD_NOT_USE__CreateRoleInput;
};


export type __SHOULD_NOT_USE__MutationCreateServiceAccountWebhookArgs = {
  input: __SHOULD_NOT_USE__CreateServiceAccountWebhookInput;
};


export type __SHOULD_NOT_USE__MutationCreateSetupIntentArgs = {
  input: __SHOULD_NOT_USE__CreateSetupIntentInput;
};


export type __SHOULD_NOT_USE__MutationCreateTransferArgs = {
  input: __SHOULD_NOT_USE__CreateTransferInput;
};


export type __SHOULD_NOT_USE__MutationCreateUpdateSetupIntentArgs = {
  input: __SHOULD_NOT_USE__CreateUpdateSetupIntentInput;
};


export type __SHOULD_NOT_USE__MutationDeactivateApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteCardTypeArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteLineItemArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteMediaArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteMobileSavedCardArgs = {
  customerRef: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteOrganizationPaymentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeletePaymentProviderArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeletePaymentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeletePayoutArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeletePolicyDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeletePolicyTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteTransferArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDenyRefundArgs = {
  input: __SHOULD_NOT_USE__DenyRefundInput;
};


export type __SHOULD_NOT_USE__MutationDeprecatePolicyDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDetachPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDownloadPaidApiPaymentReceiptArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationDownloadPaidInvoiceReceiptArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationDownloadTransferReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationDownloadUnpaidApiPaymentReceiptArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationDownloadUnpaidInvoiceReceiptArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationExpireDisputeArgs = {
  input: __SHOULD_NOT_USE__ExpireDisputeInput;
};


export type __SHOULD_NOT_USE__MutationFlagPaymentArgs = {
  input: __SHOULD_NOT_USE__FlagPaymentInput;
};


export type __SHOULD_NOT_USE__MutationGenerateApiKeyArgs = {
  input: __SHOULD_NOT_USE__GenerateApiKeyInput;
};


export type __SHOULD_NOT_USE__MutationGenerateInvoicePdfArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationGenerateTransferPdfArgs = {
  transferId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationGrantPermissionToRoleArgs = {
  input: __SHOULD_NOT_USE__GrantPermissionInput;
};


export type __SHOULD_NOT_USE__MutationGrantPermissionsToRoleArgs = {
  input: __SHOULD_NOT_USE__GrantPermissionsInput;
};


export type __SHOULD_NOT_USE__MutationInitQuickPaymentArgs = {
  input: __SHOULD_NOT_USE__InitQuickPaymentInput;
};


export type __SHOULD_NOT_USE__MutationInviteBankUserArgs = {
  input: __SHOULD_NOT_USE__InviteBankUserInput;
};


export type __SHOULD_NOT_USE__MutationInviteUserArgs = {
  input: __SHOULD_NOT_USE__InviteUserInput;
};


export type __SHOULD_NOT_USE__MutationLoginArgs = {
  input: __SHOULD_NOT_USE__LoginInput;
};


export type __SHOULD_NOT_USE__MutationManualProcessRefundArgs = {
  input: __SHOULD_NOT_USE__ManualProcessRefundInput;
};


export type __SHOULD_NOT_USE__MutationManuallyApproveInvoiceArgs = {
  input: __SHOULD_NOT_USE__ManuallyApproveInvoiceInput;
};


export type __SHOULD_NOT_USE__MutationMobileRequestRefundArgs = {
  input: __SHOULD_NOT_USE__MobileRequestRefundInput;
};


export type __SHOULD_NOT_USE__MutationOnboardBankArgs = {
  input: __SHOULD_NOT_USE__OnboardBankInput;
};


export type __SHOULD_NOT_USE__MutationOnboardOrganizationArgs = {
  input: __SHOULD_NOT_USE__OnboardOrganizationInput;
};


export type __SHOULD_NOT_USE__MutationPauseQuickPayArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationPauseRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationPlatformAdminSignInArgs = {
  input: __SHOULD_NOT_USE__LoginInput;
};


export type __SHOULD_NOT_USE__MutationProcessApiPaymentArgs = {
  input: __SHOULD_NOT_USE__ProcessApiPaymentInput;
};


export type __SHOULD_NOT_USE__MutationProcessInvoicePaymentArgs = {
  input: __SHOULD_NOT_USE__ProcessInvoicePaymentInput;
};


export type __SHOULD_NOT_USE__MutationProcessQuickPayPaymentArgs = {
  input: __SHOULD_NOT_USE__ProcessQuickPayPaymentInput;
};


export type __SHOULD_NOT_USE__MutationProcessRefundArgs = {
  input: __SHOULD_NOT_USE__ProcessRefundInput;
};


export type __SHOULD_NOT_USE__MutationRecordDisputeWithdrawalArgs = {
  input: __SHOULD_NOT_USE__RecordDisputeWithdrawalInput;
};


export type __SHOULD_NOT_USE__MutationRefreshTokenArgs = {
  input: __SHOULD_NOT_USE__RefreshTokenInput;
};


export type __SHOULD_NOT_USE__MutationReinstateBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type __SHOULD_NOT_USE__MutationRejectBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationRejectRefundArgs = {
  input: __SHOULD_NOT_USE__RejectRefundInput;
};


export type __SHOULD_NOT_USE__MutationRemoveDefaultPolicyArgs = {
  policyType: PolicyType;
};


export type __SHOULD_NOT_USE__MutationRemovePayoutsFromTransferArgs = {
  input: __SHOULD_NOT_USE__RemovePayoutsFromTransferInput;
};


export type __SHOULD_NOT_USE__MutationRemoveServiceAccountWebhookSubscriptionsArgs = {
  input: __SHOULD_NOT_USE__RemoveServiceAccountWebhookSubscriptionsInput;
};


export type __SHOULD_NOT_USE__MutationRemoveWebhookSubscriptionsArgs = {
  input: __SHOULD_NOT_USE__RemoveWebhookSubscriptionsInput;
};


export type __SHOULD_NOT_USE__MutationReorderLineItemsArgs = {
  input: __SHOULD_NOT_USE__ReorderLineItemsInput;
};


export type __SHOULD_NOT_USE__MutationRequestEmailVerificationOtpArgs = {
  input: __SHOULD_NOT_USE__RequestEmailVerificationOtpInput;
};


export type __SHOULD_NOT_USE__MutationRequestLoginOtpArgs = {
  input: __SHOULD_NOT_USE__RequestLoginOtpInput;
};


export type __SHOULD_NOT_USE__MutationRequestMagicLinkArgs = {
  input: __SHOULD_NOT_USE__RequestMagicLinkInput;
};


export type __SHOULD_NOT_USE__MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationRequestPasswordResetOtpArgs = {
  input: __SHOULD_NOT_USE__RequestPasswordResetOtpInput;
};


export type __SHOULD_NOT_USE__MutationResendEmailVerificationArgs = {
  input: __SHOULD_NOT_USE__ResendEmailVerificationInput;
};


export type __SHOULD_NOT_USE__MutationResendInvitationArgs = {
  userId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationResetPasswordArgs = {
  input: __SHOULD_NOT_USE__ResetPasswordInput;
};


export type __SHOULD_NOT_USE__MutationResetPasswordWithOtpArgs = {
  input: __SHOULD_NOT_USE__ResetPasswordWithOtpInput;
};


export type __SHOULD_NOT_USE__MutationResolveDisputeArgs = {
  input: __SHOULD_NOT_USE__ResolveDisputeInput;
};


export type __SHOULD_NOT_USE__MutationRestoreOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationRestorePermissionToRoleArgs = {
  input: __SHOULD_NOT_USE__RestorePermissionInput;
};


export type __SHOULD_NOT_USE__MutationResumeRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationRetryWebhookDeliveryArgs = {
  input: __SHOULD_NOT_USE__RetryWebhookDeliveryInput;
};


export type __SHOULD_NOT_USE__MutationRevokePermissionFromRoleArgs = {
  input: __SHOULD_NOT_USE__RevokePermissionInput;
};


export type __SHOULD_NOT_USE__MutationRotateServiceAccountWebhookSecretArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationSavePaymentMethodArgs = {
  input: __SHOULD_NOT_USE__SavePaymentMethodInput;
};


export type __SHOULD_NOT_USE__MutationSendDisputeReceivedMerchantNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationSendInvoiceEmailArgs = {
  input: __SHOULD_NOT_USE__SendInvoiceEmailInput;
};


export type __SHOULD_NOT_USE__MutationSetBankSupportedChannelsArgs = {
  bankId: Scalars['ID']['input'];
  channels: Array<PaymentChannel>;
};


export type __SHOULD_NOT_USE__MutationSetDefaultPaymentMethodArgs = {
  customerID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationSetDefaultPolicyArgs = {
  input: __SHOULD_NOT_USE__SetDefaultPolicyInput;
};


export type __SHOULD_NOT_USE__MutationSetOrganizationDonationEligibilityArgs = {
  canReceiveDonation: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationSetPrimaryBankAccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__MutationSignUpUserArgs = {
  input: __SHOULD_NOT_USE__SignUpUserInput;
};


export type __SHOULD_NOT_USE__MutationSplitPayoutArgs = {
  input: __SHOULD_NOT_USE__SplitPayoutInput;
};


export type __SHOULD_NOT_USE__MutationSubmitDisputeEvidenceArgs = {
  input: __SHOULD_NOT_USE__SubmitDisputeEvidenceInput;
};


export type __SHOULD_NOT_USE__MutationSubmitTransferArgs = {
  input: __SHOULD_NOT_USE__SubmitTransferInput;
};


export type __SHOULD_NOT_USE__MutationSuspendBankAccountArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__MutationSyncRolePermissionsArgs = {
  input: __SHOULD_NOT_USE__SyncRolePermissionsInput;
};


export type __SHOULD_NOT_USE__MutationUnassignRoleFromUserArgs = {
  input: __SHOULD_NOT_USE__UnassignRoleInput;
};


export type __SHOULD_NOT_USE__MutationUnflagPaymentArgs = {
  input: __SHOULD_NOT_USE__UnflagPaymentInput;
};


export type __SHOULD_NOT_USE__MutationUpdateApiKeyArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateApiKeyInput;
};


export type __SHOULD_NOT_USE__MutationUpdateBankAccountDetailsArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateBankAccountDetailsInput;
};


export type __SHOULD_NOT_USE__MutationUpdateBillingAddressArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateBillingAddressInput;
};


export type __SHOULD_NOT_USE__MutationUpdateBusinessArgs = {
  input: __SHOULD_NOT_USE__UpdateOrganizationInput;
};


export type __SHOULD_NOT_USE__MutationUpdateCardTypeArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateCardTypeInput;
};


export type __SHOULD_NOT_USE__MutationUpdateDisputeProgressArgs = {
  input: __SHOULD_NOT_USE__UpdateDisputeProgressInput;
};


export type __SHOULD_NOT_USE__MutationUpdateInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateInvoiceInput;
};


export type __SHOULD_NOT_USE__MutationUpdateLineItemArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateLineItemInput;
};


export type __SHOULD_NOT_USE__MutationUpdateMediaArgs = {
  input: __SHOULD_NOT_USE__UpdateMediaInput;
};


export type __SHOULD_NOT_USE__MutationUpdateMerchantWebhookArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateMerchantWebhookInput;
};


export type __SHOULD_NOT_USE__MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateOrganizationInput;
};


export type __SHOULD_NOT_USE__MutationUpdateOrganizationPaymentTypeArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateOrganizationPaymentTypeInput;
};


export type __SHOULD_NOT_USE__MutationUpdateOrganizationStatusArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: OrganizationStatus;
};


export type __SHOULD_NOT_USE__MutationUpdatePaymentProviderArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdatePaymentProviderInput;
};


export type __SHOULD_NOT_USE__MutationUpdatePaymentTypeArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdatePaymentTypeInput;
};


export type __SHOULD_NOT_USE__MutationUpdatePermissionGroupArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdatePermissionGroupInput;
};


export type __SHOULD_NOT_USE__MutationUpdatePolicyDocumentArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdatePolicyDocumentInput;
};


export type __SHOULD_NOT_USE__MutationUpdatePolicyTemplateArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdatePolicyTemplateInput;
};


export type __SHOULD_NOT_USE__MutationUpdateQuickPayArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateQuickPayInput;
};


export type __SHOULD_NOT_USE__MutationUpdateRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateRecurringPaymentInput;
};


export type __SHOULD_NOT_USE__MutationUpdateRecurringPaymentMethodArgs = {
  input: __SHOULD_NOT_USE__UpdateRecurringPaymentMethodInput;
};


export type __SHOULD_NOT_USE__MutationUpdateRefundArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateRefundInput;
};


export type __SHOULD_NOT_USE__MutationUpdateRoleArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateRoleInput;
};


export type __SHOULD_NOT_USE__MutationUpdateServiceAccountWebhookArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateServiceAccountWebhookInput;
};


export type __SHOULD_NOT_USE__MutationUpdateServiceAccountWebhookSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateServiceAccountWebhookSubscriptionInput;
};


export type __SHOULD_NOT_USE__MutationUpdateTransferNotesArgs = {
  input: __SHOULD_NOT_USE__UpdateTransferNotesInput;
};


export type __SHOULD_NOT_USE__MutationUpdateUserProfileArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateUserProfileInput;
};


export type __SHOULD_NOT_USE__MutationUpdateUserStatusArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: UserStatus;
};


export type __SHOULD_NOT_USE__MutationUpdateWebhookSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input: __SHOULD_NOT_USE__UpdateWebhookSubscriptionInput;
};


export type __SHOULD_NOT_USE__MutationVerifyBankAccountArgs = {
  input: __SHOULD_NOT_USE__VerifyBankAccountInput;
};


export type __SHOULD_NOT_USE__MutationVerifyEmailArgs = {
  input: __SHOULD_NOT_USE__VerifyEmailInput;
};


export type __SHOULD_NOT_USE__MutationVerifyEmailWithOtpArgs = {
  input: __SHOULD_NOT_USE__VerifyEmailWithOtpInput;
};


export type __SHOULD_NOT_USE__MutationVerifyLoginOtpArgs = {
  input: __SHOULD_NOT_USE__VerifyLoginOtpInput;
};


export type __SHOULD_NOT_USE__MutationVerifyMagicLinkArgs = {
  input: __SHOULD_NOT_USE__VerifyMagicLinkInput;
};


export type __SHOULD_NOT_USE__MutationVerifyOtpArgs = {
  input: __SHOULD_NOT_USE__VerifyOtpInput;
};


export type __SHOULD_NOT_USE__MutationVoidInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export const OtpPurpose = {
  EmailVerification: 'EMAIL_VERIFICATION',
  PasswordlessLogin: 'PASSWORDLESS_LOGIN',
  PasswordReset: 'PASSWORD_RESET'
} as const;

export type OtpPurpose = typeof OtpPurpose[keyof typeof OtpPurpose];
export type __SHOULD_NOT_USE__OnBoardMerchantBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bankId: Scalars['ID']['input'];
  type: BankAccountType;
};

export type __SHOULD_NOT_USE__OnboardBankInput = {
  address?: InputMaybe<Scalars['Map']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  owner: __SHOULD_NOT_USE__OnboardBankOwnerInput;
  phoneNumber: Scalars['String']['input'];
  /** Defaults to [WEB, MOBILE] when omitted */
  supportedChannels?: InputMaybe<Array<PaymentChannel>>;
};

/** The bank's first owner user, created during onboarding and invited by email */
export type __SHOULD_NOT_USE__OnboardBankOwnerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__OnboardBankPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
  /** The created owner user (invited by email, IsOwner) */
  owner: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__OnboardOrganizationInput = {
  address: Scalars['Map']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  industry?: InputMaybe<OrganizationIndustry>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  mccCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  otherIndustry?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  primaryAccount: __SHOULD_NOT_USE__OnBoardMerchantBankAccountInput;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__Organization = {
  address: Maybe<Scalars['Map']['output']>;
  canReceiveDonation: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  industry: Maybe<OrganizationIndustry>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  logo: Maybe<__SHOULD_NOT_USE__Media>;
  mccCode: Maybe<Scalars['String']['output']>;
  merchantProcessingFee: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  otherIndustry: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  refundPolicyTerms: OrganizationRefundPolicyTerms;
  status: OrganizationStatus;
  supportedChannels: Array<PaymentChannel>;
  type: OrganizationType;
  updatedAt: Scalars['Time']['output'];
  users: Array<__SHOULD_NOT_USE__User>;
  website: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__OrganizationConnection = {
  edges: Array<__SHOULD_NOT_USE__OrganizationEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__OrganizationEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Organization;
};

export const OrganizationIndustry = {
  Airlines: 'AIRLINES',
  Bank: 'BANK',
  CsoNgo: 'CSO_NGO',
  ECommerce: 'E_COMMERCE',
  Government: 'GOVERNMENT',
  Hotel: 'HOTEL',
  Other: 'OTHER',
  Retail: 'RETAIL',
  Tourism: 'TOURISM'
} as const;

export type OrganizationIndustry = typeof OrganizationIndustry[keyof typeof OrganizationIndustry];
export type __SHOULD_NOT_USE__OrganizationOrderByField = {
  direction: SortOrder;
  field: OrganizationOrderField;
};

export const OrganizationOrderField = {
  CreatedAt: 'CREATED_AT',
  Email: 'EMAIL',
  Industry: 'INDUSTRY',
  Name: 'NAME',
  Status: 'STATUS',
  Type: 'TYPE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type OrganizationOrderField = typeof OrganizationOrderField[keyof typeof OrganizationOrderField];
export type __SHOULD_NOT_USE__OrganizationPaymentType = {
  CreatedAt: Scalars['Time']['output'];
  Enabled: Scalars['Boolean']['output'];
  Organization: __SHOULD_NOT_USE__Organization;
  OrganizationId: Scalars['ID']['output'];
  PaymentContext: OrganizationPaymentTypeContext;
  PaymentProviderPaymentType: __SHOULD_NOT_USE__PaymentProviderPaymentType;
  PaymentProviderPaymentTypeId: Scalars['ID']['output'];
  UpdatedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
};

export const OrganizationPaymentTypeContext = {
  Api: 'API',
  Invoice: 'INVOICE',
  Recurring: 'RECURRING'
} as const;

export type OrganizationPaymentTypeContext = typeof OrganizationPaymentTypeContext[keyof typeof OrganizationPaymentTypeContext];
/**
 * OrganizationPaymentTypeWhereInput is used for filtering OrganizationPaymentType objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__OrganizationPaymentTypeWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationPaymentTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payment_provider_payment_type edge predicates */
  hasPaymentProviderPaymentType?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderPaymentTypeWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderPaymentTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__OrganizationPaymentTypeWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationPaymentTypeWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** payment_context field predicates */
  paymentContext?: InputMaybe<OrganizationPaymentTypeContext>;
  paymentContextIn?: InputMaybe<Array<OrganizationPaymentTypeContext>>;
  paymentContextNEQ?: InputMaybe<OrganizationPaymentTypeContext>;
  paymentContextNotIn?: InputMaybe<Array<OrganizationPaymentTypeContext>>;
  /** payment_provider_payment_type_id field predicates */
  paymentProviderPaymentTypeID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderPaymentTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderPaymentTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderPaymentTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const OrganizationRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  NoRefund: 'NO_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type OrganizationRefundPolicyTerms = typeof OrganizationRefundPolicyTerms[keyof typeof OrganizationRefundPolicyTerms];
export type __SHOULD_NOT_USE__OrganizationSortInput = {
  orderBy: Array<__SHOULD_NOT_USE__OrganizationOrderByField>;
};

export const OrganizationStatus = {
  Active: 'ACTIVE',
  BankAccountPending: 'BANK_ACCOUNT_PENDING',
  Closed: 'CLOSED',
  Rejected: 'REJECTED',
  Suspended: 'SUSPENDED'
} as const;

export type OrganizationStatus = typeof OrganizationStatus[keyof typeof OrganizationStatus];
export const OrganizationType = {
  Bank: 'BANK',
  Merchant: 'MERCHANT',
  Platform: 'PLATFORM'
} as const;

export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType];
/**
 * OrganizationWhereInput is used for filtering Organization objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__OrganizationWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** can_receive_donation field predicates */
  canReceiveDonation?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveDonationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** country field predicates */
  country?: InputMaybe<Scalars['String']['input']>;
  countryContains?: InputMaybe<Scalars['String']['input']>;
  countryContainsFold?: InputMaybe<Scalars['String']['input']>;
  countryEqualFold?: InputMaybe<Scalars['String']['input']>;
  countryGT?: InputMaybe<Scalars['String']['input']>;
  countryGTE?: InputMaybe<Scalars['String']['input']>;
  countryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  countryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  countryLT?: InputMaybe<Scalars['String']['input']>;
  countryLTE?: InputMaybe<Scalars['String']['input']>;
  countryNEQ?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** api_keys edge predicates */
  hasAPIKeys?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIKeysWith?: InputMaybe<Array<__SHOULD_NOT_USE__ApiKeyWhereInput>>;
  /** api_logs edge predicates */
  hasAPILogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPILogsWith?: InputMaybe<Array<__SHOULD_NOT_USE__ApiLogWhereInput>>;
  /** api_payments edge predicates */
  hasAPIPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__ApiPaymentWhereInput>>;
  /** bank_policy_acceptances edge predicates */
  hasBankPolicyAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankPolicyAcceptancesWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>>;
  /** created_policies edge predicates */
  hasCreatedPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedPoliciesWith?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** customers edge predicates */
  hasCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomersWith?: InputMaybe<Array<__SHOULD_NOT_USE__CustomerWhereInput>>;
  /** default_policies edge predicates */
  hasDefaultPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasDefaultPoliciesWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantDefaultPolicyWhereInput>>;
  /** disputes edge predicates */
  hasDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputesWith?: InputMaybe<Array<__SHOULD_NOT_USE__DisputeWhereInput>>;
  /** events edge predicates */
  hasEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventsWith?: InputMaybe<Array<__SHOULD_NOT_USE__EventWhereInput>>;
  /** invoices edge predicates */
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoicesWith?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceWhereInput>>;
  /** managed_bank_accounts edge predicates */
  hasManagedBankAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasManagedBankAccountsWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantBankAccountWhereInput>>;
  /** merchant_bank_accounts edge predicates */
  hasMerchantBankAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantBankAccountsWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantBankAccountWhereInput>>;
  /** payment_types edge predicates */
  hasPaymentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentTypesWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationPaymentTypeWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** policy_acceptances edge predicates */
  hasPolicyAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyAcceptancesWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>>;
  /** quick_pays edge predicates */
  hasQuickPays?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuickPaysWith?: InputMaybe<Array<__SHOULD_NOT_USE__QuickPayWhereInput>>;
  /** recurring_payments edge predicates */
  hasRecurringPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecurringPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__RecurringPaymentWhereInput>>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<__SHOULD_NOT_USE__RoleWhereInput>>;
  /** transfers edge predicates */
  hasTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  hasTransfersWith?: InputMaybe<Array<__SHOULD_NOT_USE__TransferWhereInput>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** webhooks edge predicates */
  hasWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhooksWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** industry field predicates */
  industry?: InputMaybe<OrganizationIndustry>;
  industryIn?: InputMaybe<Array<OrganizationIndustry>>;
  industryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  industryNEQ?: InputMaybe<OrganizationIndustry>;
  industryNotIn?: InputMaybe<Array<OrganizationIndustry>>;
  industryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** license_number field predicates */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licenseNumberContains?: InputMaybe<Scalars['String']['input']>;
  licenseNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  licenseNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  licenseNumberGT?: InputMaybe<Scalars['String']['input']>;
  licenseNumberGTE?: InputMaybe<Scalars['String']['input']>;
  licenseNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  licenseNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  licenseNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  licenseNumberLT?: InputMaybe<Scalars['String']['input']>;
  licenseNumberLTE?: InputMaybe<Scalars['String']['input']>;
  licenseNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  licenseNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mcc_code field predicates */
  mccCode?: InputMaybe<Scalars['String']['input']>;
  mccCodeContains?: InputMaybe<Scalars['String']['input']>;
  mccCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  mccCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  mccCodeGT?: InputMaybe<Scalars['String']['input']>;
  mccCodeGTE?: InputMaybe<Scalars['String']['input']>;
  mccCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mccCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mccCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mccCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mccCodeLT?: InputMaybe<Scalars['String']['input']>;
  mccCodeLTE?: InputMaybe<Scalars['String']['input']>;
  mccCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  mccCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mccCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__OrganizationWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** other_industry field predicates */
  otherIndustry?: InputMaybe<Scalars['String']['input']>;
  otherIndustryContains?: InputMaybe<Scalars['String']['input']>;
  otherIndustryContainsFold?: InputMaybe<Scalars['String']['input']>;
  otherIndustryEqualFold?: InputMaybe<Scalars['String']['input']>;
  otherIndustryGT?: InputMaybe<Scalars['String']['input']>;
  otherIndustryGTE?: InputMaybe<Scalars['String']['input']>;
  otherIndustryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  otherIndustryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  otherIndustryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherIndustryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  otherIndustryLT?: InputMaybe<Scalars['String']['input']>;
  otherIndustryLTE?: InputMaybe<Scalars['String']['input']>;
  otherIndustryNEQ?: InputMaybe<Scalars['String']['input']>;
  otherIndustryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherIndustryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** phone_number field predicates */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberContains?: InputMaybe<Scalars['String']['input']>;
  phoneNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberGT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberGTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumberLT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<OrganizationRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<OrganizationRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<OrganizationRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<OrganizationRefundPolicyTerms>>;
  /** status field predicates */
  status?: InputMaybe<OrganizationStatus>;
  statusIn?: InputMaybe<Array<OrganizationStatus>>;
  statusNEQ?: InputMaybe<OrganizationStatus>;
  statusNotIn?: InputMaybe<Array<OrganizationStatus>>;
  /** type field predicates */
  type?: InputMaybe<OrganizationType>;
  typeIn?: InputMaybe<Array<OrganizationType>>;
  typeNEQ?: InputMaybe<OrganizationType>;
  typeNotIn?: InputMaybe<Array<OrganizationType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** website field predicates */
  website?: InputMaybe<Scalars['String']['input']>;
  websiteContains?: InputMaybe<Scalars['String']['input']>;
  websiteContainsFold?: InputMaybe<Scalars['String']['input']>;
  websiteEqualFold?: InputMaybe<Scalars['String']['input']>;
  websiteGT?: InputMaybe<Scalars['String']['input']>;
  websiteGTE?: InputMaybe<Scalars['String']['input']>;
  websiteHasPrefix?: InputMaybe<Scalars['String']['input']>;
  websiteHasSuffix?: InputMaybe<Scalars['String']['input']>;
  websiteIn?: InputMaybe<Array<Scalars['String']['input']>>;
  websiteIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  websiteLT?: InputMaybe<Scalars['String']['input']>;
  websiteLTE?: InputMaybe<Scalars['String']['input']>;
  websiteNEQ?: InputMaybe<Scalars['String']['input']>;
  websiteNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  websiteNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__PageInfo = {
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__PaginationInput = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type __SHOULD_NOT_USE__PauseQuickPayPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  quickPay: Maybe<__SHOULD_NOT_USE__QuickPay>;
};

export type __SHOULD_NOT_USE__PauseRecurringPaymentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  recurringPayment: Maybe<__SHOULD_NOT_USE__RecurringPayment>;
};

export type __SHOULD_NOT_USE__Payment = {
  amount: Scalars['Float']['output'];
  apiPayment: Maybe<__SHOULD_NOT_USE__ApiPayment>;
  cardBrand: Maybe<Scalars['String']['output']>;
  cardLast4: Maybe<Scalars['String']['output']>;
  cardType: Maybe<CardType>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Currency;
  customerEmail: Maybe<Scalars['String']['output']>;
  customerName: Maybe<Scalars['String']['output']>;
  environment: PaymentEnvironment;
  flag_reason: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  invoice: Maybe<__SHOULD_NOT_USE__Invoice>;
  is_flagged: Maybe<Scalars['Boolean']['output']>;
  merchantProcessingFee: Scalars['Float']['output'];
  merchantReceives: Scalars['Float']['output'];
  netAmount: Scalars['Float']['output'];
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
  owner_id: Scalars['ID']['output'];
  paymentMethodType: Maybe<Scalars['String']['output']>;
  paymentProvider: __SHOULD_NOT_USE__PaymentProvider;
  paymentType: PaymentType;
  platformFee: Scalars['Float']['output'];
  providerCustomerId: Maybe<Scalars['String']['output']>;
  providerDeclineCode: Maybe<Scalars['String']['output']>;
  providerErrorCode: Maybe<Scalars['String']['output']>;
  providerErrorMessage: Maybe<Scalars['String']['output']>;
  providerFee: Maybe<Scalars['Float']['output']>;
  providerMetadata: Scalars['Map']['output'];
  providerPaymentMethodId: Maybe<Scalars['String']['output']>;
  providerTransactionId: Maybe<Scalars['String']['output']>;
  quickPay: Maybe<__SHOULD_NOT_USE__QuickPay>;
  recurringPayment: Maybe<__SHOULD_NOT_USE__RecurringPayment>;
  responseCode: Maybe<Scalars['String']['output']>;
  responseCodeDescription: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
  totalFees: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  walletType: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__PaymentAnalytics = {
  averageTransactionAmount: Scalars['Float']['output'];
  date: Scalars['Time']['output'];
  failedCount: Scalars['Int']['output'];
  grossRevenue: Scalars['Float']['output'];
  merchantNet: Scalars['Float']['output'];
  period: Scalars['String']['output'];
  platformRevenue: Scalars['Float']['output'];
  processingFees: Scalars['Float']['output'];
  providerFees: Scalars['Float']['output'];
  successRate: Scalars['Float']['output'];
  successfulCount: Scalars['Int']['output'];
  transactionCount: Scalars['Int']['output'];
};

export const PaymentChannel = {
  Mobile: 'MOBILE',
  Web: 'WEB'
} as const;

export type PaymentChannel = typeof PaymentChannel[keyof typeof PaymentChannel];
export type __SHOULD_NOT_USE__PaymentConnection = {
  edges: Array<__SHOULD_NOT_USE__PaymentEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PaymentEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Payment;
};

export const PaymentEnvironment = {
  Live: 'LIVE',
  Test: 'TEST'
} as const;

export type PaymentEnvironment = typeof PaymentEnvironment[keyof typeof PaymentEnvironment];
export type __SHOULD_NOT_USE__PaymentFailureAnalysis = {
  declineCode: Maybe<Scalars['String']['output']>;
  errorCode: Scalars['String']['output'];
  errorMessage: Maybe<Scalars['String']['output']>;
  occurrenceCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type __SHOULD_NOT_USE__PaymentFeeBreakdown = {
  gatewayFeeAmount: Scalars['Float']['output'];
  gatewayFeeRate: Scalars['Float']['output'];
  gatewayFeeType: Scalars['String']['output'];
  merchantFeeAmount: Scalars['Float']['output'];
  merchantFeePercent: Scalars['Float']['output'];
  platformFeeAmount: Scalars['Float']['output'];
  platformFeePercent: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterMerchant: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type __SHOULD_NOT_USE__PaymentMethod = {
  cardBrand: Maybe<Scalars['String']['output']>;
  cardExpiryMonth: Maybe<Scalars['Int']['output']>;
  cardExpiryYear: Maybe<Scalars['Int']['output']>;
  cardLast4: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  customer: __SHOULD_NOT_USE__Customer;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  metadata: Scalars['Map']['output'];
  paymentProvider: __SHOULD_NOT_USE__PaymentProvider;
  providerCustomerID: Maybe<Scalars['String']['output']>;
  providerPaymentMethodID: Scalars['String']['output'];
  status: PaymentMethodStatus;
  type: PaymentType;
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__PaymentMethodConnection = {
  edges: Array<__SHOULD_NOT_USE__PaymentMethodEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PaymentMethodEdge = {
  cursor: Scalars['Cursor']['output'];
  node: __SHOULD_NOT_USE__PaymentMethod;
};

export type __SHOULD_NOT_USE__PaymentMethodOrderBy = {
  direction: SortOrder;
  field: PaymentMethodOrderField;
};

export const PaymentMethodOrderField = {
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  Type: 'TYPE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PaymentMethodOrderField = typeof PaymentMethodOrderField[keyof typeof PaymentMethodOrderField];
export const PaymentMethodStatus = {
  Active: 'ACTIVE',
  Expired: 'EXPIRED',
  Failed: 'FAILED',
  Removed: 'REMOVED'
} as const;

export type PaymentMethodStatus = typeof PaymentMethodStatus[keyof typeof PaymentMethodStatus];
/**
 * PaymentMethodWhereInput is used for filtering PaymentMethod objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PaymentMethodWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentMethodWhereInput>>;
  /** bank_last4 field predicates */
  bankLast4?: InputMaybe<Scalars['String']['input']>;
  bankLast4Contains?: InputMaybe<Scalars['String']['input']>;
  bankLast4ContainsFold?: InputMaybe<Scalars['String']['input']>;
  bankLast4EqualFold?: InputMaybe<Scalars['String']['input']>;
  bankLast4GT?: InputMaybe<Scalars['String']['input']>;
  bankLast4GTE?: InputMaybe<Scalars['String']['input']>;
  bankLast4HasPrefix?: InputMaybe<Scalars['String']['input']>;
  bankLast4HasSuffix?: InputMaybe<Scalars['String']['input']>;
  bankLast4In?: InputMaybe<Array<Scalars['String']['input']>>;
  bankLast4IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bankLast4LT?: InputMaybe<Scalars['String']['input']>;
  bankLast4LTE?: InputMaybe<Scalars['String']['input']>;
  bankLast4NEQ?: InputMaybe<Scalars['String']['input']>;
  bankLast4NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bankLast4NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bank_name field predicates */
  bankName?: InputMaybe<Scalars['String']['input']>;
  bankNameContains?: InputMaybe<Scalars['String']['input']>;
  bankNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  bankNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  bankNameGT?: InputMaybe<Scalars['String']['input']>;
  bankNameGTE?: InputMaybe<Scalars['String']['input']>;
  bankNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bankNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bankNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bankNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bankNameLT?: InputMaybe<Scalars['String']['input']>;
  bankNameLTE?: InputMaybe<Scalars['String']['input']>;
  bankNameNEQ?: InputMaybe<Scalars['String']['input']>;
  bankNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bankNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_brand field predicates */
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardBrandContains?: InputMaybe<Scalars['String']['input']>;
  cardBrandContainsFold?: InputMaybe<Scalars['String']['input']>;
  cardBrandEqualFold?: InputMaybe<Scalars['String']['input']>;
  cardBrandGT?: InputMaybe<Scalars['String']['input']>;
  cardBrandGTE?: InputMaybe<Scalars['String']['input']>;
  cardBrandHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cardBrandHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cardBrandIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cardBrandIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardBrandLT?: InputMaybe<Scalars['String']['input']>;
  cardBrandLTE?: InputMaybe<Scalars['String']['input']>;
  cardBrandNEQ?: InputMaybe<Scalars['String']['input']>;
  cardBrandNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cardBrandNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_exp_month field predicates */
  cardExpMonth?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthGT?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthGTE?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardExpMonthIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardExpMonthLT?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthLTE?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthNEQ?: InputMaybe<Scalars['Int']['input']>;
  cardExpMonthNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardExpMonthNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_exp_year field predicates */
  cardExpYear?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearGT?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearGTE?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardExpYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardExpYearLT?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearLTE?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  cardExpYearNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardExpYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_last4 field predicates */
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  cardLast4Contains?: InputMaybe<Scalars['String']['input']>;
  cardLast4ContainsFold?: InputMaybe<Scalars['String']['input']>;
  cardLast4EqualFold?: InputMaybe<Scalars['String']['input']>;
  cardLast4GT?: InputMaybe<Scalars['String']['input']>;
  cardLast4GTE?: InputMaybe<Scalars['String']['input']>;
  cardLast4HasPrefix?: InputMaybe<Scalars['String']['input']>;
  cardLast4HasSuffix?: InputMaybe<Scalars['String']['input']>;
  cardLast4In?: InputMaybe<Array<Scalars['String']['input']>>;
  cardLast4IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardLast4LT?: InputMaybe<Scalars['String']['input']>;
  cardLast4LTE?: InputMaybe<Scalars['String']['input']>;
  cardLast4NEQ?: InputMaybe<Scalars['String']['input']>;
  cardLast4NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cardLast4NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** customer_id field predicates */
  customerID?: InputMaybe<Scalars['ID']['input']>;
  customerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  customerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** customer edge predicates */
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomerWith?: InputMaybe<Array<__SHOULD_NOT_USE__CustomerWhereInput>>;
  /** payment_provider edge predicates */
  hasPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** recurring_payments edge predicates */
  hasRecurringPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecurringPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__RecurringPaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__PaymentMethodWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentMethodWhereInput>>;
  /** payment_provider_id field predicates */
  paymentProviderID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** provider_customer_id field predicates */
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDContains?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDGT?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCustomerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerCustomerIDLT?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCustomerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_payment_method_id field predicates */
  providerPaymentMethodID?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDContains?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDGT?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerPaymentMethodIDLT?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<PaymentMethodStatus>;
  statusIn?: InputMaybe<Array<PaymentMethodStatus>>;
  statusNEQ?: InputMaybe<PaymentMethodStatus>;
  statusNotIn?: InputMaybe<Array<PaymentMethodStatus>>;
  /** type field predicates */
  type?: InputMaybe<PaymentType>;
  typeIn?: InputMaybe<Array<PaymentType>>;
  typeNEQ?: InputMaybe<PaymentType>;
  typeNotIn?: InputMaybe<Array<PaymentType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__PaymentOrderBy = {
  direction: SortOrder;
  field: PaymentOrderField;
};

export const PaymentOrderField = {
  Amount: 'AMOUNT',
  CreatedAt: 'CREATED_AT',
  CustomerEmail: 'CUSTOMER_EMAIL',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PaymentOrderField = typeof PaymentOrderField[keyof typeof PaymentOrderField];
export type __SHOULD_NOT_USE__PaymentProvider = {
  apiLoginId: Maybe<Scalars['String']['output']>;
  cardTypes: Array<__SHOULD_NOT_USE__PaymentProviderCardType>;
  configProfile: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  environment: PaymentEnvironment;
  id: Scalars['ID']['output'];
  isAutoRefundSupported: Scalars['Boolean']['output'];
  logoMedia: Maybe<__SHOULD_NOT_USE__Media>;
  name: Scalars['String']['output'];
  paymentTypes: Array<__SHOULD_NOT_USE__PaymentProviderPaymentType>;
  priority: Scalars['Int']['output'];
  publicKey: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: ProviderStatus;
  /** Client channels this provider serves; routing skips it for other channels */
  supportedChannels: Array<PaymentChannel>;
  supportedCurrencies: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__PaymentProviderCardType = {
  createdAt: Scalars['Time']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentProvider: __SHOULD_NOT_USE__PaymentProvider;
  paymentProviderId: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  type: CardType;
  updatedAt: Scalars['Time']['output'];
};

/**
 * PaymentProviderCardTypeWhereInput is used for filtering PaymentProviderCardType objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PaymentProviderCardTypeWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderCardTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_provider edge predicates */
  hasPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PaymentProviderCardTypeWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderCardTypeWhereInput>>;
  /** payment_provider_id field predicates */
  paymentProviderID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** priority field predicates */
  priority?: InputMaybe<Scalars['Int']['input']>;
  priorityGT?: InputMaybe<Scalars['Int']['input']>;
  priorityGTE?: InputMaybe<Scalars['Int']['input']>;
  priorityIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  priorityLT?: InputMaybe<Scalars['Int']['input']>;
  priorityLTE?: InputMaybe<Scalars['Int']['input']>;
  priorityNEQ?: InputMaybe<Scalars['Int']['input']>;
  priorityNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** type field predicates */
  type?: InputMaybe<CardType>;
  typeIn?: InputMaybe<Array<CardType>>;
  typeNEQ?: InputMaybe<CardType>;
  typeNotIn?: InputMaybe<Array<CardType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__PaymentProviderConnection = {
  edges: Array<__SHOULD_NOT_USE__PaymentProviderEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PaymentProviderEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__PaymentProvider;
};

export type __SHOULD_NOT_USE__PaymentProviderOrderByField = {
  direction: SortOrder;
  field: PaymentProviderOrderField;
};

export const PaymentProviderOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PaymentProviderOrderField = typeof PaymentProviderOrderField[keyof typeof PaymentProviderOrderField];
export type __SHOULD_NOT_USE__PaymentProviderPaymentType = {
  createdAt: Scalars['Time']['output'];
  enabled: Scalars['Boolean']['output'];
  gatewayFeeType: FeeType;
  gatewayFees: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentProvider: __SHOULD_NOT_USE__PaymentProvider;
  paymentProviderId: Scalars['ID']['output'];
  platformFeeType: FeeType;
  platformFees: Scalars['Float']['output'];
  supportedCurrencies: Array<Scalars['String']['output']>;
  type: PaymentType;
  updatedAt: Scalars['Time']['output'];
};

/**
 * PaymentProviderPaymentTypeWhereInput is used for filtering PaymentProviderPaymentType objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PaymentProviderPaymentTypeWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderPaymentTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** gateway_fee_type field predicates */
  gatewayFeeType?: InputMaybe<FeeType>;
  gatewayFeeTypeIn?: InputMaybe<Array<FeeType>>;
  gatewayFeeTypeNEQ?: InputMaybe<FeeType>;
  gatewayFeeTypeNotIn?: InputMaybe<Array<FeeType>>;
  /** gateway_fees field predicates */
  gatewayFees?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesGT?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesGTE?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  gatewayFeesLT?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesLTE?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesNEQ?: InputMaybe<Scalars['Float']['input']>;
  gatewayFeesNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** organization_payment_types edge predicates */
  hasOrganizationPaymentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationPaymentTypesWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationPaymentTypeWhereInput>>;
  /** payment_provider edge predicates */
  hasPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PaymentProviderPaymentTypeWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderPaymentTypeWhereInput>>;
  /** payment_provider_id field predicates */
  paymentProviderID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** platform_fee_type field predicates */
  platformFeeType?: InputMaybe<FeeType>;
  platformFeeTypeIn?: InputMaybe<Array<FeeType>>;
  platformFeeTypeNEQ?: InputMaybe<FeeType>;
  platformFeeTypeNotIn?: InputMaybe<Array<FeeType>>;
  /** platform_fees field predicates */
  platformFees?: InputMaybe<Scalars['Float']['input']>;
  platformFeesGT?: InputMaybe<Scalars['Float']['input']>;
  platformFeesGTE?: InputMaybe<Scalars['Float']['input']>;
  platformFeesIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  platformFeesLT?: InputMaybe<Scalars['Float']['input']>;
  platformFeesLTE?: InputMaybe<Scalars['Float']['input']>;
  platformFeesNEQ?: InputMaybe<Scalars['Float']['input']>;
  platformFeesNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** supports_recurring field predicates */
  supportsRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRecurringNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** type field predicates */
  type?: InputMaybe<PaymentType>;
  typeIn?: InputMaybe<Array<PaymentType>>;
  typeNEQ?: InputMaybe<PaymentType>;
  typeNotIn?: InputMaybe<Array<PaymentType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__PaymentProviderSortInput = {
  orderBy: Array<__SHOULD_NOT_USE__PaymentProviderOrderByField>;
};

/**
 * PaymentProviderWhereInput is used for filtering PaymentProvider objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PaymentProviderWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderWhereInput>>;
  /** config_profile field predicates */
  configProfile?: InputMaybe<Scalars['String']['input']>;
  configProfileContains?: InputMaybe<Scalars['String']['input']>;
  configProfileContainsFold?: InputMaybe<Scalars['String']['input']>;
  configProfileEqualFold?: InputMaybe<Scalars['String']['input']>;
  configProfileGT?: InputMaybe<Scalars['String']['input']>;
  configProfileGTE?: InputMaybe<Scalars['String']['input']>;
  configProfileHasPrefix?: InputMaybe<Scalars['String']['input']>;
  configProfileHasSuffix?: InputMaybe<Scalars['String']['input']>;
  configProfileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  configProfileLT?: InputMaybe<Scalars['String']['input']>;
  configProfileLTE?: InputMaybe<Scalars['String']['input']>;
  configProfileNEQ?: InputMaybe<Scalars['String']['input']>;
  configProfileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** card_types edge predicates */
  hasCardTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasCardTypesWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderCardTypeWhereInput>>;
  /** logo_media edge predicates */
  hasLogoMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasLogoMediaWith?: InputMaybe<Array<__SHOULD_NOT_USE__MediaWhereInput>>;
  /** payment_methods edge predicates */
  hasPaymentMethods?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentMethodsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentMethodWhereInput>>;
  /** payment_types edge predicates */
  hasPaymentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentTypesWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderPaymentTypeWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_auto_refund_supported field predicates */
  isAutoRefundSupported?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRefundSupportedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** logo_media_id field predicates */
  logoMediaID?: InputMaybe<Scalars['ID']['input']>;
  logoMediaIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoMediaIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  logoMediaIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  logoMediaIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoMediaIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PaymentProviderWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderWhereInput>>;
  /** priority field predicates */
  priority?: InputMaybe<Scalars['Int']['input']>;
  priorityGT?: InputMaybe<Scalars['Int']['input']>;
  priorityGTE?: InputMaybe<Scalars['Int']['input']>;
  priorityIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  priorityLT?: InputMaybe<Scalars['Int']['input']>;
  priorityLTE?: InputMaybe<Scalars['Int']['input']>;
  priorityNEQ?: InputMaybe<Scalars['Int']['input']>;
  priorityNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** slug field predicates */
  slug?: InputMaybe<Scalars['String']['input']>;
  slugContains?: InputMaybe<Scalars['String']['input']>;
  slugContainsFold?: InputMaybe<Scalars['String']['input']>;
  slugEqualFold?: InputMaybe<Scalars['String']['input']>;
  slugGT?: InputMaybe<Scalars['String']['input']>;
  slugGTE?: InputMaybe<Scalars['String']['input']>;
  slugHasPrefix?: InputMaybe<Scalars['String']['input']>;
  slugHasSuffix?: InputMaybe<Scalars['String']['input']>;
  slugIn?: InputMaybe<Array<Scalars['String']['input']>>;
  slugLT?: InputMaybe<Scalars['String']['input']>;
  slugLTE?: InputMaybe<Scalars['String']['input']>;
  slugNEQ?: InputMaybe<Scalars['String']['input']>;
  slugNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<ProviderStatus>;
  statusIn?: InputMaybe<Array<ProviderStatus>>;
  statusNEQ?: InputMaybe<ProviderStatus>;
  statusNotIn?: InputMaybe<Array<ProviderStatus>>;
  /** supports_recurring_payments field predicates */
  supportsRecurringPayments?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRecurringPaymentsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const PaymentReportField = {
  CardNumber: 'CARD_NUMBER',
  CardScheme: 'CARD_SCHEME',
  CreatedAt: 'CREATED_AT',
  Currency: 'CURRENCY',
  CustomerEmail: 'CUSTOMER_EMAIL',
  CustomerName: 'CUSTOMER_NAME',
  Environment: 'ENVIRONMENT',
  MerchantCode: 'MERCHANT_CODE',
  MerchantProcessingFee: 'MERCHANT_PROCESSING_FEE',
  OrganizationCode: 'ORGANIZATION_CODE',
  OrganizationName: 'ORGANIZATION_NAME',
  PaymentCode: 'PAYMENT_CODE',
  PaymentType: 'PAYMENT_TYPE',
  PlatformFee: 'PLATFORM_FEE',
  ProviderDeclineCode: 'PROVIDER_DECLINE_CODE',
  ProviderErrorCode: 'PROVIDER_ERROR_CODE',
  ProviderErrorMessage: 'PROVIDER_ERROR_MESSAGE',
  ProviderFee: 'PROVIDER_FEE',
  ProviderTransactionId: 'PROVIDER_TRANSACTION_ID',
  ResponseCode: 'RESPONSE_CODE',
  ResponseCodeDescription: 'RESPONSE_CODE_DESCRIPTION',
  Status: 'STATUS',
  TransactionAmount: 'TRANSACTION_AMOUNT',
  TransactionTimestamp: 'TRANSACTION_TIMESTAMP'
} as const;

export type PaymentReportField = typeof PaymentReportField[keyof typeof PaymentReportField];
export const PaymentStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Succeeded: 'SUCCEEDED'
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];
export type __SHOULD_NOT_USE__PaymentSummary = {
  averageAmount: Scalars['Float']['output'];
  failedCount: Scalars['Int']['output'];
  failureRate: Scalars['Float']['output'];
  pendingCount: Scalars['Int']['output'];
  succeededCount: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalMerchantFees: Scalars['Float']['output'];
  totalPayments: Scalars['Int']['output'];
  totalPlatformFees: Scalars['Float']['output'];
  totalProviderFees: Scalars['Float']['output'];
};

export const PaymentType = {
  Ach: 'ACH',
  Bank: 'BANK',
  Card: 'CARD',
  Other: 'OTHER',
  Wallet: 'WALLET'
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];
export type __SHOULD_NOT_USE__PaymentTypeFilter = {
  maxGatewayFees?: InputMaybe<Scalars['Float']['input']>;
  maxPlatformFees?: InputMaybe<Scalars['Float']['input']>;
  minGatewayFees?: InputMaybe<Scalars['Float']['input']>;
  minPlatformFees?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<PaymentType>;
};

/**
 * PaymentWhereInput is used for filtering Payment objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PaymentWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** api_payment_id field predicates */
  apiPaymentID?: InputMaybe<Scalars['ID']['input']>;
  apiPaymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  apiPaymentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiPaymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  apiPaymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  apiPaymentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** card_type field predicates */
  cardType?: InputMaybe<CardType>;
  cardTypeIn?: InputMaybe<Array<CardType>>;
  cardTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cardTypeNEQ?: InputMaybe<CardType>;
  cardTypeNotIn?: InputMaybe<Array<CardType>>;
  cardTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** customer_email field predicates */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerEmailContains?: InputMaybe<Scalars['String']['input']>;
  customerEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerEmailGT?: InputMaybe<Scalars['String']['input']>;
  customerEmailGTE?: InputMaybe<Scalars['String']['input']>;
  customerEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerEmailLT?: InputMaybe<Scalars['String']['input']>;
  customerEmailLTE?: InputMaybe<Scalars['String']['input']>;
  customerEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  customerEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_id field predicates */
  customerID?: InputMaybe<Scalars['ID']['input']>;
  customerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  customerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** customer_name field predicates */
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerNameContains?: InputMaybe<Scalars['String']['input']>;
  customerNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  customerNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  customerNameGT?: InputMaybe<Scalars['String']['input']>;
  customerNameGTE?: InputMaybe<Scalars['String']['input']>;
  customerNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  customerNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  customerNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customerNameLT?: InputMaybe<Scalars['String']['input']>;
  customerNameLTE?: InputMaybe<Scalars['String']['input']>;
  customerNameNEQ?: InputMaybe<Scalars['String']['input']>;
  customerNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** api_payment edge predicates */
  hasAPIPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIPaymentWith?: InputMaybe<Array<__SHOULD_NOT_USE__ApiPaymentWhereInput>>;
  /** customer edge predicates */
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomerWith?: InputMaybe<Array<__SHOULD_NOT_USE__CustomerWhereInput>>;
  /** disputes edge predicates */
  hasDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputesWith?: InputMaybe<Array<__SHOULD_NOT_USE__DisputeWhereInput>>;
  /** invoice edge predicates */
  hasInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoiceWith?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payment_method edge predicates */
  hasPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentMethodWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentMethodWhereInput>>;
  /** payment_provider edge predicates */
  hasPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentProviderWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentProviderWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** quick_pay edge predicates */
  hasQuickPay?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuickPayWith?: InputMaybe<Array<__SHOULD_NOT_USE__QuickPayWhereInput>>;
  /** recurring_payment edge predicates */
  hasRecurringPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecurringPaymentWith?: InputMaybe<Array<__SHOULD_NOT_USE__RecurringPaymentWhereInput>>;
  /** refunds edge predicates */
  hasRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefundsWith?: InputMaybe<Array<__SHOULD_NOT_USE__RefundWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** idempotency_key field predicates */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyContains?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyGT?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyGTE?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKeyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKeyLT?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyLTE?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKeyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** invoice_id field predicates */
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  invoiceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_flagged field predicates */
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  isFlaggedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  isFlaggedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  isFlaggedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PaymentWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** payment_method_id field predicates */
  paymentMethodID?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentMethodIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentMethodIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentMethodIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_provider_id field predicates */
  paymentProviderID?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentProviderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentProviderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** payment_type field predicates */
  paymentType?: InputMaybe<PaymentType>;
  paymentTypeIn?: InputMaybe<Array<PaymentType>>;
  paymentTypeNEQ?: InputMaybe<PaymentType>;
  paymentTypeNotIn?: InputMaybe<Array<PaymentType>>;
  /** platform_fee field predicates */
  platformFee?: InputMaybe<Scalars['Float']['input']>;
  platformFeeGT?: InputMaybe<Scalars['Float']['input']>;
  platformFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  platformFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  platformFeeLT?: InputMaybe<Scalars['Float']['input']>;
  platformFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  platformFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  platformFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** provider_charge_id field predicates */
  providerChargeID?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDContains?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDGT?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerChargeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerChargeIDLT?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerChargeIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerChargeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_charged_processing_fee field predicates */
  providerChargedProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerChargedProcessingFeeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerChargedProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  providerChargedProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerChargedProcessingFeeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_customer_id field predicates */
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDContains?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDGT?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCustomerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerCustomerIDLT?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerCustomerIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCustomerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_decline_code field predicates */
  providerDeclineCode?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeContains?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeGT?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeGTE?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerDeclineCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerDeclineCodeLT?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeLTE?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  providerDeclineCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerDeclineCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_error_code field predicates */
  providerErrorCode?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeContains?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeGT?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerErrorCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerErrorCodeLT?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  providerErrorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerErrorCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_error_message field predicates */
  providerErrorMessage?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageContains?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageGT?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageGTE?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerErrorMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerErrorMessageLT?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageLTE?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  providerErrorMessageNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerErrorMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_fee field predicates */
  providerFee?: InputMaybe<Scalars['Float']['input']>;
  providerFeeGT?: InputMaybe<Scalars['Float']['input']>;
  providerFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  providerFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerFeeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerFeeLT?: InputMaybe<Scalars['Float']['input']>;
  providerFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  providerFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  providerFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  providerFeeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_payment_method_id field predicates */
  providerPaymentMethodID?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDContains?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDGT?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerPaymentMethodIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerPaymentMethodIDLT?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerPaymentMethodIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** provider_transaction_id field predicates */
  providerTransactionID?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDContains?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDGT?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerTransactionIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerTransactionIDLT?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerTransactionIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerTransactionIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** quick_pay_id field predicates */
  quickPayID?: InputMaybe<Scalars['ID']['input']>;
  quickPayIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  quickPayIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  quickPayIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  quickPayIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  quickPayIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** recurring_payment_id field predicates */
  recurringPaymentID?: InputMaybe<Scalars['ID']['input']>;
  recurringPaymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringPaymentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recurringPaymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  recurringPaymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringPaymentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_code field predicates */
  responseCode?: InputMaybe<Scalars['String']['input']>;
  responseCodeContains?: InputMaybe<Scalars['String']['input']>;
  responseCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  /** response_code_description field predicates */
  responseCodeDescription?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseCodeDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseCodeDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  responseCodeDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseCodeDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseCodeGT?: InputMaybe<Scalars['String']['input']>;
  responseCodeGTE?: InputMaybe<Scalars['String']['input']>;
  responseCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseCodeLT?: InputMaybe<Scalars['String']['input']>;
  responseCodeLTE?: InputMaybe<Scalars['String']['input']>;
  responseCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  responseCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<PaymentStatus>;
  statusIn?: InputMaybe<Array<PaymentStatus>>;
  statusNEQ?: InputMaybe<PaymentStatus>;
  statusNotIn?: InputMaybe<Array<PaymentStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__Payout = {
  amount: Scalars['Float']['output'];
  bankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  bankAccountId: Maybe<Scalars['ID']['output']>;
  code: Scalars['String']['output'];
  completedAt: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  currency: Currency;
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  disputeId: Maybe<Scalars['ID']['output']>;
  estimatedSettlementAt: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isSplit: Scalars['Boolean']['output'];
  notes: Maybe<Scalars['Map']['output']>;
  ownerId: Scalars['ID']['output'];
  parent_payout_id: Maybe<Scalars['ID']['output']>;
  payment: __SHOULD_NOT_USE__Payment;
  paymentId: Scalars['ID']['output'];
  payoutType: PayoutType;
  processedAt: Maybe<Scalars['Time']['output']>;
  receipt: Maybe<__SHOULD_NOT_USE__Media>;
  receiverMerchant: __SHOULD_NOT_USE__Organization;
  receivingMerchantId: Scalars['ID']['output'];
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
  refundId: Maybe<Scalars['ID']['output']>;
  splitCount: Scalars['Int']['output'];
  status: PayoutStatus;
  transferCode: Maybe<Scalars['String']['output']>;
  transferId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__PayoutBatchError = {
  error: Scalars['String']['output'];
  payoutCode: Scalars['String']['output'];
  payoutId: Scalars['ID']['output'];
};

export type __SHOULD_NOT_USE__PayoutConnection = {
  edges: Array<__SHOULD_NOT_USE__PayoutEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PayoutEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Payout;
};

export const PayoutHealthStatus = {
  Delayed: 'DELAYED',
  OnTrack: 'ON_TRACK',
  Stuck: 'STUCK'
} as const;

export type PayoutHealthStatus = typeof PayoutHealthStatus[keyof typeof PayoutHealthStatus];
export type __SHOULD_NOT_USE__PayoutOperationError = {
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  payoutCode: Maybe<Scalars['String']['output']>;
  payoutId: Scalars['ID']['output'];
};

export type __SHOULD_NOT_USE__PayoutOrderByInput = {
  direction: SortOrder;
  field: PayoutOrderField;
};

export const PayoutOrderField = {
  Amount: 'AMOUNT',
  Code: 'CODE',
  CompletedAt: 'COMPLETED_AT',
  CreatedAt: 'CREATED_AT',
  ProcessedAt: 'PROCESSED_AT',
  Status: 'STATUS'
} as const;

export type PayoutOrderField = typeof PayoutOrderField[keyof typeof PayoutOrderField];
export type __SHOULD_NOT_USE__PayoutOverview = {
  /** Per-currency breakdown for hover popups */
  currencyBreakdown: Array<__SHOULD_NOT_USE__PayoutOverviewCurrencyBreakdown>;
  /** Primary currency used for card 3 display */
  primaryCurrency: Currency;
  /** Total COMPLETED payouts across all currencies (card 2 main number) */
  totalCompletedPayouts: Scalars['Int']['output'];
  /** Total PENDING payouts across all currencies (card 1 main number) */
  totalIncomingPayouts: Scalars['Int']['output'];
  /** Total COMPLETED payout amount in primary currency (card 3 main number) */
  totalPayoutAmount: Scalars['Float']['output'];
};

export type __SHOULD_NOT_USE__PayoutOverviewCurrencyBreakdown = {
  /** Sum of COMPLETED payout amounts for this currency */
  completedPayoutAmount: Scalars['Float']['output'];
  /** COMPLETED payout count for this currency */
  completedPayoutsCount: Scalars['Int']['output'];
  /** COMPLETED transfer count for this currency */
  completedTransferCount: Scalars['Int']['output'];
  currency: Currency;
  /** PENDING payout count for this currency */
  incomingPayoutsCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PayoutProcessingMetrics = {
  averageBankProcessingHours: Scalars['Float']['output'];
  averageHoursToComplete: Scalars['Float']['output'];
  averageHoursToProcess: Scalars['Float']['output'];
  completedCount: Scalars['Int']['output'];
  period: Scalars['String']['output'];
};

export const PayoutReportField = {
  Amount: 'AMOUNT',
  BankAccountId: 'BANK_ACCOUNT_ID',
  Code: 'CODE',
  CompletedAt: 'COMPLETED_AT',
  CreatedAt: 'CREATED_AT',
  Currency: 'CURRENCY',
  DisputeId: 'DISPUTE_ID',
  EstimatedSettlementAt: 'ESTIMATED_SETTLEMENT_AT',
  Notes: 'NOTES',
  ParentPayoutId: 'PARENT_PAYOUT_ID',
  PaymentId: 'PAYMENT_ID',
  PayoutType: 'PAYOUT_TYPE',
  ProcessedAt: 'PROCESSED_AT',
  ReceiverMerchantId: 'RECEIVER_MERCHANT_ID',
  RefundId: 'REFUND_ID',
  Status: 'STATUS',
  TransferId: 'TRANSFER_ID'
} as const;

export type PayoutReportField = typeof PayoutReportField[keyof typeof PayoutReportField];
export type __SHOULD_NOT_USE__PayoutSplitInput = {
  amount: Scalars['Float']['input'];
  bankAccountId: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export const PayoutStatus = {
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  Pending: 'PENDING',
  Processing: 'PROCESSING'
} as const;

export type PayoutStatus = typeof PayoutStatus[keyof typeof PayoutStatus];
export type __SHOULD_NOT_USE__PayoutSummary = {
  count: Scalars['Int']['output'];
  currency: Currency;
  newestPayoutDate: Maybe<Scalars['Time']['output']>;
  oldestPayoutDate: Maybe<Scalars['Time']['output']>;
  status: PayoutStatus;
  totalAmount: Scalars['Float']['output'];
};

export const PayoutType = {
  Adjustment: 'ADJUSTMENT',
  DisputeReceived: 'DISPUTE_RECEIVED',
  DisputeRelease: 'DISPUTE_RELEASE',
  Payment: 'PAYMENT',
  RefundDeduction: 'REFUND_DEDUCTION',
  Split: 'SPLIT'
} as const;

export type PayoutType = typeof PayoutType[keyof typeof PayoutType];
/**
 * PayoutWhereInput is used for filtering Payout objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PayoutWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** bank_account_id field predicates */
  bankAccountID?: InputMaybe<Scalars['ID']['input']>;
  bankAccountIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankAccountIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccountIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  bankAccountIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bankAccountIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** dispute_id field predicates */
  disputeID?: InputMaybe<Scalars['ID']['input']>;
  disputeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  disputeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  disputeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  disputeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  disputeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** estimated_settlement_at field predicates */
  estimatedSettlementAt?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtGT?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtGTE?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  estimatedSettlementAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedSettlementAtLT?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtLTE?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  estimatedSettlementAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  estimatedSettlementAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bank_account edge predicates */
  hasBankAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankAccountWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantBankAccountWhereInput>>;
  /** dispute edge predicates */
  hasDispute?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputeWith?: InputMaybe<Array<__SHOULD_NOT_USE__DisputeWhereInput>>;
  /** parent_payout edge predicates */
  hasParentPayout?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentPayoutWith?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** payment edge predicates */
  hasPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** receiver_merchant edge predicates */
  hasReceiverMerchant?: InputMaybe<Scalars['Boolean']['input']>;
  hasReceiverMerchantWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** refund edge predicates */
  hasRefund?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefundWith?: InputMaybe<Array<__SHOULD_NOT_USE__RefundWhereInput>>;
  /** split_payouts edge predicates */
  hasSplitPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasSplitPayoutsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** transfer edge predicates */
  hasTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  hasTransferWith?: InputMaybe<Array<__SHOULD_NOT_USE__TransferWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PayoutWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** parent_payout_id field predicates */
  parentPayoutID?: InputMaybe<Scalars['ID']['input']>;
  parentPayoutIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentPayoutIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentPayoutIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentPayoutIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentPayoutIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_id field predicates */
  paymentID?: InputMaybe<Scalars['ID']['input']>;
  paymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** payout_type field predicates */
  payoutType?: InputMaybe<PayoutType>;
  payoutTypeIn?: InputMaybe<Array<PayoutType>>;
  payoutTypeNEQ?: InputMaybe<PayoutType>;
  payoutTypeNotIn?: InputMaybe<Array<PayoutType>>;
  /** processed_at field predicates */
  processedAt?: InputMaybe<Scalars['Time']['input']>;
  processedAtGT?: InputMaybe<Scalars['Time']['input']>;
  processedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  processedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  processedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  processedAtLT?: InputMaybe<Scalars['Time']['input']>;
  processedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  processedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  processedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  processedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** receiver_merchant_id field predicates */
  receiverMerchantID?: InputMaybe<Scalars['ID']['input']>;
  receiverMerchantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  receiverMerchantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  receiverMerchantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** refund_id field predicates */
  refundID?: InputMaybe<Scalars['ID']['input']>;
  refundIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  refundIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  refundIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<PayoutStatus>;
  statusIn?: InputMaybe<Array<PayoutStatus>>;
  statusNEQ?: InputMaybe<PayoutStatus>;
  statusNotIn?: InputMaybe<Array<PayoutStatus>>;
  /** transfer_id field predicates */
  transferID?: InputMaybe<Scalars['ID']['input']>;
  transferIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  transferIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  transferIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  transferIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  transferIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__Permission = {
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  group: Maybe<__SHOULD_NOT_USE__PermissionGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissionFor: Maybe<Array<Maybe<PermissionFor>>>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__PermissionCheckResult = {
  contextMatches: Maybe<Scalars['Boolean']['output']>;
  grantedThrough: Maybe<Array<__SHOULD_NOT_USE__RolePermissionGrant>>;
  hasPermission: Scalars['Boolean']['output'];
  organizationType: Maybe<OrganizationType>;
};

export type __SHOULD_NOT_USE__PermissionConnection = {
  edges: Array<__SHOULD_NOT_USE__PermissionEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PermissionEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Permission;
};

export const PermissionFor = {
  Bank: 'BANK',
  Merchant: 'MERCHANT',
  Platform: 'PLATFORM'
} as const;

export type PermissionFor = typeof PermissionFor[keyof typeof PermissionFor];
export type __SHOULD_NOT_USE__PermissionGroup = {
  activePermissionCount: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissionCount: Scalars['Int']['output'];
  permissionFor: Maybe<Array<Maybe<PermissionFor>>>;
  permissions: Array<__SHOULD_NOT_USE__Permission>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__PermissionGroupConnection = {
  edges: Array<__SHOULD_NOT_USE__PermissionGroupEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PermissionGroupEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__PermissionGroup;
};

export type __SHOULD_NOT_USE__PermissionGroupOrderByField = {
  direction: SortOrder;
  field: PermissionGroupOrderField;
};

export const PermissionGroupOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  Slug: 'SLUG',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PermissionGroupOrderField = typeof PermissionGroupOrderField[keyof typeof PermissionGroupOrderField];
export type __SHOULD_NOT_USE__PermissionGroupSortInput = {
  orderBy: Array<__SHOULD_NOT_USE__PermissionGroupOrderByField>;
};

/**
 * PermissionGroupWhereInput is used for filtering PermissionGroup objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PermissionGroupWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** permissions edge predicates */
  hasPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PermissionGroupWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionGroupWhereInput>>;
  /** Filter permission groups that contain this specific permission level */
  permissionForContains?: InputMaybe<PermissionFor>;
  /** Filter permission groups that contain ALL of the specified permission levels */
  permissionForHasAll?: InputMaybe<Array<PermissionFor>>;
  /** Filter permission groups that contain ANY of the specified permission levels */
  permissionForHasAny?: InputMaybe<Array<PermissionFor>>;
  /** Filter permission groups that do NOT contain this specific permission level */
  permissionForNotContains?: InputMaybe<PermissionFor>;
  /** slug field predicates */
  slug?: InputMaybe<Scalars['String']['input']>;
  slugContains?: InputMaybe<Scalars['String']['input']>;
  slugContainsFold?: InputMaybe<Scalars['String']['input']>;
  slugEqualFold?: InputMaybe<Scalars['String']['input']>;
  slugGT?: InputMaybe<Scalars['String']['input']>;
  slugGTE?: InputMaybe<Scalars['String']['input']>;
  slugHasPrefix?: InputMaybe<Scalars['String']['input']>;
  slugHasSuffix?: InputMaybe<Scalars['String']['input']>;
  slugIn?: InputMaybe<Array<Scalars['String']['input']>>;
  slugLT?: InputMaybe<Scalars['String']['input']>;
  slugLTE?: InputMaybe<Scalars['String']['input']>;
  slugNEQ?: InputMaybe<Scalars['String']['input']>;
  slugNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__PermissionOrderByField = {
  direction: SortOrder;
  field: PermissionOrderField;
};

export const PermissionOrderField = {
  CreatedAt: 'CREATED_AT',
  GroupId: 'GROUP_ID',
  Name: 'NAME',
  PermissionFor: 'PERMISSION_FOR',
  Slug: 'SLUG',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PermissionOrderField = typeof PermissionOrderField[keyof typeof PermissionOrderField];
export type __SHOULD_NOT_USE__PermissionRole = {
  grantedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  permission: __SHOULD_NOT_USE__Permission;
  revokedAt: Maybe<Scalars['Time']['output']>;
  role: __SHOULD_NOT_USE__Role;
};

export type __SHOULD_NOT_USE__PermissionRoleConnection = {
  edges: Array<__SHOULD_NOT_USE__PermissionRoleEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PermissionRoleEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__PermissionRole;
};

/**
 * PermissionRoleWhereInput is used for filtering PermissionRole objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PermissionRoleWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PermissionRoleWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionRoleWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__PermissionSortInput = {
  orderBy: Array<__SHOULD_NOT_USE__PermissionOrderByField>;
};

/**
 * PermissionWhereInput is used for filtering Permission objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PermissionWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** group_id field predicates */
  groupID?: InputMaybe<Scalars['ID']['input']>;
  groupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  groupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  groupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group edge predicates */
  hasGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasGroupWith?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionGroupWhereInput>>;
  /** permission_roles edge predicates */
  hasPermissionRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionRolesWith?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionRoleWhereInput>>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<__SHOULD_NOT_USE__RoleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PermissionWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionWhereInput>>;
  /** Filter permission groups that contain this specific permission level */
  permissionForContains?: InputMaybe<PermissionFor>;
  /** Filter permission groups that contain ALL of the specified permission levels */
  permissionForHasAll?: InputMaybe<Array<PermissionFor>>;
  /** Filter permission groups that contain ANY of the specified permission levels */
  permissionForHasAny?: InputMaybe<Array<PermissionFor>>;
  /** Filter permission groups that do NOT contain this specific permission level */
  permissionForNotContains?: InputMaybe<PermissionFor>;
  /** slug field predicates */
  slug?: InputMaybe<Scalars['String']['input']>;
  slugContains?: InputMaybe<Scalars['String']['input']>;
  slugContainsFold?: InputMaybe<Scalars['String']['input']>;
  slugEqualFold?: InputMaybe<Scalars['String']['input']>;
  slugGT?: InputMaybe<Scalars['String']['input']>;
  slugGTE?: InputMaybe<Scalars['String']['input']>;
  slugHasPrefix?: InputMaybe<Scalars['String']['input']>;
  slugHasSuffix?: InputMaybe<Scalars['String']['input']>;
  slugIn?: InputMaybe<Array<Scalars['String']['input']>>;
  slugLT?: InputMaybe<Scalars['String']['input']>;
  slugLTE?: InputMaybe<Scalars['String']['input']>;
  slugNEQ?: InputMaybe<Scalars['String']['input']>;
  slugNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__PolicyDocument = {
  acceptanceCount: Scalars['Int']['output'];
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['Map']['output'];
  createdAt: Scalars['Time']['output'];
  createdByOrg: Maybe<__SHOULD_NOT_USE__Organization>;
  createdByOrgType: OrganizationType;
  deprecatedAt: Maybe<Scalars['Time']['output']>;
  effectiveDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  parentPolicy: Maybe<__SHOULD_NOT_USE__PolicyDocument>;
  policyTarget: PolicyTarget;
  policyType: PolicyType;
  template: Maybe<__SHOULD_NOT_USE__PolicyTemplate>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  version: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__PolicyDocumentConnection = {
  edges: Array<__SHOULD_NOT_USE__PolicyDocumentEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PolicyDocumentEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__PolicyDocument;
};

/**
 * PolicyDocumentWhereInput is used for filtering PolicyDocument objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PolicyDocumentWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_org_id field predicates */
  createdByOrgID?: InputMaybe<Scalars['ID']['input']>;
  createdByOrgIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByOrgIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByOrgIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByOrgIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByOrgIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by_org_type field predicates */
  createdByOrgType?: InputMaybe<OrganizationType>;
  createdByOrgTypeIn?: InputMaybe<Array<OrganizationType>>;
  createdByOrgTypeNEQ?: InputMaybe<OrganizationType>;
  createdByOrgTypeNotIn?: InputMaybe<Array<OrganizationType>>;
  /** deprecated_at field predicates */
  deprecatedAt?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deprecatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deprecatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deprecatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** child_policies edge predicates */
  hasChildPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildPoliciesWith?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** created_by_organization edge predicates */
  hasCreatedByOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** merchant_acceptances edge predicates */
  hasMerchantAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantAcceptancesWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>>;
  /** merchant_defaults edge predicates */
  hasMerchantDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantDefaultsWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantDefaultPolicyWhereInput>>;
  /** parent_policy edge predicates */
  hasParentPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentPolicyWith?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** template edge predicates */
  hasTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateWith?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyTemplateWhereInput>>;
  /** user_acceptances edge predicates */
  hasUserAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserAcceptancesWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserPolicyAcceptanceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_current field predicates */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__PolicyDocumentWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** parent_policy_id field predicates */
  parentPolicyID?: InputMaybe<Scalars['ID']['input']>;
  parentPolicyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentPolicyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentPolicyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentPolicyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentPolicyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** policy_target field predicates */
  policyTarget?: InputMaybe<PolicyTarget>;
  policyTargetIn?: InputMaybe<Array<PolicyTarget>>;
  policyTargetNEQ?: InputMaybe<PolicyTarget>;
  policyTargetNotIn?: InputMaybe<Array<PolicyTarget>>;
  /** policy_type field predicates */
  policyType?: InputMaybe<PolicyType>;
  policyTypeIn?: InputMaybe<Array<PolicyType>>;
  policyTypeNEQ?: InputMaybe<PolicyType>;
  policyTypeNotIn?: InputMaybe<Array<PolicyType>>;
  /** template_id field predicates */
  templateID?: InputMaybe<Scalars['ID']['input']>;
  templateIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  templateIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  templateIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** version field predicates */
  version?: InputMaybe<Scalars['String']['input']>;
  versionContains?: InputMaybe<Scalars['String']['input']>;
  versionContainsFold?: InputMaybe<Scalars['String']['input']>;
  versionEqualFold?: InputMaybe<Scalars['String']['input']>;
  versionGT?: InputMaybe<Scalars['String']['input']>;
  versionGTE?: InputMaybe<Scalars['String']['input']>;
  versionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  versionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  versionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  versionLT?: InputMaybe<Scalars['String']['input']>;
  versionLTE?: InputMaybe<Scalars['String']['input']>;
  versionNEQ?: InputMaybe<Scalars['String']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export const PolicyTarget = {
  Customer: 'CUSTOMER',
  EndUser: 'END_USER',
  Merchant: 'MERCHANT'
} as const;

export type PolicyTarget = typeof PolicyTarget[keyof typeof PolicyTarget];
export type __SHOULD_NOT_USE__PolicyTemplate = {
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['Map']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  policyType: PolicyType;
  updatedAt: Scalars['Time']['output'];
  usageCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PolicyTemplateConnection = {
  edges: Array<__SHOULD_NOT_USE__PolicyTemplateEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__PolicyTemplateEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__PolicyTemplate;
};

/**
 * PolicyTemplateWhereInput is used for filtering PolicyTemplate objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__PolicyTemplateWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyTemplateWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** policies_created edge predicates */
  hasPoliciesCreated?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesCreatedWith?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__PolicyTemplateWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyTemplateWhereInput>>;
  /** policy_type field predicates */
  policyType?: InputMaybe<PolicyType>;
  policyTypeIn?: InputMaybe<Array<PolicyType>>;
  policyTypeNEQ?: InputMaybe<PolicyType>;
  policyTypeNotIn?: InputMaybe<Array<PolicyType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const PolicyType = {
  BankTermsOfService: 'BANK_TERMS_OF_SERVICE',
  CancellationPolicy: 'CANCELLATION_POLICY',
  PaymentTerms: 'PAYMENT_TERMS',
  PlatformPrivacyPolicy: 'PLATFORM_PRIVACY_POLICY',
  PlatformTermsAndConditions: 'PLATFORM_TERMS_AND_CONDITIONS',
  PlatformTermsOfService: 'PLATFORM_TERMS_OF_SERVICE',
  RefundPolicy: 'REFUND_POLICY'
} as const;

export type PolicyType = typeof PolicyType[keyof typeof PolicyType];
export type __SHOULD_NOT_USE__ProcessApiPaymentInput = {
  apiPaymentAccessKey: Scalars['String']['input'];
  cardType?: InputMaybe<CardType>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  paymentMethodToken: Scalars['String']['input'];
  paymentType: PaymentType;
};

export type __SHOULD_NOT_USE__ProcessApiPaymentPayload = {
  alreadyProcessed: Scalars['Boolean']['output'];
  apiPayment: Maybe<__SHOULD_NOT_USE__ApiPayment>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  feeBreakdown: Maybe<__SHOULD_NOT_USE__PaymentFeeBreakdown>;
  payment: Maybe<__SHOULD_NOT_USE__Payment>;
};

export type __SHOULD_NOT_USE__ProcessInvoicePaymentInput = {
  cardType?: InputMaybe<CardType>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  invoiceAccessKey: Scalars['String']['input'];
  paymentMethodToken: Scalars['String']['input'];
  paymentType: PaymentType;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__ProcessInvoicePaymentPayload = {
  alreadyProcessed: Scalars['Boolean']['output'];
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  feeBreakdown: Maybe<__SHOULD_NOT_USE__PaymentFeeBreakdown>;
  invoice: Maybe<__SHOULD_NOT_USE__Invoice>;
  payment: Maybe<__SHOULD_NOT_USE__Payment>;
};

export type __SHOULD_NOT_USE__ProcessQuickPayPaymentInput = {
  amount: Scalars['Float']['input'];
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<CardType>;
  customerEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  paymentMethodToken: Scalars['String']['input'];
  paymentType: PaymentType;
  quickPayAccessKey: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__ProcessQuickPayPaymentPayload = {
  alreadyProcessed: Scalars['Boolean']['output'];
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  feeBreakdown: Maybe<__SHOULD_NOT_USE__PaymentFeeBreakdown>;
  payment: Maybe<__SHOULD_NOT_USE__Payment>;
  quickPay: Maybe<__SHOULD_NOT_USE__QuickPay>;
};

export type __SHOULD_NOT_USE__ProcessRefundInput = {
  id: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__ProcessRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export const ProductServiceType = {
  DigitalGoods: 'DIGITAL_GOODS',
  Other: 'OTHER',
  PhysicalGoods: 'PHYSICAL_GOODS',
  Services: 'SERVICES',
  Subscription: 'SUBSCRIPTION'
} as const;

export type ProductServiceType = typeof ProductServiceType[keyof typeof ProductServiceType];
export type __SHOULD_NOT_USE__ProviderDoc = {
  Name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: __SHOULD_NOT_USE__DownloadUrl;
};

export type __SHOULD_NOT_USE__ProviderPerformance = {
  averageAmount: Scalars['Float']['output'];
  failedPayments: Scalars['Int']['output'];
  provider: __SHOULD_NOT_USE__PaymentProvider;
  successRate: Scalars['Float']['output'];
  successfulPayments: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Int']['output'];
  totalProviderFees: Scalars['Float']['output'];
};

export const ProviderStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Maintenance: 'MAINTENANCE'
} as const;

export type ProviderStatus = typeof ProviderStatus[keyof typeof ProviderStatus];
export const QrCodeFormat = {
  Png: 'PNG',
  Svg: 'SVG'
} as const;

export type QrCodeFormat = typeof QrCodeFormat[keyof typeof QrCodeFormat];
export type __SHOULD_NOT_USE__QrCodePayload = {
  /** Format of the generated QR code */
  format: QrCodeFormat;
  /** Size of the generated QR code */
  size: QrCodeSize;
  /** CDN URL for the generated QR code image */
  url: Scalars['String']['output'];
};

export const QrCodeSize = {
  Large: 'LARGE',
  Medium: 'MEDIUM',
  Small: 'SMALL'
} as const;

export type QrCodeSize = typeof QrCodeSize[keyof typeof QrCodeSize];
export type __SHOULD_NOT_USE__Query = {
  DownloadDisputeReport: Maybe<__SHOULD_NOT_USE__DownloadDisputeReportPayload>;
  /** All merchant bank accounts pending bank admin action, across every bank (platform admin only) */
  allBanksPendingApprovals: Maybe<__SHOULD_NOT_USE__MerchantBankAccountConnection>;
  apiKey: Maybe<__SHOULD_NOT_USE__ApiKey>;
  apiKeys: Maybe<__SHOULD_NOT_USE__ApiKeyConnection>;
  apiLog: Maybe<__SHOULD_NOT_USE__ApiLog>;
  apiLogs: Maybe<__SHOULD_NOT_USE__ApiLogConnection>;
  apiPayment: Maybe<__SHOULD_NOT_USE__ApiPayment>;
  apiPaymentByAccessKey: Maybe<__SHOULD_NOT_USE__ApiPayment>;
  apiPaymentStats: Maybe<__SHOULD_NOT_USE__ApiPaymentStatistics>;
  apiPayments: Maybe<__SHOULD_NOT_USE__ApiPaymentConnection>;
  authContext: __SHOULD_NOT_USE__AuthContext;
  availablePayoutsForTransfer: Maybe<__SHOULD_NOT_USE__PayoutConnection>;
  /**
   * Get available payment types that support recurring/subscription payments.
   * Used on hosted checkout page to show customers which payment methods they can use for subscriptions.
   * Filters by active providers and enabled payment types that have supports_recurring = true.
   */
  availableRecurringPaymentTypes: Array<__SHOULD_NOT_USE__PaymentProviderPaymentType>;
  bankManagedAccounts: Maybe<__SHOULD_NOT_USE__MerchantBankAccountConnection>;
  bankPendingApprovals: Maybe<__SHOULD_NOT_USE__MerchantBankAccountConnection>;
  bankPendingRefunds: Maybe<__SHOULD_NOT_USE__RefundConnection>;
  bankTransfers: Maybe<__SHOULD_NOT_USE__TransferConnection>;
  /**
   * Paginated bank organizations (platform admin only). The type filter is
   * forced to BANK server-side regardless of the caller's where input. Unlike
   * the public getBanks picker, this is the management listing.
   */
  banks: Maybe<__SHOULD_NOT_USE__OrganizationConnection>;
  billingAddress: Maybe<__SHOULD_NOT_USE__BillingAddress>;
  billingAddresses: Maybe<__SHOULD_NOT_USE__BillingAddressConnection>;
  checkBankCompliance: Maybe<__SHOULD_NOT_USE__ComplianceStatus>;
  checkMerchantCompliance: Maybe<__SHOULD_NOT_USE__ComplianceStatus>;
  checkUserCompliance: __SHOULD_NOT_USE__UserComplianceStatus;
  checkUserPermission: Maybe<__SHOULD_NOT_USE__PermissionCheckResult>;
  currentBankPolicies: Maybe<Array<__SHOULD_NOT_USE__PolicyDocument>>;
  currentOrganization: Maybe<__SHOULD_NOT_USE__Organization>;
  currentPlatformPolicies: Maybe<Array<__SHOULD_NOT_USE__PolicyDocument>>;
  customerPaymentHistory: Maybe<__SHOULD_NOT_USE__CustomerPaymentHistory>;
  defaultQuickPay: __SHOULD_NOT_USE__QuickPay;
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  disputes: Maybe<__SHOULD_NOT_USE__DisputeConnection>;
  downloadDailyPaymentReport: Maybe<__SHOULD_NOT_USE__DownloadDailyReportPayload>;
  downloadMerchantReport: Maybe<__SHOULD_NOT_USE__DownloadMerchantReportPayload>;
  downloadPaymentReceipt: Maybe<__SHOULD_NOT_USE__DownloadPaymentReceiptPayload>;
  downloadPaymentReport: Maybe<__SHOULD_NOT_USE__DownloadPaymentReportPayload>;
  downloadPayoutReport: Maybe<__SHOULD_NOT_USE__DownloadPayoutReportPayload>;
  downloadRefundReport: Maybe<__SHOULD_NOT_USE__DownloadRefundReportPayload>;
  downloadTransferReport: Maybe<__SHOULD_NOT_USE__DownloadTransferReportPayload>;
  effectivePolicyForInvoice: Maybe<__SHOULD_NOT_USE__PolicyDocument>;
  entityHistory: Maybe<__SHOULD_NOT_USE__EventConnection>;
  event: Maybe<__SHOULD_NOT_USE__Event>;
  events: Maybe<__SHOULD_NOT_USE__EventConnection>;
  getApiPaymentSuccessResponseUrl: Maybe<__SHOULD_NOT_USE__ApiPaymentSuccessResponseUrlPayload>;
  getAvailableRefundAmount: Maybe<Scalars['Float']['output']>;
  getBanks: Maybe<Array<Maybe<__SHOULD_NOT_USE__Organization>>>;
  getRecurringPaymentByCheckoutSession: __SHOULD_NOT_USE__RecurringPayment;
  /**
   * Get recurring payment details for the update payment method page.
   * No auth — validated via update_session_id.
   */
  getRecurringPaymentByUpdateSession: __SHOULD_NOT_USE__RecurringPayment;
  getUploadPresignUrl: __SHOULD_NOT_USE__UploadUrl;
  introspectToken: __SHOULD_NOT_USE__IntrospectTokenPayload;
  invoice: Maybe<__SHOULD_NOT_USE__Invoice>;
  invoiceByAccessKey: Maybe<__SHOULD_NOT_USE__Invoice>;
  /**
   * Generate/retrieve QR code for a paylink by access key.
   * Unauthenticated — access gated by knowledge of UUID access key.
   */
  invoiceQRCode: __SHOULD_NOT_USE__QrCodePayload;
  invoiceSummary: Maybe<__SHOULD_NOT_USE__InvoiceSummary>;
  invoices: Maybe<__SHOULD_NOT_USE__InvoiceConnection>;
  manuallyPaidInvoicesWithoutPayout: Maybe<__SHOULD_NOT_USE__InvoiceConnection>;
  me: Maybe<__SHOULD_NOT_USE__User>;
  media: Maybe<__SHOULD_NOT_USE__Media>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  merchantBankAccounts: Maybe<__SHOULD_NOT_USE__MerchantBankAccountConnection>;
  merchantBankAccountsList: Maybe<__SHOULD_NOT_USE__MerchantBankAccountConnection>;
  merchantDefaultPolicies: Maybe<Array<__SHOULD_NOT_USE__MerchantDefaultPolicy>>;
  merchantDisputes: Maybe<__SHOULD_NOT_USE__DisputeConnection>;
  merchantInvoices: Maybe<__SHOULD_NOT_USE__InvoiceConnection>;
  merchantPayments: Maybe<__SHOULD_NOT_USE__PaymentConnection>;
  /**
   * Merchant payout summary cards — Total Paid Out and Available Payouts.
   * Returns one item per currency. Optionally filter to specific currencies.
   */
  merchantPayoutDashboard: __SHOULD_NOT_USE__MerchantPayoutDashboard;
  merchantPayouts: Maybe<__SHOULD_NOT_USE__PayoutConnection>;
  merchantPolicyAcceptances: Maybe<__SHOULD_NOT_USE__MerchantPolicyAcceptanceConnection>;
  merchantPrimaryBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  merchantQuickPays: __SHOULD_NOT_USE__QuickPayConnection;
  merchantRefunds: Maybe<__SHOULD_NOT_USE__RefundConnection>;
  merchantWebhook: Maybe<__SHOULD_NOT_USE__MerchantWebhook>;
  merchantWebhooks: Maybe<__SHOULD_NOT_USE__MerchantWebhookConnection>;
  merchantpermissions: __SHOULD_NOT_USE__PermissionConnection;
  /** All disputes on the payer's payments, newest first. Service-account only. */
  mobileCustomerDisputes: Array<__SHOULD_NOT_USE__MobileDispute>;
  /** Header stats + filter-sheet bounds for the payer. Service-account only. */
  mobileCustomerTransactionSummary: __SHOULD_NOT_USE__MobileCustomerTxnSummary;
  /**
   * The payer's transaction feed across every merchant, resolved by the
   * customer external_id (= mobile backend user ID). Service-account only.
   */
  mobileCustomerTransactions: __SHOULD_NOT_USE__MobileTxnList;
  /**
   * ACTIVE merchants with canReceiveDonation enabled, a payable default
   * QuickPay, and an APPROVED bank account at a bank that settles the given
   * payment channel (the mobile backend passes MOBILE).
   */
  mobileDonationOrganizations: Array<__SHOULD_NOT_USE__MobileDonationOrganization>;
  /**
   * The window collapsed into a single 24-hour profile, answering "when is the
   * shop busy". Always exactly 24 rows, hour 0 through 23, zeros included:
   * the domain is fixed, so completing it here saves every caller the padding.
   * Service-account only.
   */
  mobileMerchantActivityByHour: Array<__SHOULD_NOT_USE__MobileMerchantActivityHour>;
  /** Merchant Insights header: revenue, sales, known customers, refunds. Service-account only. */
  mobileMerchantInsightsSummary: __SHOULD_NOT_USE__MobileMerchantInsightsSummary;
  /**
   * Revenue bucketed by hour/day/month/year in Asia/Thimphu. Sparse — see
   * MobileMerchantRevenueSeries. Service-account only.
   */
  mobileMerchantRevenueSeries: __SHOULD_NOT_USE__MobileMerchantRevenueSeries;
  /** Header stats + filter bounds for a merchant org. Service-account only. */
  mobileMerchantTransactionSummary: __SHOULD_NOT_USE__MobileCustomerTxnSummary;
  /**
   * A merchant organization's received feed (payments in, refunds out). The org
   * ID is asserted by the trusted mobile backend from its own validated merchant
   * session. Service-account only.
   */
  mobileMerchantTransactions: __SHOULD_NOT_USE__MobileTxnList;
  mobileOrganization: Maybe<__SHOULD_NOT_USE__Organization>;
  /**
   * Signed download URL for a succeeded payment's receipt PDF, generated and
   * cached on first request. Null while the payment is not succeeded. The
   * payment ID is asserted by the trusted mobile backend from an entry it
   * already fetched for the requesting user. Service-account only.
   */
  mobilePaymentReceipt: Maybe<__SHOULD_NOT_USE__DownloadUrl>;
  /** List a mobile user's saved cards (service-account only) */
  mobileSavedCards: Array<__SHOULD_NOT_USE__MobileSavedCard>;
  myDefaultPolicies: Maybe<Array<__SHOULD_NOT_USE__MerchantDefaultPolicy>>;
  myMerchantPolicies: Maybe<Array<__SHOULD_NOT_USE__PolicyDocument>>;
  myOrganizationAcceptances: Maybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptance>>;
  myPolicyAcceptances: Maybe<Array<__SHOULD_NOT_USE__UserPolicyAcceptance>>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
  organizationAPIKeys: Maybe<__SHOULD_NOT_USE__ApiKeyConnection>;
  organizationAPIPayments: Maybe<__SHOULD_NOT_USE__ApiPaymentConnection>;
  organizationAuditLog: Maybe<__SHOULD_NOT_USE__EventConnection>;
  organizationPaymentType: Maybe<__SHOULD_NOT_USE__OrganizationPaymentType>;
  organizationPaymentTypes: Array<__SHOULD_NOT_USE__OrganizationPaymentType>;
  organizationRoles: Maybe<__SHOULD_NOT_USE__RoleConnection>;
  organizationUsers: __SHOULD_NOT_USE__UserConnection;
  organizations: Maybe<__SHOULD_NOT_USE__OrganizationConnection>;
  overdueInvoices: Maybe<__SHOULD_NOT_USE__InvoiceConnection>;
  payment: Maybe<__SHOULD_NOT_USE__Payment>;
  paymentAnalytics: Maybe<Array<__SHOULD_NOT_USE__PaymentAnalytics>>;
  paymentFailureAnalysis: Maybe<Array<__SHOULD_NOT_USE__PaymentFailureAnalysis>>;
  paymentPayouts: Maybe<Array<__SHOULD_NOT_USE__Payout>>;
  paymentProvider: Maybe<__SHOULD_NOT_USE__PaymentProvider>;
  /**
   * Get the highest priority active payment provider that supports the specified card type and payment type.
   * Optionally filter by currency. Returns null if no matching provider is found.
   * This query is typically used during checkout to determine the appropriate gateway for a specific card.
   */
  paymentProviderByCardType: Maybe<__SHOULD_NOT_USE__PaymentProvider>;
  paymentProviderCardType: Maybe<__SHOULD_NOT_USE__PaymentProviderCardType>;
  paymentProviderCardTypes: Array<__SHOULD_NOT_USE__PaymentProviderCardType>;
  paymentProviderPaymentType: Maybe<__SHOULD_NOT_USE__PaymentProviderPaymentType>;
  paymentProviderPaymentTypes: Array<__SHOULD_NOT_USE__PaymentProviderPaymentType>;
  paymentProviders: __SHOULD_NOT_USE__PaymentProviderConnection;
  paymentProvidersByType: Array<__SHOULD_NOT_USE__PaymentProvider>;
  paymentSummary: Maybe<__SHOULD_NOT_USE__PaymentSummary>;
  payments: Maybe<__SHOULD_NOT_USE__PaymentConnection>;
  payout: Maybe<__SHOULD_NOT_USE__Payout>;
  payoutOrganizations: Maybe<__SHOULD_NOT_USE__OrganizationConnection>;
  /**
   * Optional bankId filter — bank users pass their bank org ID to scope
   * payouts/transfers to their bank only. Platform admins omit for global view.
   */
  payoutOverview: __SHOULD_NOT_USE__PayoutOverview;
  payoutProcessingMetrics: Maybe<__SHOULD_NOT_USE__PayoutProcessingMetrics>;
  payoutSummary: Maybe<Array<__SHOULD_NOT_USE__PayoutSummary>>;
  payouts: Maybe<__SHOULD_NOT_USE__PayoutConnection>;
  permission: Maybe<__SHOULD_NOT_USE__Permission>;
  permissionGroup: Maybe<__SHOULD_NOT_USE__PermissionGroup>;
  permissionGroupBySlug: Maybe<__SHOULD_NOT_USE__PermissionGroup>;
  permissionGroups: __SHOULD_NOT_USE__PermissionGroupConnection;
  permissions: Maybe<__SHOULD_NOT_USE__PermissionConnection>;
  platformPendingRefunds: Maybe<__SHOULD_NOT_USE__RefundConnection>;
  policyDocument: Maybe<__SHOULD_NOT_USE__PolicyDocument>;
  policyDocumentVersionHistory: Maybe<Array<__SHOULD_NOT_USE__PolicyDocument>>;
  policyDocuments: Maybe<__SHOULD_NOT_USE__PolicyDocumentConnection>;
  policyTemplate: Maybe<__SHOULD_NOT_USE__PolicyTemplate>;
  policyTemplates: Maybe<__SHOULD_NOT_USE__PolicyTemplateConnection>;
  providerPerformance: Maybe<Array<__SHOULD_NOT_USE__ProviderPerformance>>;
  quickPay: __SHOULD_NOT_USE__QuickPay;
  quickPayByAccessKey: __SHOULD_NOT_USE__QuickPayPublic;
  /** Manual-entry fallback: resolve the human-readable code printed next to the QR */
  quickPayByCode: __SHOULD_NOT_USE__QuickPayPublic;
  quickPayFeeEstimate: __SHOULD_NOT_USE__QuickPayFeeEstimate;
  quickPays: __SHOULD_NOT_USE__QuickPayConnection;
  recentActivity: Array<__SHOULD_NOT_USE__Event>;
  recurringPayment: __SHOULD_NOT_USE__RecurringPayment;
  recurringPayments: __SHOULD_NOT_USE__RecurringPaymentConnection;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
  refundAnalytics: Maybe<__SHOULD_NOT_USE__RefundAnalytics>;
  refundSummary: Maybe<__SHOULD_NOT_USE__RefundSummary>;
  refunds: Maybe<__SHOULD_NOT_USE__RefundConnection>;
  revenueDashboard: Maybe<__SHOULD_NOT_USE__RevenueDashboard>;
  role: Maybe<__SHOULD_NOT_USE__Role>;
  rolePermissions: Maybe<__SHOULD_NOT_USE__PermissionRoleConnection>;
  roles: Maybe<__SHOULD_NOT_USE__RoleConnection>;
  searchPayments: Maybe<__SHOULD_NOT_USE__PaymentConnection>;
  serviceAccountWebhook: Maybe<__SHOULD_NOT_USE__ServiceAccountWebhook>;
  serviceAccountWebhooks: Maybe<__SHOULD_NOT_USE__ServiceAccountWebhookConnection>;
  /**
   * Lists all service accounts. Platform only — used by the admin dashboard to
   * pick a service account to attach a webhook to.
   */
  serviceAccounts: Array<__SHOULD_NOT_USE__ServiceAccount>;
  splitPayments: Maybe<__SHOULD_NOT_USE__SplitPaymentConnection>;
  transfer: Maybe<__SHOULD_NOT_USE__Transfer>;
  transferByCode: Maybe<__SHOULD_NOT_USE__Transfer>;
  transferSummary: Maybe<Array<__SHOULD_NOT_USE__TransferSummary>>;
  transfers: Maybe<__SHOULD_NOT_USE__TransferConnection>;
  user: Maybe<__SHOULD_NOT_USE__User>;
  userActivity: Maybe<__SHOULD_NOT_USE__EventConnection>;
  userPermissions: Maybe<__SHOULD_NOT_USE__PermissionConnection>;
  userPolicyAcceptances: Maybe<__SHOULD_NOT_USE__UserPolicyAcceptanceConnection>;
  userRoles: Maybe<__SHOULD_NOT_USE__UserRoleConnection>;
  users: __SHOULD_NOT_USE__UserConnection;
  verifyAccessToken: Maybe<__SHOULD_NOT_USE__SuccessPayload>;
  webhookDeliveries: __SHOULD_NOT_USE__WebhookDeliveryConnection;
  webhookDelivery: Maybe<__SHOULD_NOT_USE__WebhookDelivery>;
  webhookEventType: Maybe<__SHOULD_NOT_USE__WebhookEventType>;
  webhookEventTypes: Array<__SHOULD_NOT_USE__WebhookEventType>;
};


export type __SHOULD_NOT_USE__QueryDownloadDisputeReportArgs = {
  fields: Array<DisputeReportField>;
  where?: InputMaybe<__SHOULD_NOT_USE__DisputeWhereInput>;
};


export type __SHOULD_NOT_USE__QueryAllBanksPendingApprovalsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryApiKeysArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__ApiKeyOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__ApiKeyWhereInput>;
};


export type __SHOULD_NOT_USE__QueryApiLogArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryApiLogsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__ApiLogOrderByInput>;
  pagination: __SHOULD_NOT_USE__PaginationInput;
  where?: InputMaybe<__SHOULD_NOT_USE__ApiLogWhereInput>;
};


export type __SHOULD_NOT_USE__QueryApiPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryApiPaymentByAccessKeyArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryApiPaymentStatsArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};


export type __SHOULD_NOT_USE__QueryApiPaymentsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__ApiPaymentOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__ApiPaymentWhereInput>;
};


export type __SHOULD_NOT_USE__QueryAvailablePayoutsForTransferArgs = {
  bankId: Scalars['ID']['input'];
  currency: Currency;
  orderBy?: InputMaybe<__SHOULD_NOT_USE__PayoutOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryAvailableRecurringPaymentTypesArgs = {
  currency: Scalars['String']['input'];
  environment?: InputMaybe<PaymentEnvironment>;
};


export type __SHOULD_NOT_USE__QueryBankManagedAccountsArgs = {
  bankId: Scalars['ID']['input'];
  orderBy?: InputMaybe<__SHOULD_NOT_USE__MerchantBankAccountOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__MerchantBankAccountWhereInput>;
};


export type __SHOULD_NOT_USE__QueryBankPendingApprovalsArgs = {
  bankId: Scalars['ID']['input'];
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryBankPendingRefundsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryBankTransfersArgs = {
  bankId: Scalars['ID']['input'];
  currency?: InputMaybe<Array<Currency>>;
  orderBy?: InputMaybe<__SHOULD_NOT_USE__TransferOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  status?: InputMaybe<Array<TransferStatus>>;
};


export type __SHOULD_NOT_USE__QueryBanksArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  sort?: InputMaybe<__SHOULD_NOT_USE__OrganizationSortInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__OrganizationWhereInput>;
};


export type __SHOULD_NOT_USE__QueryBillingAddressArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryBillingAddressesArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__BillingAddressOrderByInput>;
  pagination: __SHOULD_NOT_USE__PaginationInput;
  where?: InputMaybe<__SHOULD_NOT_USE__BillingAddressWhereInput>;
};


export type __SHOULD_NOT_USE__QueryCheckBankComplianceArgs = {
  bankId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryCheckMerchantComplianceArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type __SHOULD_NOT_USE__QueryCheckUserPermissionArgs = {
  matchContext?: InputMaybe<Scalars['Boolean']['input']>;
  permissionSlug: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryCurrentBankPoliciesArgs = {
  bankId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryCurrentPlatformPoliciesArgs = {
  target: PolicyTarget;
};


export type __SHOULD_NOT_USE__QueryCustomerPaymentHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  customerEmail: Scalars['String']['input'];
  environment?: InputMaybe<PaymentEnvironment>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type __SHOULD_NOT_USE__QueryDisputeArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryDisputesArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__DisputeOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__DisputeWhereInput>;
};


export type __SHOULD_NOT_USE__QueryDownloadDailyPaymentReportArgs = {
  date: Scalars['Time']['input'];
  where?: InputMaybe<__SHOULD_NOT_USE__PaymentWhereInput>;
};


export type __SHOULD_NOT_USE__QueryDownloadMerchantReportArgs = {
  fields: Array<MerchantReportField>;
  where?: InputMaybe<__SHOULD_NOT_USE__OrganizationWhereInput>;
};


export type __SHOULD_NOT_USE__QueryDownloadPaymentReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryDownloadPaymentReportArgs = {
  fields: Array<PaymentReportField>;
  where?: InputMaybe<__SHOULD_NOT_USE__PaymentWhereInput>;
};


export type __SHOULD_NOT_USE__QueryDownloadPayoutReportArgs = {
  fields: Array<PayoutReportField>;
  where?: InputMaybe<__SHOULD_NOT_USE__PayoutWhereInput>;
};


export type __SHOULD_NOT_USE__QueryDownloadRefundReportArgs = {
  fields: Array<RefundReportField>;
  where?: InputMaybe<__SHOULD_NOT_USE__RefundWhereInput>;
};


export type __SHOULD_NOT_USE__QueryDownloadTransferReportArgs = {
  fields: Array<TransferReportField>;
  where?: InputMaybe<__SHOULD_NOT_USE__TransferWhereInput>;
};


export type __SHOULD_NOT_USE__QueryEffectivePolicyForInvoiceArgs = {
  organizationId: Scalars['ID']['input'];
  policyType: PolicyType;
};


export type __SHOULD_NOT_USE__QueryEntityHistoryArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  orderBy?: InputMaybe<__SHOULD_NOT_USE__EventOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryEventsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__EventOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__EventWhereInput>;
};


export type __SHOULD_NOT_USE__QueryGetApiPaymentSuccessResponseUrlArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryGetAvailableRefundAmountArgs = {
  paymentId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryGetBanksArgs = {
  channel?: InputMaybe<PaymentChannel>;
};


export type __SHOULD_NOT_USE__QueryGetRecurringPaymentByCheckoutSessionArgs = {
  checkoutSessionID: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryGetRecurringPaymentByUpdateSessionArgs = {
  updateSessionID: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryGetUploadPresignUrlArgs = {
  input: __SHOULD_NOT_USE__GenerateUploadUrlInput;
};


export type __SHOULD_NOT_USE__QueryIntrospectTokenArgs = {
  input: __SHOULD_NOT_USE__IntrospectTokenInput;
};


export type __SHOULD_NOT_USE__QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryInvoiceByAccessKeyArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryInvoiceQrCodeArgs = {
  accessKey: Scalars['String']['input'];
  format?: InputMaybe<QrCodeFormat>;
  size?: InputMaybe<QrCodeSize>;
};


export type __SHOULD_NOT_USE__QueryInvoiceSummaryArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};


export type __SHOULD_NOT_USE__QueryInvoicesArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__InvoiceOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__InvoiceWhereInput>;
};


export type __SHOULD_NOT_USE__QueryManuallyPaidInvoicesWithoutPayoutArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryMediaArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMerchantBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMerchantBankAccountsArgs = {
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  status?: InputMaybe<BankAccountStatus>;
};


export type __SHOULD_NOT_USE__QueryMerchantBankAccountsListArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__MerchantBankAccountOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__MerchantBankAccountWhereInput>;
};


export type __SHOULD_NOT_USE__QueryMerchantDefaultPoliciesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMerchantDisputesArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__DisputeOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__DisputeWhereInput>;
};


export type __SHOULD_NOT_USE__QueryMerchantInvoicesArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__InvoiceOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__InvoiceWhereInput>;
};


export type __SHOULD_NOT_USE__QueryMerchantPaymentsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__PaymentOrderBy>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PaymentWhereInput>;
};


export type __SHOULD_NOT_USE__QueryMerchantPayoutDashboardArgs = {
  currencies?: InputMaybe<Array<Currency>>;
};


export type __SHOULD_NOT_USE__QueryMerchantPayoutsArgs = {
  merchantId: Scalars['ID']['input'];
  orderBy?: InputMaybe<__SHOULD_NOT_USE__PayoutOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PayoutWhereInput>;
};


export type __SHOULD_NOT_USE__QueryMerchantPolicyAcceptancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  policyId?: InputMaybe<Scalars['ID']['input']>;
};


export type __SHOULD_NOT_USE__QueryMerchantPrimaryBankAccountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMerchantQuickPaysArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__QuickPayOrderByInput>;
  organizationId: Scalars['ID']['input'];
  pagination: __SHOULD_NOT_USE__PaginationInput;
  where?: InputMaybe<__SHOULD_NOT_USE__QuickPayWhereInput>;
};


export type __SHOULD_NOT_USE__QueryMerchantRefundsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__RefundOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__RefundWhereInput>;
};


export type __SHOULD_NOT_USE__QueryMerchantWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMerchantWebhooksArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__MerchantWebhookOrderByInput>;
  pagination: __SHOULD_NOT_USE__PaginationInput;
  where?: InputMaybe<__SHOULD_NOT_USE__MerchantWebhookWhereInput>;
};


export type __SHOULD_NOT_USE__QueryMerchantpermissionsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  searchquery?: InputMaybe<Scalars['String']['input']>;
};


export type __SHOULD_NOT_USE__QueryMobileCustomerDisputesArgs = {
  externalId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMobileCustomerTransactionSummaryArgs = {
  environment?: InputMaybe<PaymentEnvironment>;
  externalId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMobileCustomerTransactionsArgs = {
  externalId: Scalars['ID']['input'];
  filter?: InputMaybe<__SHOULD_NOT_USE__MobileTxnFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<MobileTxnOrder>;
};


export type __SHOULD_NOT_USE__QueryMobileDonationOrganizationsArgs = {
  channel: PaymentChannel;
};


export type __SHOULD_NOT_USE__QueryMobileMerchantActivityByHourArgs = {
  scope: __SHOULD_NOT_USE__MobileMerchantInsightsScopeInput;
};


export type __SHOULD_NOT_USE__QueryMobileMerchantInsightsSummaryArgs = {
  scope: __SHOULD_NOT_USE__MobileMerchantInsightsScopeInput;
};


export type __SHOULD_NOT_USE__QueryMobileMerchantRevenueSeriesArgs = {
  bucket: MobileInsightsBucket;
  scope: __SHOULD_NOT_USE__MobileMerchantInsightsScopeInput;
};


export type __SHOULD_NOT_USE__QueryMobileMerchantTransactionSummaryArgs = {
  environment?: InputMaybe<PaymentEnvironment>;
  merchantOrgId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMobileMerchantTransactionsArgs = {
  filter?: InputMaybe<__SHOULD_NOT_USE__MobileTxnFilterInput>;
  limit: Scalars['Int']['input'];
  merchantOrgId: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<MobileTxnOrder>;
};


export type __SHOULD_NOT_USE__QueryMobileOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMobilePaymentReceiptArgs = {
  paymentId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMobileSavedCardsArgs = {
  customerRef: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryMyMerchantPoliciesArgs = {
  where?: InputMaybe<__SHOULD_NOT_USE__PolicyDocumentWhereInput>;
};


export type __SHOULD_NOT_USE__QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryOrganizationApiKeysArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__ApiKeyOrderByInput>;
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryOrganizationApiPaymentsArgs = {
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  status?: InputMaybe<ApiPaymentsStatus>;
};


export type __SHOULD_NOT_USE__QueryOrganizationAuditLogArgs = {
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  eventActions?: InputMaybe<Array<EventAction>>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<__SHOULD_NOT_USE__EventOrderByInput>;
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryOrganizationPaymentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryOrganizationPaymentTypesArgs = {
  organizationId: Scalars['ID']['input'];
  paymentContext?: InputMaybe<OrganizationPaymentTypeContext>;
};


export type __SHOULD_NOT_USE__QueryOrganizationRolesArgs = {
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__RoleWhereInput>;
};


export type __SHOULD_NOT_USE__QueryOrganizationUsersArgs = {
  organizationId: Scalars['ID']['input'];
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<__SHOULD_NOT_USE__UserSortInput>;
  status?: InputMaybe<UserStatus>;
  where?: InputMaybe<__SHOULD_NOT_USE__UserWhereInput>;
};


export type __SHOULD_NOT_USE__QueryOrganizationsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  sort?: InputMaybe<__SHOULD_NOT_USE__OrganizationSortInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__OrganizationWhereInput>;
};


export type __SHOULD_NOT_USE__QueryOverdueInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type __SHOULD_NOT_USE__QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentAnalyticsArgs = {
  endDate: Scalars['Time']['input'];
  environment: PaymentEnvironment;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  period: AnalyticsPeriod;
  startDate: Scalars['Time']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentFailureAnalysisArgs = {
  endDate: Scalars['Time']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Time']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentPayoutsArgs = {
  paymentId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentProviderArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentProviderByCardTypeArgs = {
  cardType: CardType;
  currency?: InputMaybe<Scalars['String']['input']>;
  paymentType: PaymentType;
};


export type __SHOULD_NOT_USE__QueryPaymentProviderCardTypeArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentProviderCardTypesArgs = {
  filter?: InputMaybe<__SHOULD_NOT_USE__CardTypeFilter>;
  paymentProviderId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentProviderPaymentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentProviderPaymentTypesArgs = {
  filter?: InputMaybe<__SHOULD_NOT_USE__PaymentTypeFilter>;
  paymentProviderId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPaymentProvidersArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  sort?: InputMaybe<__SHOULD_NOT_USE__PaymentProviderSortInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PaymentProviderWhereInput>;
};


export type __SHOULD_NOT_USE__QueryPaymentProvidersByTypeArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  paymentType: PaymentType;
  supportsRecurring?: InputMaybe<Scalars['Boolean']['input']>;
};


export type __SHOULD_NOT_USE__QueryPaymentSummaryArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  environment?: InputMaybe<PaymentEnvironment>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<PaymentStatus>;
};


export type __SHOULD_NOT_USE__QueryPaymentsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__PaymentOrderBy>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PaymentWhereInput>;
};


export type __SHOULD_NOT_USE__QueryPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPayoutOrganizationsArgs = {
  pagination: __SHOULD_NOT_USE__PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type __SHOULD_NOT_USE__QueryPayoutOverviewArgs = {
  bankId?: InputMaybe<Scalars['ID']['input']>;
};


export type __SHOULD_NOT_USE__QueryPayoutProcessingMetricsArgs = {
  bankId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom: Scalars['Time']['input'];
  dateTo: Scalars['Time']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
};


export type __SHOULD_NOT_USE__QueryPayoutSummaryArgs = {
  currency?: InputMaybe<Currency>;
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PayoutStatus>;
};


export type __SHOULD_NOT_USE__QueryPayoutsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__PayoutOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PayoutWhereInput>;
};


export type __SHOULD_NOT_USE__QueryPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPermissionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPermissionGroupBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryPermissionGroupsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  sort?: InputMaybe<__SHOULD_NOT_USE__PermissionGroupSortInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PermissionGroupWhereInput>;
};


export type __SHOULD_NOT_USE__QueryPermissionsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  sort?: InputMaybe<__SHOULD_NOT_USE__PermissionSortInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PermissionWhereInput>;
};


export type __SHOULD_NOT_USE__QueryPlatformPendingRefundsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryPolicyDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPolicyDocumentVersionHistoryArgs = {
  policyId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPolicyDocumentsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PolicyDocumentWhereInput>;
};


export type __SHOULD_NOT_USE__QueryPolicyTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryPolicyTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  policyType?: InputMaybe<PolicyType>;
};


export type __SHOULD_NOT_USE__QueryProviderPerformanceArgs = {
  endDate: Scalars['Time']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Time']['input'];
};


export type __SHOULD_NOT_USE__QueryQuickPayArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryQuickPayByAccessKeyArgs = {
  accessKey: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryQuickPayByCodeArgs = {
  code: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryQuickPayFeeEstimateArgs = {
  accessKey: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  cardType?: InputMaybe<CardType>;
  channel?: InputMaybe<PaymentChannel>;
  currency: Currency;
  paymentType: PaymentType;
};


export type __SHOULD_NOT_USE__QueryQuickPaysArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__QuickPayOrderByInput>;
  pagination: __SHOULD_NOT_USE__PaginationInput;
  where?: InputMaybe<__SHOULD_NOT_USE__QuickPayWhereInput>;
};


export type __SHOULD_NOT_USE__QueryRecentActivityArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type __SHOULD_NOT_USE__QueryRecurringPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryRecurringPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<__SHOULD_NOT_USE__RecurringPaymentOrderBy>;
  where?: InputMaybe<__SHOULD_NOT_USE__RecurringPaymentWhereInput>;
};


export type __SHOULD_NOT_USE__QueryRefundArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryRefundAnalyticsArgs = {
  dateRange: __SHOULD_NOT_USE__DateRangeInput;
  environment?: InputMaybe<PaymentEnvironment>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type __SHOULD_NOT_USE__QueryRefundSummaryArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};


export type __SHOULD_NOT_USE__QueryRefundsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__RefundOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__RefundWhereInput>;
};


export type __SHOULD_NOT_USE__QueryRevenueDashboardArgs = {
  endDate: Scalars['Time']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Time']['input'];
};


export type __SHOULD_NOT_USE__QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryRolePermissionsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  roleId: Scalars['ID']['input'];
  where?: InputMaybe<__SHOULD_NOT_USE__PermissionWhereInput>;
};


export type __SHOULD_NOT_USE__QueryRolesArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  sort?: InputMaybe<__SHOULD_NOT_USE__RoleSortInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__RoleWhereInput>;
};


export type __SHOULD_NOT_USE__QuerySearchPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  environment?: InputMaybe<PaymentEnvironment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryServiceAccountWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryServiceAccountWebhooksArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__ServiceAccountWebhookOrderByInput>;
  pagination: __SHOULD_NOT_USE__PaginationInput;
  where?: InputMaybe<__SHOULD_NOT_USE__ServiceAccountWebhookWhereInput>;
};


export type __SHOULD_NOT_USE__QuerySplitPaymentsArgs = {
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};


export type __SHOULD_NOT_USE__QueryTransferArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryTransferByCodeArgs = {
  code: Scalars['String']['input'];
};


export type __SHOULD_NOT_USE__QueryTransferSummaryArgs = {
  bankId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Currency>;
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<TransferStatus>;
};


export type __SHOULD_NOT_USE__QueryTransfersArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__TransferOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__TransferWhereInput>;
};


export type __SHOULD_NOT_USE__QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryUserActivityArgs = {
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  orderBy?: InputMaybe<__SHOULD_NOT_USE__EventOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  userId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryUserPermissionsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  userId: Scalars['ID']['input'];
  where?: InputMaybe<__SHOULD_NOT_USE__PermissionWhereInput>;
};


export type __SHOULD_NOT_USE__QueryUserPolicyAcceptancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  policyId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type __SHOULD_NOT_USE__QueryUserRolesArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  userId: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryUsersArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  sort?: InputMaybe<__SHOULD_NOT_USE__UserSortInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__UserWhereInput>;
};


export type __SHOULD_NOT_USE__QueryWebhookDeliveriesArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__WebhookDeliveryOrderByInput>;
  pagination: __SHOULD_NOT_USE__PaginationInput;
  where?: InputMaybe<__SHOULD_NOT_USE__WebhookDeliveryWhereInput>;
};


export type __SHOULD_NOT_USE__QueryWebhookDeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryWebhookEventTypeArgs = {
  id: Scalars['ID']['input'];
};


export type __SHOULD_NOT_USE__QueryWebhookEventTypesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__QuickPay = {
  accessKey: Scalars['String']['output'];
  amountType: QuickPayAmountType;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Currency;
  customFields: Scalars['Map']['output'];
  description: Maybe<Scalars['Map']['output']>;
  environment: PaymentEnvironment;
  expiresAt: Maybe<Scalars['Time']['output']>;
  fixedAmount: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** Optional sale basket for dynamic QRs ([{description, unitPrice, quantity}]) */
  lineItems: Maybe<Array<Scalars['Map']['output']>>;
  maxAmount: Maybe<Scalars['Float']['output']>;
  merchantProcessingFee: Scalars['Float']['output'];
  minAmount: Maybe<Scalars['Float']['output']>;
  owner: __SHOULD_NOT_USE__Organization;
  ownerId: Scalars['ID']['output'];
  paymentCount: Scalars['Int']['output'];
  paymentOptions: Array<PaymentType>;
  paymentURL: Scalars['String']['output'];
  payments: __SHOULD_NOT_USE__PaymentConnection;
  presetAmounts: Maybe<Array<Scalars['Float']['output']>>;
  qrCode: __SHOULD_NOT_USE__QrCodePayload;
  refundPolicyTerms: QuickPayRefundPolicyTerms;
  status: QuickPayStatus;
  title: Scalars['String']['output'];
  totalPaymentAmount: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type __SHOULD_NOT_USE__QuickPayPaymentsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__PaymentOrderBy>;
  pagination: __SHOULD_NOT_USE__PaginationInput;
  where?: InputMaybe<__SHOULD_NOT_USE__PaymentWhereInput>;
};


export type __SHOULD_NOT_USE__QuickPayQrCodeArgs = {
  format?: InputMaybe<QrCodeFormat>;
  size?: InputMaybe<QrCodeSize>;
};

export const QuickPayAmountType = {
  Fixed: 'FIXED',
  Flexible: 'FLEXIBLE',
  PresetOptions: 'PRESET_OPTIONS'
} as const;

export type QuickPayAmountType = typeof QuickPayAmountType[keyof typeof QuickPayAmountType];
export type __SHOULD_NOT_USE__QuickPayConnection = {
  edges: Array<__SHOULD_NOT_USE__QuickPayEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__QuickPayEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__QuickPay;
};

export type __SHOULD_NOT_USE__QuickPayFeeEstimate = {
  gatewayFeeAmount: Scalars['Float']['output'];
  gatewayFeeRate: Scalars['Float']['output'];
  gatewayFeeType: Scalars['String']['output'];
  merchantFeeAmount: Scalars['Float']['output'];
  merchantFeePercent: Scalars['Float']['output'];
  platformFeeAmount: Scalars['Float']['output'];
  platformFeePercent: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type __SHOULD_NOT_USE__QuickPayOrderByField = {
  direction: SortOrder;
  field: QuickPaySortField;
};

export type __SHOULD_NOT_USE__QuickPayOrderByInput = {
  orderBy: Array<__SHOULD_NOT_USE__QuickPayOrderByField>;
};

export type __SHOULD_NOT_USE__QuickPayPublic = {
  /** Pay-by-code callers use this to proceed to payment (the QR embeds it; the code substitutes for scanning) */
  accessKey: Scalars['ID']['output'];
  amountType: QuickPayAmountType;
  /** Human-readable pay-by-code identifier (printed next to the QR) */
  code: Scalars['String']['output'];
  currency: Currency;
  description: Maybe<Scalars['Map']['output']>;
  fixedAmount: Maybe<Scalars['Float']['output']>;
  isExpired: Scalars['Boolean']['output'];
  /** Itemized basket shown on the pay screen, when the QR carries one */
  lineItems: Maybe<Array<Scalars['Map']['output']>>;
  maxAmount: Maybe<Scalars['Float']['output']>;
  merchantLogo: Maybe<Scalars['String']['output']>;
  merchantName: Scalars['String']['output'];
  minAmount: Maybe<Scalars['Float']['output']>;
  paymentOptions: Array<PaymentType>;
  presetAmounts: Maybe<Array<Scalars['Float']['output']>>;
  refundPolicyTerms: QuickPayRefundPolicyTerms;
  status: QuickPayStatus;
  title: Scalars['String']['output'];
};

export const QuickPayRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type QuickPayRefundPolicyTerms = typeof QuickPayRefundPolicyTerms[keyof typeof QuickPayRefundPolicyTerms];
export const QuickPaySortField = {
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  Title: 'TITLE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type QuickPaySortField = typeof QuickPaySortField[keyof typeof QuickPaySortField];
export const QuickPayStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Paused: 'PAUSED'
} as const;

export type QuickPayStatus = typeof QuickPayStatus[keyof typeof QuickPayStatus];
/**
 * QuickPayWhereInput is used for filtering QuickPay objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__QuickPayWhereInput = {
  /** access_key field predicates */
  accessKey?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyGTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  accessKeyLT?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyLTE?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNEQ?: InputMaybe<Scalars['UUID']['input']>;
  accessKeyNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** amount_type field predicates */
  amountType?: InputMaybe<QuickPayAmountType>;
  amountTypeContains?: InputMaybe<QuickPayAmountType>;
  amountTypeContainsFold?: InputMaybe<QuickPayAmountType>;
  amountTypeEqualFold?: InputMaybe<QuickPayAmountType>;
  amountTypeGT?: InputMaybe<QuickPayAmountType>;
  amountTypeGTE?: InputMaybe<QuickPayAmountType>;
  amountTypeHasPrefix?: InputMaybe<QuickPayAmountType>;
  amountTypeHasSuffix?: InputMaybe<QuickPayAmountType>;
  amountTypeIn?: InputMaybe<Array<QuickPayAmountType>>;
  amountTypeLT?: InputMaybe<QuickPayAmountType>;
  amountTypeLTE?: InputMaybe<QuickPayAmountType>;
  amountTypeNEQ?: InputMaybe<QuickPayAmountType>;
  amountTypeNotIn?: InputMaybe<Array<QuickPayAmountType>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__QuickPayWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** fixed_amount field predicates */
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountGT?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  fixedAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fixedAmountLT?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  fixedAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** max_amount field predicates */
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  maxAmountGT?: InputMaybe<Scalars['Float']['input']>;
  maxAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  maxAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  maxAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmountLT?: InputMaybe<Scalars['Float']['input']>;
  maxAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  maxAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  maxAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  maxAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** min_amount field predicates */
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmountGT?: InputMaybe<Scalars['Float']['input']>;
  minAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  minAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  minAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  minAmountLT?: InputMaybe<Scalars['Float']['input']>;
  minAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  minAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  minAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  minAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__QuickPayWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__QuickPayWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<QuickPayRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<QuickPayRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<QuickPayRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<QuickPayRefundPolicyTerms>>;
  /** status field predicates */
  status?: InputMaybe<QuickPayStatus>;
  statusContains?: InputMaybe<QuickPayStatus>;
  statusContainsFold?: InputMaybe<QuickPayStatus>;
  statusEqualFold?: InputMaybe<QuickPayStatus>;
  statusGT?: InputMaybe<QuickPayStatus>;
  statusGTE?: InputMaybe<QuickPayStatus>;
  statusHasPrefix?: InputMaybe<QuickPayStatus>;
  statusHasSuffix?: InputMaybe<QuickPayStatus>;
  statusIn?: InputMaybe<Array<QuickPayStatus>>;
  statusLT?: InputMaybe<QuickPayStatus>;
  statusLTE?: InputMaybe<QuickPayStatus>;
  statusNEQ?: InputMaybe<QuickPayStatus>;
  statusNotIn?: InputMaybe<Array<QuickPayStatus>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__RecordDisputeWithdrawalInput = {
  id: Scalars['ID']['input'];
  withdrawalDate: Scalars['Time']['input'];
};

export type __SHOULD_NOT_USE__RecordDisputeWithdrawalPayload = {
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export const RecurringInterval = {
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  Weekly: 'WEEKLY',
  Yearly: 'YEARLY'
} as const;

export type RecurringInterval = typeof RecurringInterval[keyof typeof RecurringInterval];
export type __SHOULD_NOT_USE__RecurringPayment = {
  activePaymentMethod: Maybe<__SHOULD_NOT_USE__PaymentMethod>;
  amount: Scalars['Float']['output'];
  cancelURL: Maybe<Scalars['String']['output']>;
  chargeImmediately: Scalars['Boolean']['output'];
  chargesCount: Scalars['Int']['output'];
  checkoutExpiresAt: Maybe<Scalars['Time']['output']>;
  checkoutSessionID: Scalars['String']['output'];
  code: Scalars['String']['output'];
  consecutiveFailures: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Currency;
  customer: __SHOULD_NOT_USE__Customer;
  description: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['Time']['output']>;
  externalID: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interval: RecurringInterval;
  intervalCount: Scalars['Int']['output'];
  lastChargeDate: Maybe<Scalars['Time']['output']>;
  lastChargeStatus: Maybe<PaymentStatus>;
  maxCharges: Maybe<Scalars['Int']['output']>;
  maxRetries: Scalars['Int']['output'];
  merchantProcessingFee: Scalars['Float']['output'];
  metadata: Scalars['Map']['output'];
  nextChargeDate: Maybe<Scalars['Time']['output']>;
  owner: __SHOULD_NOT_USE__Organization;
  paymentOptions: Array<PaymentType>;
  refundPolicyTerms: RecurringPaymentRefundPolicyTerms;
  setupStatus: RecurringPaymentSetupStatus;
  startDate: Scalars['Time']['output'];
  status: RecurringPaymentStatus;
  successURL: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type __SHOULD_NOT_USE__RecurringPaymentConnection = {
  edges: Array<__SHOULD_NOT_USE__RecurringPaymentEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__RecurringPaymentEdge = {
  cursor: Scalars['Cursor']['output'];
  node: __SHOULD_NOT_USE__RecurringPayment;
};

export type __SHOULD_NOT_USE__RecurringPaymentOrderBy = {
  direction: SortOrder;
  field: RecurringPaymentOrderField;
};

export const RecurringPaymentOrderField = {
  Amount: 'AMOUNT',
  CreatedAt: 'CREATED_AT',
  Interval: 'INTERVAL',
  NextChargeDate: 'NEXT_CHARGE_DATE',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type RecurringPaymentOrderField = typeof RecurringPaymentOrderField[keyof typeof RecurringPaymentOrderField];
export const RecurringPaymentRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type RecurringPaymentRefundPolicyTerms = typeof RecurringPaymentRefundPolicyTerms[keyof typeof RecurringPaymentRefundPolicyTerms];
export const RecurringPaymentSetupStatus = {
  Completed: 'COMPLETED',
  Expired: 'EXPIRED',
  Pending: 'PENDING'
} as const;

export type RecurringPaymentSetupStatus = typeof RecurringPaymentSetupStatus[keyof typeof RecurringPaymentSetupStatus];
export const RecurringPaymentStatus = {
  Active: 'ACTIVE',
  Canceled: 'CANCELED',
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Paused: 'PAUSED'
} as const;

export type RecurringPaymentStatus = typeof RecurringPaymentStatus[keyof typeof RecurringPaymentStatus];
/**
 * RecurringPaymentWhereInput is used for filtering RecurringPayment objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__RecurringPaymentWhereInput = {
  /** active_payment_method_id field predicates */
  activePaymentMethodID?: InputMaybe<Scalars['ID']['input']>;
  activePaymentMethodIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  activePaymentMethodIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activePaymentMethodIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  activePaymentMethodIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  activePaymentMethodIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountGT?: InputMaybe<Scalars['Int']['input']>;
  amountGTE?: InputMaybe<Scalars['Int']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  amountLT?: InputMaybe<Scalars['Int']['input']>;
  amountLTE?: InputMaybe<Scalars['Int']['input']>;
  amountNEQ?: InputMaybe<Scalars['Int']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__RecurringPaymentWhereInput>>;
  /** api_key field predicates */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKeyContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cancel_url field predicates */
  cancelURL?: InputMaybe<Scalars['String']['input']>;
  cancelURLContains?: InputMaybe<Scalars['String']['input']>;
  cancelURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  cancelURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  cancelURLGT?: InputMaybe<Scalars['String']['input']>;
  cancelURLGTE?: InputMaybe<Scalars['String']['input']>;
  cancelURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cancelURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cancelURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancelURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cancelURLLT?: InputMaybe<Scalars['String']['input']>;
  cancelURLLTE?: InputMaybe<Scalars['String']['input']>;
  cancelURLNEQ?: InputMaybe<Scalars['String']['input']>;
  cancelURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cancelURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** charge_immediately field predicates */
  chargeImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  chargeImmediatelyNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** charges_count field predicates */
  chargesCount?: InputMaybe<Scalars['Int']['input']>;
  chargesCountGT?: InputMaybe<Scalars['Int']['input']>;
  chargesCountGTE?: InputMaybe<Scalars['Int']['input']>;
  chargesCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  chargesCountLT?: InputMaybe<Scalars['Int']['input']>;
  chargesCountLTE?: InputMaybe<Scalars['Int']['input']>;
  chargesCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  chargesCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** checkout_expires_at field predicates */
  checkoutExpiresAt?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutExpiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutExpiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkoutExpiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutExpiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkout_session_id field predicates */
  checkoutSessionID?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDContains?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDGT?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDGTE?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkoutSessionIDLT?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDLTE?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDNEQ?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** consecutive_failures field predicates */
  consecutiveFailures?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresGT?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresGTE?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  consecutiveFailuresLT?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresLTE?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresNEQ?: InputMaybe<Scalars['Int']['input']>;
  consecutiveFailuresNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyContains?: InputMaybe<Scalars['String']['input']>;
  currencyContainsFold?: InputMaybe<Scalars['String']['input']>;
  currencyEqualFold?: InputMaybe<Scalars['String']['input']>;
  currencyGT?: InputMaybe<Scalars['String']['input']>;
  currencyGTE?: InputMaybe<Scalars['String']['input']>;
  currencyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currencyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currencyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyLT?: InputMaybe<Scalars['String']['input']>;
  currencyLTE?: InputMaybe<Scalars['String']['input']>;
  currencyNEQ?: InputMaybe<Scalars['String']['input']>;
  currencyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** customer_id field predicates */
  customerID?: InputMaybe<Scalars['ID']['input']>;
  customerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  customerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ends_at field predicates */
  endsAt?: InputMaybe<Scalars['Time']['input']>;
  endsAtGT?: InputMaybe<Scalars['Time']['input']>;
  endsAtGTE?: InputMaybe<Scalars['Time']['input']>;
  endsAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endsAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endsAtLT?: InputMaybe<Scalars['Time']['input']>;
  endsAtLTE?: InputMaybe<Scalars['Time']['input']>;
  endsAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  endsAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endsAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** active_payment_method edge predicates */
  hasActivePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  hasActivePaymentMethodWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentMethodWhereInput>>;
  /** customer edge predicates */
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomerWith?: InputMaybe<Array<__SHOULD_NOT_USE__CustomerWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** interval field predicates */
  interval?: InputMaybe<RecurringInterval>;
  /** interval_count field predicates */
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  intervalCountGT?: InputMaybe<Scalars['Int']['input']>;
  intervalCountGTE?: InputMaybe<Scalars['Int']['input']>;
  intervalCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  intervalCountLT?: InputMaybe<Scalars['Int']['input']>;
  intervalCountLTE?: InputMaybe<Scalars['Int']['input']>;
  intervalCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  intervalCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  intervalIn?: InputMaybe<Array<RecurringInterval>>;
  intervalNEQ?: InputMaybe<RecurringInterval>;
  intervalNotIn?: InputMaybe<Array<RecurringInterval>>;
  /** last_charge_attempt_at field predicates */
  lastChargeAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastChargeAttemptAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastChargeAttemptAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastChargeAttemptAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastChargeAttemptAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** max_charges field predicates */
  maxCharges?: InputMaybe<Scalars['Int']['input']>;
  maxChargesGT?: InputMaybe<Scalars['Int']['input']>;
  maxChargesGTE?: InputMaybe<Scalars['Int']['input']>;
  maxChargesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxChargesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maxChargesLT?: InputMaybe<Scalars['Int']['input']>;
  maxChargesLTE?: InputMaybe<Scalars['Int']['input']>;
  maxChargesNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxChargesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxChargesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** max_retries field predicates */
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesGT?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesGTE?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxRetriesLT?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesLTE?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxRetriesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** merchant_processing_fee field predicates */
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeGTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  merchantProcessingFeeLT?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeLTE?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNEQ?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFeeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** next_charge_date field predicates */
  nextChargeDate?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateGT?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateGTE?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextChargeDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextChargeDateLT?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateLTE?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextChargeDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextChargeDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__RecurringPaymentWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__RecurringPaymentWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** refund_policy_terms field predicates */
  refundPolicyTerms?: InputMaybe<RecurringPaymentRefundPolicyTerms>;
  refundPolicyTermsIn?: InputMaybe<Array<RecurringPaymentRefundPolicyTerms>>;
  refundPolicyTermsNEQ?: InputMaybe<RecurringPaymentRefundPolicyTerms>;
  refundPolicyTermsNotIn?: InputMaybe<Array<RecurringPaymentRefundPolicyTerms>>;
  /** setup_status field predicates */
  setupStatus?: InputMaybe<RecurringPaymentSetupStatus>;
  setupStatusIn?: InputMaybe<Array<RecurringPaymentSetupStatus>>;
  setupStatusNEQ?: InputMaybe<RecurringPaymentSetupStatus>;
  setupStatusNotIn?: InputMaybe<Array<RecurringPaymentSetupStatus>>;
  /** starts_at field predicates */
  startsAt?: InputMaybe<Scalars['Time']['input']>;
  startsAtGT?: InputMaybe<Scalars['Time']['input']>;
  startsAtGTE?: InputMaybe<Scalars['Time']['input']>;
  startsAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startsAtLT?: InputMaybe<Scalars['Time']['input']>;
  startsAtLTE?: InputMaybe<Scalars['Time']['input']>;
  startsAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  startsAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** status field predicates */
  status?: InputMaybe<RecurringPaymentStatus>;
  statusIn?: InputMaybe<Array<RecurringPaymentStatus>>;
  statusNEQ?: InputMaybe<RecurringPaymentStatus>;
  statusNotIn?: InputMaybe<Array<RecurringPaymentStatus>>;
  /** success_url field predicates */
  successURL?: InputMaybe<Scalars['String']['input']>;
  successURLContains?: InputMaybe<Scalars['String']['input']>;
  successURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  successURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  successURLGT?: InputMaybe<Scalars['String']['input']>;
  successURLGTE?: InputMaybe<Scalars['String']['input']>;
  successURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  successURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  successURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  successURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  successURLLT?: InputMaybe<Scalars['String']['input']>;
  successURLLTE?: InputMaybe<Scalars['String']['input']>;
  successURLNEQ?: InputMaybe<Scalars['String']['input']>;
  successURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  successURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__RefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__RefreshTokenPayload = {
  accessToken: Scalars['String']['output'];
  errors: Maybe<Array<Maybe<__SHOULD_NOT_USE__AuthenticationError>>>;
  refreshToken: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__Refund = {
  amount: Scalars['Float']['output'];
  bankDeclineReason: Maybe<Scalars['Map']['output']>;
  closedDate: Maybe<Scalars['Time']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Maybe<__SHOULD_NOT_USE__User>;
  createdById: Scalars['ID']['output'];
  denialReason: Maybe<Scalars['Map']['output']>;
  environment: PaymentEnvironment;
  extendedCancellationPolicyText: Maybe<Scalars['String']['output']>;
  hasCancelPolicyExtended: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  merchantDeclineReason: Maybe<RefundMerchantDeclineReason>;
  notes: Maybe<Scalars['Map']['output']>;
  ownerId: Maybe<Scalars['ID']['output']>;
  payment: __SHOULD_NOT_USE__Payment;
  paymentId: Scalars['String']['output'];
  pointOfContact: RefundPointOfContact;
  progressStatus: RefundProgressStatus;
  providerRefundId: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['Map']['output']>;
  receipts: Maybe<Array<Maybe<__SHOULD_NOT_USE__Media>>>;
  refundAlreadyPaid: RefundAlreadyPaid;
  refundAlreadyPaidAmount: Maybe<Scalars['Float']['output']>;
  status: RefundStatus;
  statusUpdatedAt: Maybe<Scalars['Time']['output']>;
  subReason: Maybe<Scalars['Map']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export const RefundAlreadyPaid = {
  PaidInCash: 'PAID_IN_CASH',
  PaidViaPaymentGateway: 'PAID_VIA_PAYMENT_GATEWAY',
  PaidViaWireTransfer: 'PAID_VIA_WIRE_TRANSFER'
} as const;

export type RefundAlreadyPaid = typeof RefundAlreadyPaid[keyof typeof RefundAlreadyPaid];
export type __SHOULD_NOT_USE__RefundAnalytics = {
  averageRefundAmount: Scalars['Float']['output'];
  averageResolutionHours: Scalars['Float']['output'];
  declinedRefunds: Scalars['Int']['output'];
  medianResolutionHours: Scalars['Float']['output'];
  pendingRefunds: Scalars['Int']['output'];
  period: __SHOULD_NOT_USE__DateRange;
  successRate: Scalars['Float']['output'];
  successfulRefunds: Scalars['Int']['output'];
  totalDeclinedAmount: Scalars['Float']['output'];
  totalRefundedAmount: Scalars['Float']['output'];
  totalRequests: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__RefundConnection = {
  edges: Array<__SHOULD_NOT_USE__RefundEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__RefundEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Refund;
};

export const RefundMerchantDeclineReason = {
  OutsideCancellationPolicy: 'OUTSIDE_CANCELLATION_POLICY',
  RefundAlreadyPaid: 'REFUND_ALREADY_PAID',
  ServiceWasProvided: 'SERVICE_WAS_PROVIDED'
} as const;

export type RefundMerchantDeclineReason = typeof RefundMerchantDeclineReason[keyof typeof RefundMerchantDeclineReason];
export type __SHOULD_NOT_USE__RefundOrderByInput = {
  direction: SortOrder;
  field: RefundOrderField;
};

export const RefundOrderField = {
  Amount: 'AMOUNT',
  ClosedDate: 'CLOSED_DATE',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  ProgressStatus: 'PROGRESS_STATUS',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type RefundOrderField = typeof RefundOrderField[keyof typeof RefundOrderField];
export const RefundPointOfContact = {
  Merchant: 'MERCHANT',
  Platform: 'PLATFORM'
} as const;

export type RefundPointOfContact = typeof RefundPointOfContact[keyof typeof RefundPointOfContact];
export const RefundProgressStatus = {
  BankApproved: 'BANK_APPROVED',
  BankDenied: 'BANK_DENIED',
  Initiated: 'INITIATED',
  MerchantApproved: 'MERCHANT_APPROVED',
  MerchantDenied: 'MERCHANT_DENIED',
  NotRefunded: 'NOT_REFUNDED',
  Refunded: 'REFUNDED'
} as const;

export type RefundProgressStatus = typeof RefundProgressStatus[keyof typeof RefundProgressStatus];
export const RefundReportField = {
  Amount: 'AMOUNT',
  BankDeclineReason: 'BANK_DECLINE_REASON',
  ClosedDate: 'CLOSED_DATE',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  CreatedById: 'CREATED_BY_ID',
  DenialReason: 'DENIAL_REASON',
  Environment: 'ENVIRONMENT',
  ExtendedCancellationPolicyText: 'EXTENDED_CANCELLATION_POLICY_TEXT',
  HasCancelPolicyExtended: 'HAS_CANCEL_POLICY_EXTENDED',
  MerchantDeclineExplanation: 'MERCHANT_DECLINE_EXPLANATION',
  MerchantDeclineReason: 'MERCHANT_DECLINE_REASON',
  MerchantDeclineSubReason: 'MERCHANT_DECLINE_SUB_REASON',
  Notes: 'NOTES',
  PaymentId: 'PAYMENT_ID',
  PointOfContact: 'POINT_OF_CONTACT',
  ProgressStatus: 'PROGRESS_STATUS',
  ProviderRefundId: 'PROVIDER_REFUND_ID',
  Reason: 'REASON',
  RefundAlreadyPaid: 'REFUND_ALREADY_PAID',
  RefundAlreadyPaidAmount: 'REFUND_ALREADY_PAID_AMOUNT',
  Status: 'STATUS',
  StatusUpdatedAt: 'STATUS_UPDATED_AT',
  SubReason: 'SUB_REASON'
} as const;

export type RefundReportField = typeof RefundReportField[keyof typeof RefundReportField];
export const RefundStatus = {
  Closed: 'CLOSED',
  InReview: 'IN_REVIEW',
  Open: 'OPEN',
  Resolved: 'RESOLVED'
} as const;

export type RefundStatus = typeof RefundStatus[keyof typeof RefundStatus];
export type __SHOULD_NOT_USE__RefundSummary = {
  approvedCount: Scalars['Int']['output'];
  deniedCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  refundedCount: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
  totalPendingAmount: Scalars['Float']['output'];
  totalRefundedAmount: Scalars['Float']['output'];
  totalRefunds: Scalars['Int']['output'];
};

/**
 * RefundWhereInput is used for filtering Refund objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__RefundWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__RefundWhereInput>>;
  /** closed_date field predicates */
  closedDate?: InputMaybe<Scalars['Time']['input']>;
  closedDateGT?: InputMaybe<Scalars['Time']['input']>;
  closedDateGTE?: InputMaybe<Scalars['Time']['input']>;
  closedDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  closedDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  closedDateLT?: InputMaybe<Scalars['Time']['input']>;
  closedDateLTE?: InputMaybe<Scalars['Time']['input']>;
  closedDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  closedDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  closedDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_id field predicates */
  createdByID?: InputMaybe<Scalars['ID']['input']>;
  createdByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** environment field predicates */
  environment?: InputMaybe<PaymentEnvironment>;
  environmentIn?: InputMaybe<Array<PaymentEnvironment>>;
  environmentNEQ?: InputMaybe<PaymentEnvironment>;
  environmentNotIn?: InputMaybe<Array<PaymentEnvironment>>;
  /** extended_cancellation_policy_text field predicates */
  extendedCancellationPolicyText?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextContains?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextContainsFold?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextEqualFold?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextGT?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextGTE?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextHasPrefix?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextHasSuffix?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextIn?: InputMaybe<Array<Scalars['String']['input']>>;
  extendedCancellationPolicyTextIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  extendedCancellationPolicyTextLT?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextLTE?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextNEQ?: InputMaybe<Scalars['String']['input']>;
  extendedCancellationPolicyTextNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  extendedCancellationPolicyTextNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** has_cancel_policy_extended field predicates */
  hasCancelPolicyExtended?: InputMaybe<Scalars['Boolean']['input']>;
  hasCancelPolicyExtendedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  hasCancelPolicyExtendedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  hasCancelPolicyExtendedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** disputes edge predicates */
  hasDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDisputesWith?: InputMaybe<Array<__SHOULD_NOT_USE__DisputeWhereInput>>;
  /** payment edge predicates */
  hasPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentWith?: InputMaybe<Array<__SHOULD_NOT_USE__PaymentWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** merchant_decline_explanation field predicates */
  merchantDeclineExplanation?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationContains?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationContainsFold?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationEqualFold?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationGT?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationGTE?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantDeclineExplanationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  merchantDeclineExplanationLT?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationLTE?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationNEQ?: InputMaybe<Scalars['String']['input']>;
  merchantDeclineExplanationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantDeclineExplanationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** merchant_decline_reason field predicates */
  merchantDeclineReason?: InputMaybe<RefundMerchantDeclineReason>;
  merchantDeclineReasonIn?: InputMaybe<Array<RefundMerchantDeclineReason>>;
  merchantDeclineReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  merchantDeclineReasonNEQ?: InputMaybe<RefundMerchantDeclineReason>;
  merchantDeclineReasonNotIn?: InputMaybe<Array<RefundMerchantDeclineReason>>;
  merchantDeclineReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__RefundWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__RefundWhereInput>>;
  /** payment_id field predicates */
  paymentID?: InputMaybe<Scalars['ID']['input']>;
  paymentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  paymentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** point_of_contact field predicates */
  pointOfContact?: InputMaybe<RefundPointOfContact>;
  pointOfContactIn?: InputMaybe<Array<RefundPointOfContact>>;
  pointOfContactNEQ?: InputMaybe<RefundPointOfContact>;
  pointOfContactNotIn?: InputMaybe<Array<RefundPointOfContact>>;
  /** progress_status field predicates */
  progressStatus?: InputMaybe<RefundProgressStatus>;
  progressStatusIn?: InputMaybe<Array<RefundProgressStatus>>;
  progressStatusNEQ?: InputMaybe<RefundProgressStatus>;
  progressStatusNotIn?: InputMaybe<Array<RefundProgressStatus>>;
  /** provider_refund_id field predicates */
  providerRefundID?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDContains?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDGT?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDGTE?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerRefundIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  providerRefundIDLT?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDLTE?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDNEQ?: InputMaybe<Scalars['String']['input']>;
  providerRefundIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  providerRefundIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** refund_already_paid field predicates */
  refundAlreadyPaid?: InputMaybe<RefundAlreadyPaid>;
  /** refund_already_paid_amount field predicates */
  refundAlreadyPaidAmount?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountGT?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundAlreadyPaidAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundAlreadyPaidAmountLT?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  refundAlreadyPaidAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundAlreadyPaidAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  refundAlreadyPaidIn?: InputMaybe<Array<RefundAlreadyPaid>>;
  refundAlreadyPaidNEQ?: InputMaybe<RefundAlreadyPaid>;
  refundAlreadyPaidNotIn?: InputMaybe<Array<RefundAlreadyPaid>>;
  /** status field predicates */
  status?: InputMaybe<RefundStatus>;
  statusIn?: InputMaybe<Array<RefundStatus>>;
  statusNEQ?: InputMaybe<RefundStatus>;
  statusNotIn?: InputMaybe<Array<RefundStatus>>;
  /** status_updated_at field predicates */
  statusUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__ReinstateBankAccountPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  statusChange: Maybe<__SHOULD_NOT_USE__BankAccountStatusChangeRecord>;
};

export type __SHOULD_NOT_USE__RejectBankAccountPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  statusChange: Maybe<__SHOULD_NOT_USE__BankAccountStatusChangeRecord>;
};

export type __SHOULD_NOT_USE__RejectRefundInput = {
  declineReason: Scalars['Map']['input'];
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type __SHOULD_NOT_USE__RejectRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export type __SHOULD_NOT_USE__RemoveDefaultPolicyPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  policyType: Maybe<PolicyType>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type __SHOULD_NOT_USE__RemovePayoutsFromTransferInput = {
  payoutIds: Array<Scalars['ID']['input']>;
  transferId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__RemovePayoutsFromTransferPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  removedPayoutIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  transfer: Maybe<__SHOULD_NOT_USE__Transfer>;
};

export type __SHOULD_NOT_USE__RemoveServiceAccountWebhookSubscriptionsInput = {
  eventTypeIds: Array<Scalars['ID']['input']>;
  webhookId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__RemoveServiceAccountWebhookSubscriptionsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__RemoveWebhookSubscriptionsInput = {
  eventTypeIds: Array<Scalars['ID']['input']>;
  webhookId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__RemoveWebhookSubscriptionsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__ReorderLineItemsInput = {
  invoiceId: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']>;
};

export type __SHOULD_NOT_USE__ReorderLineItemsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  lineItems: Maybe<Array<__SHOULD_NOT_USE__InvoiceLineItem>>;
};

export type __SHOULD_NOT_USE__RequestEmailVerificationOtpInput = {
  email: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__RequestLoginOtpInput = {
  email: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__RequestMagicLinkInput = {
  email: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__RequestMagicLinkPayload = {
  emailSent: Scalars['Boolean']['output'];
  errors: Maybe<Array<__SHOULD_NOT_USE__AuthenticationError>>;
  message: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__RequestOtpPayload = {
  emailSent: Scalars['Boolean']['output'];
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  message: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__RequestPasswordResetOtpInput = {
  email: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__RequestPasswordResetPayload = {
  emailSent: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__ResendEmailVerificationInput = {
  email: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__ResendEmailVerificationPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__ResendInvitationPayload = {
  emailSent: Scalars['Boolean']['output'];
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__ResetPasswordPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__ResetPasswordWithOtpInput = {
  newPassword: Scalars['String']['input'];
  verificationToken: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__ResolveDisputeInput = {
  evidenceReason?: InputMaybe<DisputeEvidenceReason>;
  id: Scalars['ID']['input'];
  status: DisputeStatus;
};

export type __SHOULD_NOT_USE__ResolveDisputePayload = {
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__RestoreOrganizationPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
};

export type __SHOULD_NOT_USE__RestorePermissionInput = {
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__RestorePermissionPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  permissionRole: Maybe<__SHOULD_NOT_USE__PermissionRole>;
};

export type __SHOULD_NOT_USE__ResumeRecurringPaymentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  recurringPayment: Maybe<__SHOULD_NOT_USE__RecurringPayment>;
};

export type __SHOULD_NOT_USE__RetryWebhookDeliveryInput = {
  deliveryId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__RetryWebhookDeliveryPayload = {
  delivery: Maybe<__SHOULD_NOT_USE__WebhookDelivery>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__RevenueDashboard = {
  analytics: Array<__SHOULD_NOT_USE__PaymentAnalytics>;
  failedPayments: Array<__SHOULD_NOT_USE__Payment>;
  providerBreakdown: Array<__SHOULD_NOT_USE__ProviderPerformance>;
  recentPayments: Array<__SHOULD_NOT_USE__Payment>;
  summary: __SHOULD_NOT_USE__PaymentSummary;
  topCustomers: Array<__SHOULD_NOT_USE__CustomerPaymentHistory>;
};

export type __SHOULD_NOT_USE__RevokePermissionInput = {
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__RevokePermissionPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type __SHOULD_NOT_USE__Role = {
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['Map']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: __SHOULD_NOT_USE__Organization;
  organizationId: Scalars['ID']['output'];
  permissionCount: Scalars['Int']['output'];
  permissions: __SHOULD_NOT_USE__PermissionConnection;
  updatedAt: Scalars['Time']['output'];
  userCount: Scalars['Int']['output'];
  users: Array<Maybe<__SHOULD_NOT_USE__User>>;
};


export type __SHOULD_NOT_USE__RolePermissionsArgs = {
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
  where?: InputMaybe<__SHOULD_NOT_USE__PermissionWhereInput>;
};

export type __SHOULD_NOT_USE__RoleConnection = {
  edges: Array<__SHOULD_NOT_USE__RoleEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__RoleEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Role;
};

export type __SHOULD_NOT_USE__RoleOrderByField = {
  direction: SortOrder;
  field: RoleOrderField;
};

export const RoleOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type RoleOrderField = typeof RoleOrderField[keyof typeof RoleOrderField];
export type __SHOULD_NOT_USE__RolePermissionGrant = {
  permission: __SHOULD_NOT_USE__Permission;
  permissionFor: Maybe<PermissionFor>;
  role: __SHOULD_NOT_USE__Role;
};

export type __SHOULD_NOT_USE__RoleSortInput = {
  orderBy: Array<__SHOULD_NOT_USE__RoleOrderByField>;
};

/**
 * RoleWhereInput is used for filtering Role objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__RoleWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__RoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** permissions edge predicates */
  hasPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionWhereInput>>;
  /** role_permissions edge predicates */
  hasRolePermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolePermissionsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PermissionRoleWhereInput>>;
  /** role_users edge predicates */
  hasRoleUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoleUsersWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserRoleWhereInput>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__RoleWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__RoleWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__RotateServiceAccountWebhookSecretPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  /**
   * The new signing secret. Returned only here. The previous secret stops working
   * immediately.
   */
  secret: Maybe<Scalars['String']['output']>;
  serviceAccountWebhook: Maybe<__SHOULD_NOT_USE__ServiceAccountWebhook>;
};

export type __SHOULD_NOT_USE__SavePaymentMethodInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardExpiryMonth?: InputMaybe<Scalars['Int']['input']>;
  cardExpiryYear?: InputMaybe<Scalars['Int']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionID: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['Map']['input']>;
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodID: Scalars['String']['input'];
  type: PaymentType;
};

export type __SHOULD_NOT_USE__SavePaymentMethodPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  paymentMethod: Maybe<__SHOULD_NOT_USE__PaymentMethod>;
  successResponseUrl: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__SendInvoiceEmailInput = {
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  to: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__SendInvoiceEmailPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  sentAt: Maybe<Scalars['Time']['output']>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__ServiceAccount = {
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/**
 * ServiceAccountAuditLogWhereInput is used for filtering ServiceAccountAuditLog objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__ServiceAccountAuditLogWhereInput = {
  /** acting_user_id field predicates */
  actingUserID?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDGT?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  actingUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  actingUserIDLT?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  actingUserIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  actingUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountAuditLogWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** error_reason field predicates */
  errorReason?: InputMaybe<Scalars['String']['input']>;
  errorReasonContains?: InputMaybe<Scalars['String']['input']>;
  errorReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorReasonGT?: InputMaybe<Scalars['String']['input']>;
  errorReasonGTE?: InputMaybe<Scalars['String']['input']>;
  errorReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorReasonLT?: InputMaybe<Scalars['String']['input']>;
  errorReasonLTE?: InputMaybe<Scalars['String']['input']>;
  errorReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  errorReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_account edge predicates */
  hasServiceAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** jti field predicates */
  jti?: InputMaybe<Scalars['String']['input']>;
  jtiContains?: InputMaybe<Scalars['String']['input']>;
  jtiContainsFold?: InputMaybe<Scalars['String']['input']>;
  jtiEqualFold?: InputMaybe<Scalars['String']['input']>;
  jtiGT?: InputMaybe<Scalars['String']['input']>;
  jtiGTE?: InputMaybe<Scalars['String']['input']>;
  jtiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  jtiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  jtiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  jtiLT?: InputMaybe<Scalars['String']['input']>;
  jtiLTE?: InputMaybe<Scalars['String']['input']>;
  jtiNEQ?: InputMaybe<Scalars['String']['input']>;
  jtiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__ServiceAccountAuditLogWhereInput>;
  /** operation_name field predicates */
  operationName?: InputMaybe<Scalars['String']['input']>;
  operationNameContains?: InputMaybe<Scalars['String']['input']>;
  operationNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  operationNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  operationNameGT?: InputMaybe<Scalars['String']['input']>;
  operationNameGTE?: InputMaybe<Scalars['String']['input']>;
  operationNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  operationNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  operationNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  operationNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  operationNameLT?: InputMaybe<Scalars['String']['input']>;
  operationNameLTE?: InputMaybe<Scalars['String']['input']>;
  operationNameNEQ?: InputMaybe<Scalars['String']['input']>;
  operationNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  operationNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountAuditLogWhereInput>>;
  /** request_ip field predicates */
  requestIP?: InputMaybe<Scalars['String']['input']>;
  requestIPContains?: InputMaybe<Scalars['String']['input']>;
  requestIPContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestIPEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestIPGT?: InputMaybe<Scalars['String']['input']>;
  requestIPGTE?: InputMaybe<Scalars['String']['input']>;
  requestIPHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestIPHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestIPIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIPIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestIPLT?: InputMaybe<Scalars['String']['input']>;
  requestIPLTE?: InputMaybe<Scalars['String']['input']>;
  requestIPNEQ?: InputMaybe<Scalars['String']['input']>;
  requestIPNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIPNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_user_agent field predicates */
  requestUserAgent?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentContains?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentGT?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentGTE?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestUserAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestUserAgentLT?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentLTE?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  requestUserAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestUserAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_account_id field predicates */
  serviceAccountID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** succeeded field predicates */
  succeeded?: InputMaybe<Scalars['Boolean']['input']>;
  succeededNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * ServiceAccountKeyWhereInput is used for filtering ServiceAccountKey objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__ServiceAccountKeyWhereInput = {
  /** algorithm field predicates */
  algorithm?: InputMaybe<Scalars['String']['input']>;
  algorithmContains?: InputMaybe<Scalars['String']['input']>;
  algorithmContainsFold?: InputMaybe<Scalars['String']['input']>;
  algorithmEqualFold?: InputMaybe<Scalars['String']['input']>;
  algorithmGT?: InputMaybe<Scalars['String']['input']>;
  algorithmGTE?: InputMaybe<Scalars['String']['input']>;
  algorithmHasPrefix?: InputMaybe<Scalars['String']['input']>;
  algorithmHasSuffix?: InputMaybe<Scalars['String']['input']>;
  algorithmIn?: InputMaybe<Array<Scalars['String']['input']>>;
  algorithmLT?: InputMaybe<Scalars['String']['input']>;
  algorithmLTE?: InputMaybe<Scalars['String']['input']>;
  algorithmNEQ?: InputMaybe<Scalars['String']['input']>;
  algorithmNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountKeyWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_account edge predicates */
  hasServiceAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** kid field predicates */
  kid?: InputMaybe<Scalars['String']['input']>;
  kidContains?: InputMaybe<Scalars['String']['input']>;
  kidContainsFold?: InputMaybe<Scalars['String']['input']>;
  kidEqualFold?: InputMaybe<Scalars['String']['input']>;
  kidGT?: InputMaybe<Scalars['String']['input']>;
  kidGTE?: InputMaybe<Scalars['String']['input']>;
  kidHasPrefix?: InputMaybe<Scalars['String']['input']>;
  kidHasSuffix?: InputMaybe<Scalars['String']['input']>;
  kidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  kidLT?: InputMaybe<Scalars['String']['input']>;
  kidLTE?: InputMaybe<Scalars['String']['input']>;
  kidNEQ?: InputMaybe<Scalars['String']['input']>;
  kidNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__ServiceAccountKeyWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountKeyWhereInput>>;
  /** public_key field predicates */
  publicKey?: InputMaybe<Scalars['String']['input']>;
  publicKeyContains?: InputMaybe<Scalars['String']['input']>;
  publicKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyGT?: InputMaybe<Scalars['String']['input']>;
  publicKeyGTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  publicKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicKeyLT?: InputMaybe<Scalars['String']['input']>;
  publicKeyLTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  publicKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** service_account_id field predicates */
  serviceAccountID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A webhook endpoint owned by a service account. Unlike a MerchantWebhook it has
 * no owning organization and receives matching events across all organizations.
 *
 * The signing secret is deliberately absent from this type — it is returned only
 * when the webhook is created or its secret is rotated.
 */
export type __SHOULD_NOT_USE__ServiceAccountWebhook = {
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['String']['output']>;
  disabledAt: Maybe<Scalars['Time']['output']>;
  failureCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastTriggeredAt: Maybe<Scalars['Time']['output']>;
  metadata: Maybe<Scalars['Map']['output']>;
  name: Scalars['String']['output'];
  serviceAccount: __SHOULD_NOT_USE__ServiceAccount;
  serviceAccountID: Scalars['ID']['output'];
  status: WebhookStatus;
  subscriptions: Maybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookSubscription>>;
  updatedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__ServiceAccountWebhookConnection = {
  edges: Array<__SHOULD_NOT_USE__ServiceAccountWebhookEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__ServiceAccountWebhookEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__ServiceAccountWebhook;
};

export type __SHOULD_NOT_USE__ServiceAccountWebhookOrderByInput = {
  direction: SortOrder;
  field: ServiceAccountWebhookOrderField;
};

export const ServiceAccountWebhookOrderField = {
  CreatedAt: 'CREATED_AT',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ServiceAccountWebhookOrderField = typeof ServiceAccountWebhookOrderField[keyof typeof ServiceAccountWebhookOrderField];
export type __SHOULD_NOT_USE__ServiceAccountWebhookSubscription = {
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  metadata: Maybe<Scalars['Map']['output']>;
  serviceAccountWebhook: __SHOULD_NOT_USE__ServiceAccountWebhook;
  serviceAccountWebhookID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  webhookEventType: __SHOULD_NOT_USE__WebhookEventType;
  webhookEventTypeID: Scalars['ID']['output'];
};

/**
 * ServiceAccountWebhookSubscriptionWhereInput is used for filtering ServiceAccountWebhookSubscription objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__ServiceAccountWebhookSubscriptionWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookSubscriptionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** service_account_webhook edge predicates */
  hasServiceAccountWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWebhookWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookWhereInput>>;
  /** webhook_event_type edge predicates */
  hasWebhookEventType?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhookEventTypeWith?: InputMaybe<Array<__SHOULD_NOT_USE__WebhookEventTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_enabled field predicates */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__ServiceAccountWebhookSubscriptionWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookSubscriptionWhereInput>>;
  /** service_account_webhook_id field predicates */
  serviceAccountWebhookID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountWebhookIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountWebhookIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountWebhookIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** webhook_event_type_id field predicates */
  webhookEventTypeID?: InputMaybe<Scalars['ID']['input']>;
  webhookEventTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookEventTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  webhookEventTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * ServiceAccountWebhookWhereInput is used for filtering ServiceAccountWebhook objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__ServiceAccountWebhookWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled_at field predicates */
  disabledAt?: InputMaybe<Scalars['Time']['input']>;
  disabledAtGT?: InputMaybe<Scalars['Time']['input']>;
  disabledAtGTE?: InputMaybe<Scalars['Time']['input']>;
  disabledAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disabledAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  disabledAtLT?: InputMaybe<Scalars['Time']['input']>;
  disabledAtLTE?: InputMaybe<Scalars['Time']['input']>;
  disabledAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  disabledAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  disabledAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** failure_count field predicates */
  failureCount?: InputMaybe<Scalars['Int']['input']>;
  failureCountGT?: InputMaybe<Scalars['Int']['input']>;
  failureCountGTE?: InputMaybe<Scalars['Int']['input']>;
  failureCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  failureCountLT?: InputMaybe<Scalars['Int']['input']>;
  failureCountLTE?: InputMaybe<Scalars['Int']['input']>;
  failureCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  failureCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** deliveries edge predicates */
  hasDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeliveriesWith?: InputMaybe<Array<__SHOULD_NOT_USE__WebhookDeliveryWhereInput>>;
  /** service_account edge predicates */
  hasServiceAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWhereInput>>;
  /** subscriptions edge predicates */
  hasSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubscriptionsWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookSubscriptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_triggered_at field predicates */
  lastTriggeredAt?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastTriggeredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastTriggeredAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastTriggeredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastTriggeredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__ServiceAccountWebhookWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookWhereInput>>;
  /** service_account_id field predicates */
  serviceAccountID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<WebhookStatus>;
  statusIn?: InputMaybe<Array<WebhookStatus>>;
  statusNEQ?: InputMaybe<WebhookStatus>;
  statusNotIn?: InputMaybe<Array<WebhookStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * ServiceAccountWhereInput is used for filtering ServiceAccount objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__ServiceAccountWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** audit_logs edge predicates */
  hasAuditLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAuditLogsWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountAuditLogWhereInput>>;
  /** keys edge predicates */
  hasKeys?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeysWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountKeyWhereInput>>;
  /** webhooks edge predicates */
  hasWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhooksWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__ServiceAccountWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__SetBankSupportedChannelsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
};

export type __SHOULD_NOT_USE__SetDefaultPolicyInput = {
  policyId: Scalars['ID']['input'];
  policyType: PolicyType;
};

export type __SHOULD_NOT_USE__SetDefaultPolicyPayload = {
  defaultPolicy: Maybe<__SHOULD_NOT_USE__MerchantDefaultPolicy>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__SetOrganizationDonationEligibilityPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
};

export type __SHOULD_NOT_USE__SetPrimaryBankAccountPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  previousPrimaryAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
};

export type __SHOULD_NOT_USE__SignUpUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  isTermsAccepted: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__SignUpUserPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export const SortOrder = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type __SHOULD_NOT_USE__SplitPaymentConnection = {
  edges: Array<__SHOULD_NOT_USE__SplitPaymentEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
};

export type __SHOULD_NOT_USE__SplitPaymentEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__SplitPaymentInfo;
};

export type __SHOULD_NOT_USE__SplitPaymentInfo = {
  currency: Currency;
  payment: __SHOULD_NOT_USE__Payment;
  payoutCount: Scalars['Int']['output'];
  payouts: Array<__SHOULD_NOT_USE__Payout>;
  totalSplitAmount: Scalars['Float']['output'];
};

export type __SHOULD_NOT_USE__SplitPayoutInput = {
  originalPayoutId: Scalars['ID']['input'];
  splits: Array<__SHOULD_NOT_USE__PayoutSplitInput>;
};

export type __SHOULD_NOT_USE__SplitPayoutPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  newPayouts: Maybe<Array<__SHOULD_NOT_USE__Payout>>;
  originalPayout: Maybe<__SHOULD_NOT_USE__Payout>;
};

export type __SHOULD_NOT_USE__StatusChangeRecord = {
  changedAt: Scalars['Time']['output'];
  changedBy: __SHOULD_NOT_USE__User;
  fromStatus: UserStatus;
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
  toStatus: UserStatus;
  userId: Scalars['ID']['output'];
};

export type __SHOULD_NOT_USE__SubmitDisputeEvidenceInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  cancellationDelayDate?: InputMaybe<Scalars['Time']['input']>;
  cancellationDelayDescription?: InputMaybe<Scalars['String']['input']>;
  creditVoucherAmount?: InputMaybe<Scalars['Float']['input']>;
  creditVoucherDescription?: InputMaybe<Scalars['String']['input']>;
  creditVoucherGivenDate?: InputMaybe<Scalars['Time']['input']>;
  customerAlreadyRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  evidenceReason: DisputeEvidenceReason;
  id: Scalars['ID']['input'];
  otherReasonDescription?: InputMaybe<Scalars['String']['input']>;
  productOrServiceDetails?: InputMaybe<Scalars['String']['input']>;
  productServiceType?: InputMaybe<ProductServiceType>;
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
  refundDate?: InputMaybe<Scalars['Time']['input']>;
  refundDescription?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['ID']['input']>;
  withdrawalDateByCustomer?: InputMaybe<Scalars['Time']['input']>;
};

export type __SHOULD_NOT_USE__SubmitDisputeEvidencePayload = {
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__SubmitTransferInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['Map']['input']>;
};

export type __SHOULD_NOT_USE__SubmitTransferPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  transfer: Maybe<__SHOULD_NOT_USE__Transfer>;
};

export type __SHOULD_NOT_USE__SuccessPayload = {
  success: Maybe<Scalars['Boolean']['output']>;
};

export type __SHOULD_NOT_USE__SuspendBankAccountPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  statusChange: Maybe<__SHOULD_NOT_USE__BankAccountStatusChangeRecord>;
};

export type __SHOULD_NOT_USE__SyncRolePermissionsInput = {
  permissionIds: Array<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__SyncRolePermissionsPayload = {
  added: Array<__SHOULD_NOT_USE__Permission>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  removed: Array<__SHOULD_NOT_USE__Permission>;
  role: __SHOULD_NOT_USE__Role;
};

export type __SHOULD_NOT_USE__Transfer = {
  beyulTransferCode: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: __SHOULD_NOT_USE__User;
  createdById: Scalars['ID']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notes: Maybe<Scalars['Map']['output']>;
  payoutCount: Scalars['Int']['output'];
  payouts: __SHOULD_NOT_USE__PayoutConnection;
  status: TransferStatus;
  statusUpdatedAt: Maybe<Scalars['Time']['output']>;
  totalAmount: Scalars['Float']['output'];
  transferredToBank: __SHOULD_NOT_USE__Organization;
  transferredToBankId: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type __SHOULD_NOT_USE__TransferPayoutsArgs = {
  orderBy?: InputMaybe<__SHOULD_NOT_USE__PayoutOrderByInput>;
  pagination?: InputMaybe<__SHOULD_NOT_USE__PaginationInput>;
};

export type __SHOULD_NOT_USE__TransferConnection = {
  edges: Array<__SHOULD_NOT_USE__TransferEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__TransferEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__Transfer;
};

export type __SHOULD_NOT_USE__TransferOrderByInput = {
  direction: SortOrder;
  field: TransferOrderField;
};

export const TransferOrderField = {
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  Currency: 'CURRENCY',
  Status: 'STATUS',
  StatusUpdatedAt: 'STATUS_UPDATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type TransferOrderField = typeof TransferOrderField[keyof typeof TransferOrderField];
export const TransferReportField = {
  BeyulTransferCode: 'BEYUL_TRANSFER_CODE',
  Code: 'CODE',
  CreatedAt: 'CREATED_AT',
  CreatedBy: 'CREATED_BY',
  Currency: 'CURRENCY',
  Notes: 'NOTES',
  Status: 'STATUS',
  StatusUpdatedAt: 'STATUS_UPDATED_AT',
  TransferredToBankId: 'TRANSFERRED_TO_BANK_ID'
} as const;

export type TransferReportField = typeof TransferReportField[keyof typeof TransferReportField];
export const TransferStatus = {
  Completed: 'COMPLETED',
  Draft: 'DRAFT',
  Submitted: 'SUBMITTED'
} as const;

export type TransferStatus = typeof TransferStatus[keyof typeof TransferStatus];
export type __SHOULD_NOT_USE__TransferSummary = {
  count: Scalars['Int']['output'];
  currency: Currency;
  payoutCount: Scalars['Int']['output'];
  status: TransferStatus;
  totalAmount: Scalars['Float']['output'];
};

/**
 * TransferWhereInput is used for filtering Transfer objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__TransferWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__TransferWhereInput>>;
  /** beyul_transfer_code field predicates */
  beyulTransferCode?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeContains?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeGT?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeGTE?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  beyulTransferCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  beyulTransferCodeLT?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeLTE?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  beyulTransferCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  beyulTransferCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Currency>;
  currencyIn?: InputMaybe<Array<Currency>>;
  currencyNEQ?: InputMaybe<Currency>;
  currencyNotIn?: InputMaybe<Array<Currency>>;
  /** bank edge predicates */
  hasBank?: InputMaybe<Scalars['Boolean']['input']>;
  hasBankWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** payouts edge predicates */
  hasPayouts?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayoutsWith?: InputMaybe<Array<__SHOULD_NOT_USE__PayoutWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__TransferWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__TransferWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<TransferStatus>;
  statusIn?: InputMaybe<Array<TransferStatus>>;
  statusNEQ?: InputMaybe<TransferStatus>;
  statusNotIn?: InputMaybe<Array<TransferStatus>>;
  /** status_updated_at field predicates */
  statusUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  statusUpdatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  statusUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** transferred_to_bank_id field predicates */
  transferredToBankID?: InputMaybe<Scalars['ID']['input']>;
  transferredToBankIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  transferredToBankIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  transferredToBankIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__UnassignRoleInput = {
  roleId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type __SHOULD_NOT_USE__UnassignRolePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  success: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__UnflagPaymentInput = {
  paymentId: Scalars['ID']['input'];
};

export type __SHOULD_NOT_USE__UnflagPaymentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  payment: Maybe<__SHOULD_NOT_USE__Payment>;
};

export type __SHOULD_NOT_USE__UpdateApiKeyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateApiKeyPayload = {
  apiKey: Maybe<__SHOULD_NOT_USE__ApiKey>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__UpdateBankAccountDetailsInput = {
  accountHolderName: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__UpdateBankAccountDetailsPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  requiresReVerification: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__UpdateBillingAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateBillingAddressPayload = {
  billingAddress: Maybe<__SHOULD_NOT_USE__BillingAddress>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__UpdateCardTypeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CardType>;
};

export type __SHOULD_NOT_USE__UpdateCardTypePayload = {
  cardType: __SHOULD_NOT_USE__PaymentProviderCardType;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__UpdateDisputeProgressInput = {
  id: Scalars['ID']['input'];
  progressStatus: DisputeProgressStatus;
};

export type __SHOULD_NOT_USE__UpdateDisputeProgressPayload = {
  dispute: Maybe<__SHOULD_NOT_USE__Dispute>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
};

export type __SHOULD_NOT_USE__UpdateInvoiceInput = {
  dueDate?: InputMaybe<Scalars['Time']['input']>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  paymentOptions?: InputMaybe<Array<PaymentType>>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  refundPolicyTerms?: InputMaybe<InvoiceRefundPolicyTerms>;
};

export type __SHOULD_NOT_USE__UpdateInvoicePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  invoice: Maybe<__SHOULD_NOT_USE__Invoice>;
};

export type __SHOULD_NOT_USE__UpdateLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type __SHOULD_NOT_USE__UpdateLineItemPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  lineItem: Maybe<__SHOULD_NOT_USE__InvoiceLineItem>;
};

export type __SHOULD_NOT_USE__UpdateMediaInput = {
  id: Scalars['ID']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateMerchantWebhookInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WebhookStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateMerchantWebhookPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantWebhook: Maybe<__SHOULD_NOT_USE__MerchantWebhook>;
};

export type __SHOULD_NOT_USE__UpdateOrganizationInput = {
  address?: InputMaybe<Scalars['Map']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<OrganizationIndustry>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  mccCode?: InputMaybe<Scalars['String']['input']>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherIndustry?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  refundPolicyTerms?: InputMaybe<OrganizationRefundPolicyTerms>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateOrganizationPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
};

export type __SHOULD_NOT_USE__UpdateOrganizationPaymentTypeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__UpdateOrganizationPaymentTypePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organizationPaymentType: Maybe<__SHOULD_NOT_USE__OrganizationPaymentType>;
};

export type __SHOULD_NOT_USE__UpdateOrganizationStatusPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
};

export type __SHOULD_NOT_USE__UpdatePaymentProviderInput = {
  configProfile?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  environment?: InputMaybe<PaymentEnvironment>;
  logoMediaId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProviderStatus>;
  /** Must be non-empty when provided — an empty list would make the provider unroutable */
  supportedChannels?: InputMaybe<Array<PaymentChannel>>;
  supportedCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type __SHOULD_NOT_USE__UpdatePaymentProviderPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  paymentProvider: __SHOULD_NOT_USE__PaymentProvider;
};

export type __SHOULD_NOT_USE__UpdatePaymentTypeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayFeeType?: InputMaybe<FeeType>;
  gatewayFees?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformFeeType?: InputMaybe<FeeType>;
  platformFees?: InputMaybe<Scalars['Float']['input']>;
  supportedCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<PaymentType>;
};

export type __SHOULD_NOT_USE__UpdatePaymentTypePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  paymentType: __SHOULD_NOT_USE__PaymentProviderPaymentType;
};

export type __SHOULD_NOT_USE__UpdatePermissionGroupInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdatePermissionGroupPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  permissionGroup: Maybe<__SHOULD_NOT_USE__PermissionGroup>;
};

export type __SHOULD_NOT_USE__UpdatePolicyDocumentInput = {
  content?: InputMaybe<Scalars['Map']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdatePolicyDocumentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  policy: Maybe<__SHOULD_NOT_USE__PolicyDocument>;
};

export type __SHOULD_NOT_USE__UpdatePolicyTemplateInput = {
  content?: InputMaybe<Scalars['Map']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdatePolicyTemplatePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  template: Maybe<__SHOULD_NOT_USE__PolicyTemplate>;
};

export type __SHOULD_NOT_USE__UpdateQuickPayInput = {
  amountType?: InputMaybe<QuickPayAmountType>;
  customFields?: InputMaybe<Scalars['Map']['input']>;
  description?: InputMaybe<Scalars['Map']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Optional sale basket, stored verbatim; replaces the existing basket when provided */
  lineItems?: InputMaybe<Array<Scalars['Map']['input']>>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  merchantProcessingFee?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentOptions?: InputMaybe<Array<PaymentType>>;
  presetAmounts?: InputMaybe<Array<Scalars['Float']['input']>>;
  status?: InputMaybe<QuickPayStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateQuickPayPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  quickPay: Maybe<__SHOULD_NOT_USE__QuickPay>;
};

export type __SHOULD_NOT_USE__UpdateRecurringPaymentInput = {
  amount?: InputMaybe<Scalars['Int64']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  maxCharges?: InputMaybe<Scalars['Int']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Map']['input']>;
};

export type __SHOULD_NOT_USE__UpdateRecurringPaymentMethodInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardExpiryMonth?: InputMaybe<Scalars['Int']['input']>;
  cardExpiryYear?: InputMaybe<Scalars['Int']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Map']['input']>;
  providerCustomerID?: InputMaybe<Scalars['String']['input']>;
  providerPaymentMethodID: Scalars['String']['input'];
  type: PaymentType;
  /** The update session ID */
  updateSessionID: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__UpdateRecurringPaymentMethodPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  paymentMethod: Maybe<__SHOULD_NOT_USE__PaymentMethod>;
  recurringPayment: Maybe<__SHOULD_NOT_USE__RecurringPayment>;
  /** Redirect URL after success (the recurring payment's success_url) */
  successURL: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__UpdateRecurringPaymentPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  recurringPayment: Maybe<__SHOULD_NOT_USE__RecurringPayment>;
};

export type __SHOULD_NOT_USE__UpdateRefundInput = {
  extendedCancellationPolicyText?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['Map']['input']>;
  subReason?: InputMaybe<Scalars['Map']['input']>;
};

export type __SHOULD_NOT_USE__UpdateRefundPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refund: Maybe<__SHOULD_NOT_USE__Refund>;
};

export type __SHOULD_NOT_USE__UpdateRoleInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateRolePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  role: __SHOULD_NOT_USE__Role;
};

export type __SHOULD_NOT_USE__UpdateServiceAccountWebhookInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WebhookStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateServiceAccountWebhookPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  serviceAccountWebhook: Maybe<__SHOULD_NOT_USE__ServiceAccountWebhook>;
};

export type __SHOULD_NOT_USE__UpdateServiceAccountWebhookSubscriptionInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__UpdateServiceAccountWebhookSubscriptionPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  subscription: Maybe<__SHOULD_NOT_USE__ServiceAccountWebhookSubscription>;
};

export type __SHOULD_NOT_USE__UpdateTransferNotesInput = {
  id: Scalars['ID']['input'];
  notes: Scalars['Map']['input'];
};

export type __SHOULD_NOT_USE__UpdateTransferNotesPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  transfer: Maybe<__SHOULD_NOT_USE__Transfer>;
};

export type __SHOULD_NOT_USE__UpdateUserProfileInput = {
  description?: InputMaybe<Scalars['Map']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type __SHOULD_NOT_USE__UpdateUserProfilePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__UpdateUserStatusPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  statusChange: __SHOULD_NOT_USE__StatusChangeRecord;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__UpdateWebhookSubscriptionInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__UpdateWebhookSubscriptionPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  subscription: Maybe<__SHOULD_NOT_USE__MerchantWebhookSubscription>;
};

export type __SHOULD_NOT_USE__UploadUrl = {
  expiresIn: Scalars['Int64']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type __SHOULD_NOT_USE__User = {
  avatar: Maybe<__SHOULD_NOT_USE__Media>;
  createdAt: Scalars['Time']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  description: Maybe<Scalars['Map']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  isOwner: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['Time']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  organization: Maybe<__SHOULD_NOT_USE__Organization>;
  organizationId: Maybe<Scalars['ID']['output']>;
  permissions: Array<__SHOULD_NOT_USE__Permission>;
  roles: Maybe<Array<__SHOULD_NOT_USE__Role>>;
  status: UserStatus;
  updatedAt: Scalars['Time']['output'];
  userRoles: Maybe<Array<__SHOULD_NOT_USE__UserRole>>;
};

export type __SHOULD_NOT_USE__UserComplianceStatus = {
  acceptedPolicies: Array<__SHOULD_NOT_USE__UserPolicyAcceptance>;
  isCompliant: Scalars['Boolean']['output'];
  pendingPolicies: Array<__SHOULD_NOT_USE__PolicyDocument>;
};

export type __SHOULD_NOT_USE__UserConnection = {
  edges: Array<__SHOULD_NOT_USE__UserEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__UserEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__User;
};

/**
 * UserOTPWhereInput is used for filtering UserOTP objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__UserOtpWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__UserOtpWhereInput>>;
  /** attempts field predicates */
  attempts?: InputMaybe<Scalars['Int']['input']>;
  attemptsGT?: InputMaybe<Scalars['Int']['input']>;
  attemptsGTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  attemptsLT?: InputMaybe<Scalars['Int']['input']>;
  attemptsLTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsNEQ?: InputMaybe<Scalars['Int']['input']>;
  attemptsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** consumed_at field predicates */
  consumedAt?: InputMaybe<Scalars['Time']['input']>;
  consumedAtGT?: InputMaybe<Scalars['Time']['input']>;
  consumedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  consumedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  consumedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  consumedAtLT?: InputMaybe<Scalars['Time']['input']>;
  consumedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  consumedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  consumedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  consumedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__UserOtpWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__UserOtpWhereInput>>;
  /** purpose field predicates */
  purpose?: InputMaybe<OtpPurpose>;
  purposeIn?: InputMaybe<Array<OtpPurpose>>;
  purposeNEQ?: InputMaybe<OtpPurpose>;
  purposeNotIn?: InputMaybe<Array<OtpPurpose>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type __SHOULD_NOT_USE__UserOrderByField = {
  direction: SortOrder;
  field: UserOrderField;
};

export const UserOrderField = {
  CreatedAt: 'CREATED_AT',
  Email: 'EMAIL',
  FirstName: 'FIRST_NAME',
  LastLoginAt: 'LAST_LOGIN_AT',
  LastName: 'LAST_NAME',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserOrderField = typeof UserOrderField[keyof typeof UserOrderField];
export type __SHOULD_NOT_USE__UserPolicyAcceptance = {
  acceptedAt: Scalars['Time']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  policy: __SHOULD_NOT_USE__PolicyDocument;
  supersededBy: Maybe<__SHOULD_NOT_USE__UserPolicyAcceptance>;
  user: __SHOULD_NOT_USE__User;
  userAgent: Maybe<Scalars['String']['output']>;
};

export type __SHOULD_NOT_USE__UserPolicyAcceptanceConnection = {
  edges: Array<__SHOULD_NOT_USE__UserPolicyAcceptanceEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__UserPolicyAcceptanceEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__UserPolicyAcceptance;
};

/**
 * UserPolicyAcceptanceWhereInput is used for filtering UserPolicyAcceptance objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__UserPolicyAcceptanceWhereInput = {
  /** accepted_at field predicates */
  acceptedAt?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  acceptedAtLT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  and?: InputMaybe<Array<__SHOULD_NOT_USE__UserPolicyAcceptanceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** policy edge predicates */
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyWith?: InputMaybe<Array<__SHOULD_NOT_USE__PolicyDocumentWhereInput>>;
  /** superseded_acceptances edge predicates */
  hasSupersededAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededAcceptancesWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserPolicyAcceptanceWhereInput>>;
  /** superseded_by edge predicates */
  hasSupersededBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededByWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserPolicyAcceptanceWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ip_address field predicates */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressContains?: InputMaybe<Scalars['String']['input']>;
  ipAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ipAddressGT?: InputMaybe<Scalars['String']['input']>;
  ipAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ipAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ipAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddressLT?: InputMaybe<Scalars['String']['input']>;
  ipAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ipAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ipAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_current field predicates */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__UserPolicyAcceptanceWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__UserPolicyAcceptanceWhereInput>>;
  /** policy_id field predicates */
  policyID?: InputMaybe<Scalars['ID']['input']>;
  policyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  policyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** superseded_by_id field predicates */
  supersededByID?: InputMaybe<Scalars['ID']['input']>;
  supersededByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supersededByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supersededByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  supersededByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  supersededByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgentContains?: InputMaybe<Scalars['String']['input']>;
  userAgentContainsFold?: InputMaybe<Scalars['String']['input']>;
  userAgentEqualFold?: InputMaybe<Scalars['String']['input']>;
  userAgentGT?: InputMaybe<Scalars['String']['input']>;
  userAgentGTE?: InputMaybe<Scalars['String']['input']>;
  userAgentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userAgentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['String']['input']>;
  userAgentLTE?: InputMaybe<Scalars['String']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['String']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type __SHOULD_NOT_USE__UserRole = {
  assignedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  role: __SHOULD_NOT_USE__Role;
  roleId: Scalars['ID']['output'];
  user: __SHOULD_NOT_USE__User;
  userId: Scalars['ID']['output'];
};

export type __SHOULD_NOT_USE__UserRoleConnection = {
  edges: Array<__SHOULD_NOT_USE__UserRoleEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__UserRoleEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__UserRole;
};

/**
 * UserRoleWhereInput is used for filtering UserRole objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__UserRoleWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__UserRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<__SHOULD_NOT_USE__UserRoleWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__UserRoleWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__UserSortInput = {
  orderBy: Array<__SHOULD_NOT_USE__UserOrderByField>;
};

export const UserStatus = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Pending: 'PENDING',
  Suspended: 'SUSPENDED'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];
/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__UserWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** email_verification_token field predicates */
  emailVerificationToken?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenContains?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenGT?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenGTE?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailVerificationTokenIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerificationTokenLT?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenLTE?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  emailVerificationTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailVerificationTokenNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameContains?: InputMaybe<Scalars['String']['input']>;
  firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstNameGT?: InputMaybe<Scalars['String']['input']>;
  firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameLT?: InputMaybe<Scalars['String']['input']>;
  firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** events edge predicates */
  hasEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventsWith?: InputMaybe<Array<__SHOULD_NOT_USE__EventWhereInput>>;
  /** generated_api_keys edge predicates */
  hasGeneratedAPIKeys?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeneratedAPIKeysWith?: InputMaybe<Array<__SHOULD_NOT_USE__ApiKeyWhereInput>>;
  /** invoices edge predicates */
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoicesWith?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceWhereInput>>;
  /** manually_approved_invoices edge predicates */
  hasManuallyApprovedInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  hasManuallyApprovedInvoicesWith?: InputMaybe<Array<__SHOULD_NOT_USE__InvoiceWhereInput>>;
  /** media edge predicates */
  hasMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediaWith?: InputMaybe<Array<__SHOULD_NOT_USE__MediaWhereInput>>;
  /** merchant_policy_acceptances edge predicates */
  hasMerchantPolicyAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasMerchantPolicyAcceptancesWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantPolicyAcceptanceWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<__SHOULD_NOT_USE__OrganizationWhereInput>>;
  /** otps edge predicates */
  hasOtps?: InputMaybe<Scalars['Boolean']['input']>;
  hasOtpsWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserOtpWhereInput>>;
  /** policy_acceptances edge predicates */
  hasPolicyAcceptances?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyAcceptancesWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserPolicyAcceptanceWhereInput>>;
  /** refunds edge predicates */
  hasRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  hasRefundsWith?: InputMaybe<Array<__SHOULD_NOT_USE__RefundWhereInput>>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<__SHOULD_NOT_USE__RoleWhereInput>>;
  /** transfers edge predicates */
  hasTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  hasTransfersWith?: InputMaybe<Array<__SHOULD_NOT_USE__TransferWhereInput>>;
  /** user_roles edge predicates */
  hasUserRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserRolesWith?: InputMaybe<Array<__SHOULD_NOT_USE__UserRoleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_email_verified field predicates */
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerifiedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_owner field predicates */
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_login_at field predicates */
  lastLoginAt?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastLoginAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastLoginAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastLoginAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameContains?: InputMaybe<Scalars['String']['input']>;
  lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastNameGT?: InputMaybe<Scalars['String']['input']>;
  lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameLT?: InputMaybe<Scalars['String']['input']>;
  lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** magic_link_token_expiry field predicates */
  magicLinkTokenExpiry?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  magicLinkTokenExpiryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  magicLinkTokenExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  magicLinkTokenExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  magicLinkTokenExpiryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__UserWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__UserWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** password_reset_token_expiry field predicates */
  passwordResetTokenExpiry?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  passwordResetTokenExpiryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  passwordResetTokenExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  passwordResetTokenExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  passwordResetTokenExpiryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<UserStatus>;
  statusContains?: InputMaybe<UserStatus>;
  statusContainsFold?: InputMaybe<UserStatus>;
  statusEqualFold?: InputMaybe<UserStatus>;
  statusGT?: InputMaybe<UserStatus>;
  statusGTE?: InputMaybe<UserStatus>;
  statusHasPrefix?: InputMaybe<UserStatus>;
  statusHasSuffix?: InputMaybe<UserStatus>;
  statusIn?: InputMaybe<Array<UserStatus>>;
  statusLT?: InputMaybe<UserStatus>;
  statusLTE?: InputMaybe<UserStatus>;
  statusNEQ?: InputMaybe<UserStatus>;
  statusNotIn?: InputMaybe<Array<UserStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__VerifyBankAccountInput = {
  accountId: Scalars['ID']['input'];
  amount1: Scalars['Int']['input'];
  amount2: Scalars['Int']['input'];
};

export type __SHOULD_NOT_USE__VerifyBankAccountPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  merchantBankAccount: Maybe<__SHOULD_NOT_USE__MerchantBankAccount>;
  verified: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__VerifyEmailInput = {
  token: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__VerifyEmailPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__VerifyEmailWithOtpInput = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__VerifyLoginOtpInput = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__VerifyMagicLinkInput = {
  token: Scalars['String']['input'];
};

export type __SHOULD_NOT_USE__VerifyMagicLinkPayload = {
  accessToken: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<__SHOULD_NOT_USE__AuthenticationError>>;
  refreshToken: Maybe<Scalars['String']['output']>;
  user: Maybe<__SHOULD_NOT_USE__User>;
};

export type __SHOULD_NOT_USE__VerifyOtpInput = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  purpose: OtpPurpose;
};

export type __SHOULD_NOT_USE__VerifyOtpPayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__AuthenticationError>>;
  expiresAt: Maybe<Scalars['Time']['output']>;
  verificationToken: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type __SHOULD_NOT_USE__VoidInvoicePayload = {
  errors: Maybe<Array<__SHOULD_NOT_USE__Error>>;
  invoice: Maybe<__SHOULD_NOT_USE__Invoice>;
};

export const WebPaymentsRefundPolicyTerms = {
  FullRefund: 'FULL_REFUND',
  NoRefund: 'NO_REFUND',
  ProcessingFeeNotRefunded: 'PROCESSING_FEE_NOT_REFUNDED'
} as const;

export type WebPaymentsRefundPolicyTerms = typeof WebPaymentsRefundPolicyTerms[keyof typeof WebPaymentsRefundPolicyTerms];
export type __SHOULD_NOT_USE__WebhookDelivery = {
  attemptNumber: Scalars['Int']['output'];
  completedAt: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  durationMs: Maybe<Scalars['Int']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  eventID: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  maxAttempts: Scalars['Int']['output'];
  nextRetryAt: Maybe<Scalars['Time']['output']>;
  organizationID: Maybe<Scalars['ID']['output']>;
  requestBody: Scalars['String']['output'];
  requestHeaders: Scalars['Map']['output'];
  requestURL: Scalars['String']['output'];
  responseBody: Maybe<Scalars['String']['output']>;
  responseHeaders: Maybe<Scalars['Map']['output']>;
  responseStatusCode: Maybe<Scalars['Int']['output']>;
  serviceAccountWebhookID: Maybe<Scalars['ID']['output']>;
  status: WebhookDeliveryStatus;
  triggeredAt: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  webhook: Maybe<__SHOULD_NOT_USE__MerchantWebhook>;
  webhookID: Maybe<Scalars['ID']['output']>;
};

export type __SHOULD_NOT_USE__WebhookDeliveryConnection = {
  edges: Array<__SHOULD_NOT_USE__WebhookDeliveryEdge>;
  pageInfo: __SHOULD_NOT_USE__PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type __SHOULD_NOT_USE__WebhookDeliveryEdge = {
  cursor: Scalars['String']['output'];
  node: __SHOULD_NOT_USE__WebhookDelivery;
};

export type __SHOULD_NOT_USE__WebhookDeliveryOrderByInput = {
  direction: SortOrder;
  field: WebhookDeliveryOrderField;
};

export const WebhookDeliveryOrderField = {
  EventType: 'EVENT_TYPE',
  Status: 'STATUS',
  TriggeredAt: 'TRIGGERED_AT'
} as const;

export type WebhookDeliveryOrderField = typeof WebhookDeliveryOrderField[keyof typeof WebhookDeliveryOrderField];
export const WebhookDeliveryStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Success: 'SUCCESS',
  Trying: 'TRYING'
} as const;

export type WebhookDeliveryStatus = typeof WebhookDeliveryStatus[keyof typeof WebhookDeliveryStatus];
/**
 * WebhookDeliveryWhereInput is used for filtering WebhookDelivery objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__WebhookDeliveryWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__WebhookDeliveryWhereInput>>;
  /** attempt_number field predicates */
  attemptNumber?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberGT?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  attemptNumberLT?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  attemptNumberNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** duration_ms field predicates */
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  durationMsGT?: InputMaybe<Scalars['Int']['input']>;
  durationMsGTE?: InputMaybe<Scalars['Int']['input']>;
  durationMsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationMsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  durationMsLT?: InputMaybe<Scalars['Int']['input']>;
  durationMsLTE?: InputMaybe<Scalars['Int']['input']>;
  durationMsNEQ?: InputMaybe<Scalars['Int']['input']>;
  durationMsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationMsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** error_code field predicates */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorCodeContains?: InputMaybe<Scalars['String']['input']>;
  errorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorCodeGT?: InputMaybe<Scalars['String']['input']>;
  errorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  errorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorCodeLT?: InputMaybe<Scalars['String']['input']>;
  errorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  errorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  errorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** error_message field predicates */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessageContains?: InputMaybe<Scalars['String']['input']>;
  errorMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorMessageGT?: InputMaybe<Scalars['String']['input']>;
  errorMessageGTE?: InputMaybe<Scalars['String']['input']>;
  errorMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorMessageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessageLT?: InputMaybe<Scalars['String']['input']>;
  errorMessageLTE?: InputMaybe<Scalars['String']['input']>;
  errorMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  errorMessageNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** event_id field predicates */
  eventID?: InputMaybe<Scalars['String']['input']>;
  eventIDContains?: InputMaybe<Scalars['String']['input']>;
  eventIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventIDGT?: InputMaybe<Scalars['String']['input']>;
  eventIDGTE?: InputMaybe<Scalars['String']['input']>;
  eventIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventIDLT?: InputMaybe<Scalars['String']['input']>;
  eventIDLTE?: InputMaybe<Scalars['String']['input']>;
  eventIDNEQ?: InputMaybe<Scalars['String']['input']>;
  eventIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** event_type field predicates */
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventTypeContains?: InputMaybe<Scalars['String']['input']>;
  eventTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeGT?: InputMaybe<Scalars['String']['input']>;
  eventTypeGTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventTypeLT?: InputMaybe<Scalars['String']['input']>;
  eventTypeLTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  eventTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** service_account_webhook edge predicates */
  hasServiceAccountWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceAccountWebhookWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookWhereInput>>;
  /** webhook edge predicates */
  hasWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebhookWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** idempotency_key field predicates */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyContains?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyGT?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyGTE?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKeyLT?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyLTE?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  idempotencyKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** max_attempts field predicates */
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsGT?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsGTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxAttemptsLT?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsLTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxAttemptsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** next_retry_at field predicates */
  nextRetryAt?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtGT?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtGTE?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextRetryAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextRetryAtLT?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtLTE?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextRetryAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextRetryAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__WebhookDeliveryWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__WebhookDeliveryWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDGT?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  organizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIDLT?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  organizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_body field predicates */
  requestBody?: InputMaybe<Scalars['String']['input']>;
  requestBodyContains?: InputMaybe<Scalars['String']['input']>;
  requestBodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestBodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestBodyGT?: InputMaybe<Scalars['String']['input']>;
  requestBodyGTE?: InputMaybe<Scalars['String']['input']>;
  requestBodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestBodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestBodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestBodyLT?: InputMaybe<Scalars['String']['input']>;
  requestBodyLTE?: InputMaybe<Scalars['String']['input']>;
  requestBodyNEQ?: InputMaybe<Scalars['String']['input']>;
  requestBodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** request_url field predicates */
  requestURL?: InputMaybe<Scalars['String']['input']>;
  requestURLContains?: InputMaybe<Scalars['String']['input']>;
  requestURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  requestURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  requestURLGT?: InputMaybe<Scalars['String']['input']>;
  requestURLGTE?: InputMaybe<Scalars['String']['input']>;
  requestURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  requestURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  requestURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestURLLT?: InputMaybe<Scalars['String']['input']>;
  requestURLLTE?: InputMaybe<Scalars['String']['input']>;
  requestURLNEQ?: InputMaybe<Scalars['String']['input']>;
  requestURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** response_body field predicates */
  responseBody?: InputMaybe<Scalars['String']['input']>;
  responseBodyContains?: InputMaybe<Scalars['String']['input']>;
  responseBodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseBodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseBodyGT?: InputMaybe<Scalars['String']['input']>;
  responseBodyGTE?: InputMaybe<Scalars['String']['input']>;
  responseBodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseBodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseBodyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseBodyLT?: InputMaybe<Scalars['String']['input']>;
  responseBodyLTE?: InputMaybe<Scalars['String']['input']>;
  responseBodyNEQ?: InputMaybe<Scalars['String']['input']>;
  responseBodyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_status_code field predicates */
  responseStatusCode?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeGT?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeGTE?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseStatusCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatusCodeLT?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeLTE?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeNEQ?: InputMaybe<Scalars['Int']['input']>;
  responseStatusCodeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseStatusCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_account_webhook_id field predicates */
  serviceAccountWebhookID?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountWebhookIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountWebhookIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  serviceAccountWebhookIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountWebhookIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceAccountWebhookIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<WebhookDeliveryStatus>;
  statusIn?: InputMaybe<Array<WebhookDeliveryStatus>>;
  statusNEQ?: InputMaybe<WebhookDeliveryStatus>;
  statusNotIn?: InputMaybe<Array<WebhookDeliveryStatus>>;
  /** triggered_at field predicates */
  triggeredAt?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtGT?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  triggeredAtLT?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  triggeredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** webhook_id field predicates */
  webhookID?: InputMaybe<Scalars['ID']['input']>;
  webhookIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  webhookIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  webhookIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  webhookIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type __SHOULD_NOT_USE__WebhookEventType = {
  category: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deprecatedMessage: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeprecated: Scalars['Boolean']['output'];
  payloadExample: Maybe<Scalars['Map']['output']>;
  replacesEventType: Maybe<Scalars['String']['output']>;
  subscriptions: Maybe<Array<__SHOULD_NOT_USE__MerchantWebhookSubscription>>;
  updatedAt: Scalars['Time']['output'];
};

/**
 * WebhookEventTypeWhereInput is used for filtering WebhookEventType objects.
 * Input was generated by ent.
 */
export type __SHOULD_NOT_USE__WebhookEventTypeWhereInput = {
  and?: InputMaybe<Array<__SHOULD_NOT_USE__WebhookEventTypeWhereInput>>;
  /** category field predicates */
  category?: InputMaybe<Scalars['String']['input']>;
  categoryContains?: InputMaybe<Scalars['String']['input']>;
  categoryContainsFold?: InputMaybe<Scalars['String']['input']>;
  categoryEqualFold?: InputMaybe<Scalars['String']['input']>;
  categoryGT?: InputMaybe<Scalars['String']['input']>;
  categoryGTE?: InputMaybe<Scalars['String']['input']>;
  categoryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  categoryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  categoryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryLT?: InputMaybe<Scalars['String']['input']>;
  categoryLTE?: InputMaybe<Scalars['String']['input']>;
  categoryNEQ?: InputMaybe<Scalars['String']['input']>;
  categoryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deprecated_message field predicates */
  deprecatedMessage?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageContains?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageGT?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageGTE?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deprecatedMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedMessageLT?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageLTE?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  deprecatedMessageNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deprecatedMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayNameGT?: InputMaybe<Scalars['String']['input']>;
  displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameLT?: InputMaybe<Scalars['String']['input']>;
  displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  displayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** event_type field predicates */
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventTypeContains?: InputMaybe<Scalars['String']['input']>;
  eventTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventTypeGT?: InputMaybe<Scalars['String']['input']>;
  eventTypeGTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventTypeLT?: InputMaybe<Scalars['String']['input']>;
  eventTypeLTE?: InputMaybe<Scalars['String']['input']>;
  eventTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  eventTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sa_subscriptions edge predicates */
  hasSaSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSaSubscriptionsWith?: InputMaybe<Array<__SHOULD_NOT_USE__ServiceAccountWebhookSubscriptionWhereInput>>;
  /** subscriptions edge predicates */
  hasSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubscriptionsWith?: InputMaybe<Array<__SHOULD_NOT_USE__MerchantWebhookSubscriptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_deprecated field predicates */
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecatedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<__SHOULD_NOT_USE__WebhookEventTypeWhereInput>;
  or?: InputMaybe<Array<__SHOULD_NOT_USE__WebhookEventTypeWhereInput>>;
  /** replaces_event_type field predicates */
  replacesEventType?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeContains?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeGT?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeGTE?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  replacesEventTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  replacesEventTypeLT?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeLTE?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  replacesEventTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  replacesEventTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export const WebhookStatus = {
  Active: 'ACTIVE',
  Disabled: 'DISABLED',
  Paused: 'PAUSED'
} as const;

export type WebhookStatus = typeof WebhookStatus[keyof typeof WebhookStatus];